import React, { useEffect, useState } from "react";
import {
  Paper,
  Typography,
  IconButton,
  Button,
  RadioGroup,
  Radio,
  FormControlLabel,
  ListItemText,
  InputAdornment,
  Autocomplete,
  Snackbar,
  Alert,
  CircularProgress,
  Backdrop,
  Link,
  Avatar,
  FormLabel,
  Breadcrumbs,
  Checkbox,
} from "@mui/material";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { Slider } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Box } from "@mui/system";
import { MenuItem, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  LocalPrintshop,
  Preview,
  FilterListOff,
  FormatListBulleted,
  AddBox,
  Edit,
} from "@mui/icons-material";
import { AddPhotoAlternate } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import LinkIcon from "@mui/icons-material/Link";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import DoneIcon from "@mui/icons-material/Done";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import SelectField from "../../components/formElements/SelectField";
import TeaxtareaField from "../../components/formElements/TeaxtareaField";
import { useDispatch, useSelector } from "react-redux";
import { display, hide } from "../../redux/reducers/sidebar";
import LinktoRecipt from "../../components/modals/LinktoRecipt";
import Attachments from "../../components/modals/Attachments";
import EnterDenomination from "../../components/modals/EnterDenomination";
import AddUnitsModal from "../../components/modals/AddUnits";
import { useLocation } from "react-router-dom";
import { MoneyFormat } from "../../library/MoneyFormat";
import { API, graphqlOperation } from "aws-amplify";
import {
  getAccountBalance,
  getCodeTranslation,
  getCompany,
  listAccountGroupMaster,
  listHSN,
  searchHSN,
  listItemmasters,
  listPartymasters,
  listPartyInvoices,
  getPartyAddressEntity,
  getItemmaster,
  getCrDrNoteMaster,
  getTransactionMaster,
} from "../../graphql/queries";
import DeleteEntries from "../../components/modals/DeleteEntries";
import {
  createCrDrNoteMaster,
  createCrDrNoteLineItems,
  createCrDrNoteLineNonItems,
  createCrDrNoteDetails,
  createCrDrAttachment,
  createCrDrNoteInvoices,
  createTransactionMaster,
  createTransactionDetails,
  updateTransactionMaster,
  updateCrDrNoteMaster,
  updateCrDrNoteInvoices,
  updateCrDrNoteDetails,
  deleteCrDrAttachment,
  updateCrDrNoteLineItems,
  updateCrDrNoteLineNonItems,
  deleteCrDrNoteInvoices,
  deleteCrDrNoteLineItems,
  deleteCrDrNoteLineNonItems,
  createPartyAddressEntity,
  updatePartyAddressEntity,
  deleteTransactionDetails,
} from "../../graphql/mutations";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import ConfirmCancel from "../../components/modals/confirmCancel";
import ItemsSwitchWarning from "../../components/modals/ItemsSwitchWarning";
import DeleteNonItems from "../../components/modals/DeleteNonItems";
import printJS from "print-js";
import PreviewGstCreditNote from "../../components/modals/PreviewGstCreditNote";
import PreviewNonGstCreditNote from "../../components/modals/PreviewNonGstCreditNote";
import DeleteNonGstEntryModal from "../../components/modals/DeleteNonGstEntryModal";
import GstApplicableSwitchModal from "../../components/modals/GstApplicableSwitchModal";
import EditCreditDeliveryAddress from "../../components/modals/EditCreditDeliveryAddress";
import EditCreditBillingAddress from "../../components/modals/EditCreditBillingAddress";
import { settingsClose } from "../../redux/reducers/companySkipSave";
import AddToAccount from "../../components/modals/AddToAccount";
import { useThemes } from "../../components/Theme/theme";
import { ToWords } from "to-words";
import moment from "moment";

const nonItemWiseHeader = [
  {
    id: "S. No",
    label: "S. No",
    minWidth: 40,
  },
  {
    id: "Ledger Account",
    label: "Ledger Account",
    minWidth: 140,
  },
  {
    id: "HSN/SAC Code",
    label: "HSN/SAC Code",
    minWidth: 100,
  },
  {
    id: "Description",
    label: "Description",
    minWidth: 100,
    align: "right",
  },
  {
    id: "Taxable Amount",
    label: "Taxable Amount (₹)",
    minWidth: 100,
    align: "right",
  },
  {
    id: "GST Rate",
    label: "GST Rate (%)",
    minWidth: 80,
    align: "right",
  },
  {
    id: "GST",
    label: "GST (₹)",
    minWidth: 80,
    align: "right",
  },
  {
    id: "GST Cess",
    label: "GST Cess (₹)",
    minWidth: 40,
    align: "right",
  },
  {
    id: "Net Amount",
    label: "Net Amount (₹)",
    minWidth: 40,
    align: "right",
  },
  {
    id: "action",
    label: "Action",
    minWidth: 80,
    align: "right",
  },
];

const itemWiseHeader = [
  {
    id: "S. No",
    label: "S. No",
    minWidth: 40,
  },
  {
    id: "Item Code",
    label: "Item Code",
    minWidth: 80,
    align: "right",
  },
  {
    id: "Item Name",
    label: "Item Name",
    minWidth: 80,
    align: "right",
  },

  {
    id: "HSN/SAC Code",
    label: "HSN/SAC Code",
    minWidth: 80,
    align: "right",
  },
  {
    id: "Qty",
    label: "Qty",
    minWidth: 40,
    align: "right",
  },
  {
    id: "Units",
    label: "Units",
    minWidth: 40,
    align: "right",
  },
  {
    id: "Rate",
    label: "Rate (₹)",
    minWidth: 50,
    align: "right",
  },
  {
    id: "Amount",
    label: "Amount (₹)",
    minWidth: 60,
    align: "right",
  },
  {
    id: "Discount",
    label: "Discount (₹)",
    minWidth: 60,
    align: "right",
  },
  {
    id: "Taxable Amount",
    label: "Taxable Amount (₹)",
    minWidth: 100,
    align: "right",
  },
  {
    id: "GST Rate",
    label: "GST Rate (%)",
    minWidth: 80,
    align: "right",
  },
  {
    id: "GST",
    label: "GST",
    minWidth: 80,
    align: "right",
  },
  {
    id: "GST Cess",
    label: "GST Cess (₹)",
    minWidth: 80,
    align: "right",
  },
  {
    id: "Net Amount",
    label: "Net Amount (₹)",
    minWidth: 80,
    align: "right",
  },
  {
    id: "action",
    label: "Action",
    minWidth: 80,
    align: "right",
  },
];

const headCell2 = [
  {
    id: "attachment",
    label: "Attachment Name",
  },
  {
    id: "browse",
    label: "Browse",
  },
  {
    id: "action",
    label: "Action",
  },
];
const nonGSTTableHeader = [
  {
    id: "S. No",
    label: "S. No",
    minWidth: 40,
  },
  {
    id: "Ledger Account",
    label: "Ledger Account",
    minWidth: 140,
  },
  {
    id: "Description",
    label: "Description",
    minWidth: 100,
    align: "right",
  },
  {
    id: "Amount",
    label: "Amount (₹)",
    minWidth: 40,
    align: "right",
  },
  {
    id: "action",
    label: "Action",
    minWidth: 80,
    align: "right",
  },
];
const accountsArr = {
  1: "Real",
  2: "Personal",
  3: "Nominal",
  10: "Company",
};

const nonaccountsArr = {
  1: "HDFC",
  2: "SBI",
  3: "ICIC",
  4: "Canara",
};
let today = new Date();
let yy = today.getFullYear();
let mm = today.getMonth() + 1;
let dd = today.getDate();

if (dd < 10) dd = "0" + dd;
if (mm < 10) mm = "0" + mm;

const todayDate = yy + "-" + mm + "-" + dd;

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#396afc",
    color: "#fff",
    boxShadow: theme.shadows[1],
    fontSize: 13,
    padding: "10px 20px",
  },
}));

function AddRecurringInvoice({ handleClose, ModalCloseEvent, ModalEvent }) {
  const dispatch = useDispatch();
  dispatch(display());
  const { theme } = useThemes();

  let location = useLocation();
  let params = location.state;

  const navigate = useNavigate();

  const toWords = new ToWords();

  let randomNum = Math.floor(Math.random() * 100 + 1);
  let timeStamp = Math.floor(new Date().getTime() / 1000);
  let randomNumber = randomNum + timeStamp.toString().slice(3, 10);

  const [unitModal, setUnitModal] = useState(false);
  const [itemEntry, setItemEntry] = useState(true);
  const [linktoReciptModal, setLinktoReciptModal] = useState(false);
  const [attachmentModal, setAttachmentModal] = useState(false);
  const [denominationModal, setDenominationModal] = useState(false);
  const [suppliers, setSupplires] = useState([]);
  const [itemsName, SetItemsName] = useState([]);
  const [itemsCode, SetItemsCode] = useState([]);
  const [HSNCodes, SetHSNCOdes] = useState([]);
  const [filterHSN, setFilterHSN] = useState([]);
  const [units, setunits] = useState([]);
  const [creditPeriod, setCreditPeriod] = useState("");
  const [allItemData, setAllItemData] = useState([]);
  const [warningMessage, setWarningMessage] = useState("");
  const [completeSnackbar, setCompleteSnakbar] = useState(false);
  const [entrySnakbar, setEntrySnakbar] = useState(false);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [deleteEntriesModal, setDeleteEntriesModal] = useState(false);
  const [deleteNonGSTEntriesModal, setDeleteNonGSTEntriesModal] =
    useState(false);
  const [deleteNonEntriesModal, setDeleteNonEntriesModal] = useState(false);
  const [successSnackbar, setsuccessSnakbar] = useState(false);
  const [snakbarText, setSnakbarTex] = useState("");
  const [entryIndex, setEntryIndex] = useState("");
  const [nonGSTentryIndex, setNonGSTEntryIndex] = useState("");
  const [nonEntryIndex, setNonEntryIndex] = useState("");
  const [states, SetCountrySTates] = useState("");
  const [imageName, setImageName] = useState("");
  const [uploadedFile, setUploadedFile] = useState();
  const [cancelModal, setCancelModal] = useState(false);
  const [totAmount, setTotAmount] = useState(0);
  const [totDiscount, setTotDiscount] = useState(0);
  const [totTaxableAmount, setTotTaxableAmount] = useState(0);
  const [totGstCess, setTotGstCess] = useState(0);
  const [totNetAmount, setTotNetAmount] = useState(0);
  const [totNonGstNetAmount, setNonGstTotNetAmount] = useState(0);
  const [totGST, setTotGST] = useState(0);
  const [itemsWrningModal, setItemsWarningModal] = useState(false);
  const [warningText, setWarningText] = useState("");
  const [switchedTo, setSwitchedTo] = useState("");
  const [accName, setAccName] = useState([]);
  const [accountsObj, setAccountsObj] = useState({});
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [companyDetails, setCOmpanyDetails] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [partyID, setPartyID] = useState("");
  const [invPartyId, setInvPartyId] = useState("");
  const [supplierNameEnabled, setSupplierNameEnabled] = useState(true);
  const [previewGstCreditNoteModal, setPreviewGstCreditNoteModal] =
    useState(false);
  const [previewNonGstCreditNoteModal, setPreviewNonGstCreditNoteModal] =
    useState(false);
  const [paidAccountName, setPaidAccountName] = useState("");
  const [bankAccount, setBankAccount] = useState([]);
  const [cashAccount, setCashAccount] = useState([]);
  const [selectedGroupId, setSelectedAccountGroupId] = useState("");
  const [accountBalance, setAccountBalance] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [changeAddressModal, setChangeAddressModal] = useState(false);
  const [gstFlag, setGstFlag] = useState("");
  const [creditNoteNumber, setCreditNoteNumber] = useState("");
  const [ItemId, setItemId] = useState("");
  const [itemModal, setItemModal] = useState(false);
  const [additemModal, setAddItemModal] = useState(false);
  const [itemType, setItemType] = useState("");
  const [gstWarningModal, setGstWarningModal] = useState(false);
  const [companyLogo, setCompanyLogo] = useState("");
  const [partyMasters, setPartyMasters] = useState([]);
  const [transId, setTransId] = useState("");
  const [CrDrId, setCrDrId] = useState("");
  const [invoiceDetails, setinvoiceDetails] = useState([]);
  const [journalItems, setJournalItems] = useState([]);
  const [journalNonItems, setJournalNonItems] = useState([]);
  const [journalNonGstItems, setJournalNonGstItems] = useState([]);
  const [billingAddressModal, setBillingAddressModal] = useState(false);
  const [partyAddressEntity, setPartyAddressEntity] = useState("");
  const [partyBillAddressEntity, setPartyBillAddressEntity] = useState("");
  const [stateArr, setStateArr] = useState([]);
  const [countryArr, setCountryArr] = useState([]);
  const [districtArr, setDistrictArr] = useState([]);
  const [stateName, setStateName] = useState("");
  const [districtName, setDistrictName] = useState("");
  const [countryName, setCountryName] = useState("");
  const [stateDelName, setStateDelName] = useState("");
  const [districtDelName, setDistrictDelName] = useState("");
  const [countryDelName, setCountryDelName] = useState("");
  const [tabelTotAmount, setTableTotAmount] = useState(0);
  let totalAmount = 0;
  let totalTaxableAmount = 0;
  let totalGstCess = 0;
  let totalNetAmount = 0;
  let totDicount = 0;
  let tableTotalAmount = 0;
  const [toAccountModal, setToAccountModal] = useState(false);
  const [warningSnakbar, setWarningSnakbar] = useState(false);
  const [paidAccountFlag, setPaidAccountFlag] = useState(false);
  const [currentItemCode, setCurrentItemCode] = useState("");
  const [nonGstItems, setNonGstItems] = useState([
    {
      ledgerAccount: { label: "", value: "" },
      description: "",
      amount: 0,
      editable: true,
      new: true,
    },
  ]);
  const [nonGstItemEditedRow, setNonGstItemEditedRow] = useState({
    ledgerAccount: { label: "", value: "" },
    description: "",
    amount: 0,
    editable: true,
    new: true,
  });
  const [nonGstItemTempRow, setNonGstItemTempRow] = useState({
    ledgerAccount: { label: "", value: "" },
    description: "",
    amount: 0,
    editable: true,
    new: true,
  });
  const [items, setItems] = useState([
    {
      itemCode: { label: "", value: "" },
      name: { label: "", value: "" },
      purchaseAccount: { label: "", value: "" },
      HSN: { label: "", value: "" },
      qty: 1,
      units: "",
      rate: 0,
      amount: 0,
      dicount: 0,
      taxableAMount: 0,
      GSTRate: "",
      IGST: "0.00",
      CGST: "0.00",
      SGST: "0.00",
      GSTCess: 0,
      netAmount: "0000",
      editable: true,
      new: true,
    },
  ]);
  const [itemEditedRow, setItemEditedRow] = useState({
    itemCode: { label: "", value: "" },
    name: { label: "", value: "" },
    purchaseAccount: { label: "", value: "" },
    HSN: { label: "", value: "" },
    qty: 1,
    units: "",
    rate: 0,
    amount: 0,
    dicount: 0,
    taxableAMount: 0,
    GSTRate: "",
    IGST: "0.00",
    CGST: "0.00",
    SGST: "0.00",
    GSTCess: 0,
    netAmount: 0,
    editable: true,
    new: true,
  });
  const [itemTempRow, setItemTempRow] = useState({
    itemCode: { label: "", value: "" },
    name: { label: "", value: "" },
    purchaseAccount: { label: "", value: "" },
    HSN: { label: "", value: "" },
    qty: 1,
    units: "",
    rate: 0,
    amount: 0,
    dicount: 0,
    taxableAMount: 0,
    GSTRate: "",
    IGST: "0.00",
    CGST: "0.00",
    SGST: "0.00",
    GSTCess: 0,
    netAmount: "0000",
    editable: true,
    new: true,
  });
  const [nonItems, setNonItems] = useState([
    {
      ledgerAccount: { label: "", value: "" },
      HSN: { label: "", value: "" },
      description: "",
      taxAMount: 0,
      GSTRate: "0",
      IGST: "0.00",
      CGST: "0.00",
      SGST: "0.00",
      GSTCess: 0,
      netAmount: 0,
      editable: true,
      new: true,
    },
  ]);
  const [nonItemEditedRow, setNonItemEditedRow] = useState({
    ledgerAccount: { label: "", value: "" },
    HSN: { label: "", value: "" },
    description: "",
    taxAMount: 0,
    GSTRate: "0",
    IGST: "0.00",
    CGST: "0.00",
    SGST: "0.00",
    GSTCess: 0,
    netAmount: 0,
    editable: true,
    new: true,
  });
  const [nonItemTempRow, setNonItemTempRow] = useState({
    ledgerAccount: { label: "", value: "" },
    HSN: { label: "", value: "" },
    description: "",
    taxAMount: 0,
    GSTRate: "0",
    IGST: "0.00",
    CGST: "0.00",
    SGST: "0.00",
    GSTCess: 0,
    netAmount: 0,
    editable: true,
    new: true,
  });

  const AccountTypes = [
    { option: "IGST Input A/c", value: "1" },
    { option: "IGST Output A/c", value: "2" },
    { option: "GST Payable A/c", value: "3" },
  ];

  const [data, setData] = useState({
    gstApplicable: "1",
    purchaseOrSalseFlag: "1",
    partyName: { label: "", value: "" },
    billingAddress: "",
    deliveryAddress: "",
    creditNoteDate: todayDate,
    creditNote: "",
    originalInvoiceNumber: [],
    originalInvoiceDate: "",
    paymentType: "Credit",
    recordAmount: "",
    creditToAccount: { label: "", value: "" },
    attachments: "",
    transpotationMode: "",
    vehicleNumber: "",
    dateOfDispatch: todayDate,
    eWayBill: "",
    bankRefNo: "",
    vouchernumber: randomNumber,
    entryDate: todayDate,
    invoiceDate: todayDate,
    invoiceNumber: "",
    supplierName: { label: "", value: "" },
    supplier: "",
    paidAmount: "",
    paidAccount: "",
    creditPeriod: 0,
    dueDate: "",
    tdsFlag: "",
    tdsOptions: "",
    tdsAmount: "",
    adjustments: "",
    ineligibleITCFlag: "",
    reverseChargeFlag: 0,
    remarks: "",
    placeOfSupply: "",
    address: "",
    gstin: "",
    invoiceEndDate: "",
    invoiceStartDate: "",
    periodicity: "",
    errorStatus: {
      gstApplicable: false,
      purchaseOrSalseFlag: false,
      partyName: false,
      billingAddress: false,
      deliveryAddress: false,
      creditNoteDate: false,
      creditNote: false,
      originalInvoiceNumber: false,
      originalInvoiceDate: false,
      paymentType: false,
      recordAmount: false,
      creditToAccount: false,
      attachments: false,
      transpotationMode: false,
      vehicleNumber: false,
      dateOfDispatch: false,
      eWayBill: false,
      bankRefNo: false,
      vouchernumber: false,
      entryDate: false,
      invoiceDate: false,
      invoiceNumber: false,
      supplierName: false,
      paymentType: false,
      paidAmount: false,
      paidAccount: false,
      creditPeriod: false,
      dueDate: false,
      tdsFlag: false,
      tdsOptions: false,
      tdsAmount: false,
      adjustments: false,
      ineligibleITCFlag: false,
      reverseChargeFlag: false,
      remarks: false,
      placeOfSupply: false,
      address: false,
      gstin: false,
      invoiceEndDate: false,
      invoiceStartDate: false,
      periodicity: false,
    },
    errorFields: {
      gstApplicable: "",
      purchaseOrSalseFlag: "",
      partyName: "",
      billingAddress: "",
      deliveryAddress: "",
      creditNoteDate: "",
      creditNote: "",
      originalInvoiceNumber: "",
      originalInvoiceDate: "",
      paymentType: "",
      recordAmount: "",
      creditToAccount: "",
      attachments: "",
      transpotationMode: "",
      vehicleNumber: "",
      dateOfDispatch: "",
      eWayBill: "",
      bankRefNo: "",
      vouchernumber: "",
      entryDate: "",
      invoiceDate: "",
      invoiceNumber: "",
      supplierName: "",
      paidAmount: "",
      paidAccount: "",
      creditPeriod: "",
      dueDate: "",
      tdsFlag: "",
      tdsOptions: "",
      tdsAmount: "",
      adjustments: "",
      ineligibleITCFlag: "",
      reverseChargeFlag: "",
      remarks: "",
      placeOfSupply: "",
      address: "",
      gstin: "",
      invoiceEndDate: "",
      invoiceStartDate: "",
      periodicity: "",
    },
  });
  const [deliveryAddressDetails, setDeliveryAddressDetails] = useState({
    deliveryAddress: "",
    states: "",
    district: "",
    country: "",
    pincode: "",
    stateCD: "",
    countryCD: "",

    errorStatus: {
      deliveryAddress: false,
      states: false,
      district: false,
      country: false,
      pincode: false,
    },
    errorFields: {
      deliveryAddress: "",
      states: "",
      district: "",
      country: "",
      pincode: "",
    },
  });
  const [billingAddressDetails, setBillingAddressDetails] = useState({
    billingAddress: "",
    states: "",
    district: "",
    country: "",
    pincode: "",
    stateCD: "",
    countryCD: "",

    errorStatus: {
      billingAddress: false,
      states: false,
      district: false,
      country: false,
      pincode: false,
    },
    errorFields: {
      billingAddress: "",
      states: "",
      district: "",
      country: "",
      pincode: "",
    },
  });
  const defaultProps = {
    options: itemsName,
  };
  const { saveSkipStatus } = useSelector(
    (state) => state.companySipSaveReducer
  );
  useEffect(() => {
    if (saveSkipStatus == false) {
      dispatch(settingsClose());
      navigate("/companysetup");
    }
  }, []);
  async function displayBalance(id) {
    try {
      if (id) {
        const res = await API.graphql(
          graphqlOperation(getAccountBalance, { AccountID: id })
        );
        if (res.data.getAccountBalance !== null) {
          setAccountBalance(res.data.getAccountBalance.AccountBalance);
        }
        if (res.data.getAccountBalance === null) setAccountBalance(0);
      } else setAccountBalance(0);
    } catch (error) {
      console.log(error);
      setAccountBalance(0);
    }
  }

  useEffect(() => {
    totalAmount = 0;
    totDicount = 0;
    totalTaxableAmount = 0;
    totalGstCess = 0;
    totalNetAmount = 0;
    let totalGST = 0;
    tableTotalAmount = 0;
    items.map((col) => {
      totalAmount += Number(col.rate).toFixed(2) * Number(col.qty).toFixed(2);
      totDicount += Number(col.dicount);
      totalTaxableAmount +=
        Number(col.qty) * Number(col.rate) - Number(col.dicount);
      totalGstCess += Number(col.GSTCess);
      // totalNetAmount += Number(col.netAmount);
      if (data.reverseChargeFlag == 0) {
        if (data.placeOfSupply == "KeralaDistrict") {
          totalNetAmount +=
            Number(col.rate) * Number(col.qty) -
            Number(col.dicount) +
            ((Number(col.taxableAMount) * Number(col.GSTRate / 100)) / 2 +
              (Number(col.taxableAMount) * Number(col.GSTRate / 100)) / 2) +
            Number(col.GSTCess);
        } else {
          totalNetAmount +=
            Number(col.rate) * Number(col.qty) -
            Number(col.dicount) +
            Number(col.taxableAMount) * Number(col.GSTRate / 100) +
            Number(col.GSTCess);
        }
      } else {
        totalNetAmount +=
          Number(col.rate) * Number(col.qty) - Number(col.dicount);
      }
      if (data.placeOfSupply == "KeralaDistrict") {
        totalGST +=
          (Number(col.taxableAMount) * Number(col.GSTRate / 100)) / 2 +
          (Number(col.taxableAMount) * Number(col.GSTRate / 100)) / 2;
      } else {
        totalGST += Number(col.taxableAMount) * Number(col.GSTRate / 100);
      }
      if (data.placeOfSupply == "KeralaDistrict") {
        tableTotalAmount +=
          Number(col.rate) * Number(col.qty) -
          Number(col.dicount) +
          ((Number(col.taxableAMount) * Number(col.GSTRate / 100)) / 2 +
            (Number(col.taxableAMount) * Number(col.GSTRate / 100)) / 2) +
          Number(col.GSTCess);
      } else {
        tableTotalAmount +=
          Number(col.rate) * Number(col.qty) -
          Number(col.dicount) +
          Number(col.taxableAMount) * Number(col.GSTRate / 100) +
          Number(col.GSTCess);
      }
    });
    setTotDiscount(totDicount);
    setTotAmount(totalAmount);
    setTotTaxableAmount(totalTaxableAmount);
    setTotGstCess(totalGstCess);
    setTotNetAmount(totalNetAmount);
    setTotGST(totalGST);
    setTableTotAmount(tableTotalAmount);
  }, [items, data.reverseChargeFlag]);

  useEffect(() => {
    totalAmount = 0;
    totalTaxableAmount = 0;
    totalGstCess = 0;
    totalNetAmount = 0;
    let totalGST = 0;
    nonItems.map((col) => {
      // totalAmount += Number(col?.amount)
      totalTaxableAmount += Number(col.taxAMount);
      totalGstCess += Number(col.GSTCess);
      totalNetAmount += Number(col.netAmount);
      if (data.placeOfSupply == "KeralaDistrict") {
        totalGST +=
          (Number(col.taxAMount) * Number(col.GSTRate / 100)) / 2 +
          (Number(col.taxAMount) * Number(col.GSTRate / 100)) / 2;
      } else {
        totalGST += Number(col.taxAMount) * Number(col.GSTRate / 100);
      }
    });

    setTotAmount(totalAmount);
    setTotTaxableAmount(totalTaxableAmount);
    setTotGstCess(totalGstCess);
    setTotNetAmount(totalNetAmount);
    setTotGST(totalGST);
  }, [nonItems]);
  useEffect(() => {
    let totalNonGstNetAmount = 0;
    nonGstItems.map((col) => {
      // totalAmount += Number(col?.amount)
      totalNonGstNetAmount += Number(col.amount);
    });

    setNonGstTotNetAmount(totalNonGstNetAmount);
  }, [nonGstItems]);
  function handleChange(e) {
    const name = e.target.name;
    setData((prev) => ({
      ...prev,
      [name]: e.target.value,
    }));
  }

  useEffect(() => {
    totalAmount = 0;
    totalTaxableAmount = 0;
    totalGstCess = 0;
    totalNetAmount = 0;
    let totalGST = 0;
    nonItems.map((col) => {
      // totalAmount += Number(col?.amount)
      totalTaxableAmount += Number(col.taxAMount);
      totalGstCess += Number(col.GSTCess);
      totalNetAmount += Number(col.netAmount);
      if (data.placeOfSupply == "KeralaDistrict") {
        totalGST +=
          (Number(col.taxAMount) * Number(col.GSTRate / 100)) / 2 +
          (Number(col.taxAMount) * Number(col.GSTRate / 100)) / 2;
      } else {
        totalGST += Number(col.taxAMount) * Number(col.GSTRate / 100);
      }
    });

    setTotAmount(totalAmount);
    setTotTaxableAmount(totalTaxableAmount);
    setTotGstCess(totalGstCess);
    setTotNetAmount(totalNetAmount);
    setTotGST(totalGST);
  }, [nonItems]);
  useEffect(() => {
    let obj = { ...itemEditedRow };
    let grandTotal = "";
    if (Object.keys(obj).length > 0) {
      if (itemEditedRow?.taxableAMount !== "") {
        if (itemEditedRow?.GSTCess !== "") {
          grandTotal =
            Number(itemEditedRow?.taxableAMount) +
            Number(itemEditedRow?.GSTCess) +
            Number(
              Number(itemEditedRow.taxableAMount) *
                Number(itemEditedRow.GSTRate / 100)
            );
        } else {
          grandTotal =
            Number(itemEditedRow?.taxableAMount) +
            Number(
              Number(itemEditedRow.taxableAMount) *
                Number(itemEditedRow.GSTRate / 100)
            );
        }
      } else {
        grandTotal = "";
      }

      obj.netAmount = grandTotal;
      setItemEditedRow(obj);
    }
  }, [itemEditedRow?.taxableAMount]);
  useEffect(() => {
    let obj = { ...itemEditedRow };
    let grandTotal = "";
    if (Object.keys(obj).length > 0) {
      if (itemEditedRow?.taxableAMount !== "") {
        if (data.placeOfSupply == "KeralaDistrict") {
          grandTotal =
            Number(itemEditedRow?.taxableAMount) +
            ((Number(itemEditedRow.taxableAMount) *
              Number(itemEditedRow.GSTRate / 100)) /
              2 +
              (Number(itemEditedRow.taxableAMount) *
                Number(itemEditedRow.GSTRate / 100)) /
                2);
        } else {
          grandTotal =
            Number(itemEditedRow?.taxableAMount) +
            Number(itemEditedRow.taxableAMount) *
              Number(itemEditedRow.GSTRate / 100);
        }
      } else {
        grandTotal = "";
      }

      obj.netAmount = grandTotal;
      setItemEditedRow(obj);
    }
  }, [itemEditedRow.GSTRate]);

  useEffect(() => {
    let obj = { ...itemEditedRow };
    let grandTotal = "";
    if (Object.keys(obj).length > 0) {
      if (itemEditedRow?.taxableAMount !== "") {
        if (itemEditedRow?.GSTCess !== "") {
          grandTotal =
            Number(itemEditedRow?.taxableAMount) +
            Number(itemEditedRow?.GSTCess) +
            Number(
              Number(itemEditedRow.taxableAMount) *
                Number(itemEditedRow.GSTRate / 100)
            );
        } else {
          grandTotal =
            Number(itemEditedRow?.taxableAMount) +
            Number(
              Number(itemEditedRow.taxableAMount) *
                Number(itemEditedRow.GSTRate / 100)
            );
        }
      } else {
        grandTotal = "";
      }

      obj.netAmount = grandTotal;
      setItemEditedRow(obj);
    }
  }, [itemEditedRow?.GSTCess]);
  useEffect(() => {
    let obj = { ...nonItemEditedRow };
    let grandTotal = "";
    if (Object.keys(obj).length > 0) {
      if (nonItemEditedRow?.taxAMount !== "") {
        if (nonItemEditedRow?.GSTCess !== "") {
          grandTotal =
            Number(nonItemEditedRow?.taxAMount) +
            Number(nonItemEditedRow?.GSTCess) +
            Number(
              Number(nonItemEditedRow.taxAMount) *
                Number(nonItemEditedRow.GSTRate / 100)
            );
        } else {
          grandTotal =
            Number(nonItemEditedRow?.taxAMount) +
            Number(
              Number(nonItemEditedRow.taxAMount) *
                Number(nonItemEditedRow.GSTRate / 100)
            );
        }
      } else {
        grandTotal = "";
      }

      obj.netAmount = grandTotal;
      setNonItemEditedRow(obj);
    }
  }, [nonItemEditedRow?.taxAMount]);
  useEffect(() => {
    let obj = { ...nonItemEditedRow };
    let grandTotal = "";
    if (Object.keys(obj).length > 0) {
      if (nonItemEditedRow?.taxAMount !== "") {
        if (data.placeOfSupply == "KeralaDistrict") {
          grandTotal =
            Number(nonItemEditedRow?.taxAMount) +
            ((Number(nonItemEditedRow.taxAMount) *
              Number(nonItemEditedRow.GSTRate / 100)) /
              2 +
              (Number(nonItemEditedRow.taxAMount) *
                Number(nonItemEditedRow.GSTRate / 100)) /
                2);
        } else {
          grandTotal =
            Number(nonItemEditedRow?.taxAMount) +
            Number(nonItemEditedRow.taxAMount) *
              Number(nonItemEditedRow.GSTRate / 100);
        }
      } else {
        grandTotal = "";
      }

      obj.netAmount = grandTotal;
      setNonItemEditedRow(obj);
    }
  }, [nonItemEditedRow.GSTRate]);

  useEffect(() => {
    let obj = { ...nonItemEditedRow };
    let grandTotal = "";
    if (Object.keys(obj).length > 0) {
      if (nonItemEditedRow?.taxAMount !== "") {
        if (nonItemEditedRow?.GSTCess !== "") {
          grandTotal =
            Number(nonItemEditedRow?.taxAMount) +
            Number(nonItemEditedRow?.GSTCess) +
            Number(
              Number(nonItemEditedRow.taxAMount) *
                Number(nonItemEditedRow.GSTRate / 100)
            );
        } else {
          grandTotal =
            Number(nonItemEditedRow?.taxAMount) +
            Number(
              Number(nonItemEditedRow.taxAMount) *
                Number(nonItemEditedRow.GSTRate / 100)
            );
        }
      } else {
        grandTotal = "";
      }

      obj.netAmount = grandTotal;
      setNonItemEditedRow(obj);
    }
  }, [nonItemEditedRow?.GSTCess]);

  function nonitemsHandleChange(e, ind) {
    const name = e.target.name;
    let arr = [...nonItems];
    arr[ind][name] = e.target.value;
    setNonItems(arr);
  }

  const [itemsRows, setItemsRows] = useState([
    // { slNo: '', name: '', action: '' }
  ]);
  useEffect(() => {
    //console.log("uploadedFile :::: ", uploadedFile)
    if (uploadedFile) {
      if (
        uploadedFile?.type == "image/jpeg" ||
        uploadedFile?.type == "image/jpg"
      ) {
        setBackdropOpen(true);
        setData((prev) => ({
          ...prev,
          attachments: uploadedFile?.name,
          errorFields: {
            ...prev.errorFields,
            attachments: "",
          },
          errorStatus: {
            ...prev.errorStatus,
            attachments: false,
          },
        }));
        try {
          let data = "";
          let config = {
            method: "post",
            url: `https://xd8ts5ub3e.execute-api.us-east-1.amazonaws.com/Prod/api/PreSigned/PreSignedUrl?filename=${uploadedFile.name}&contentType=image/jpeg`,
            headers: {},
            data: data,
          };

          axios(config)
            .then(function (response) {
              //console.log('res :::: ', response.data);
              let config2 = {
                method: "put",
                url: response.data,
                headers: {
                  "Content-Type": "image/jpeg",
                },
                data: uploadedFile,
              };

              axios(config2)
                .then(function (res) {
                  setImageName(uploadedFile.name);
                  setBackdropOpen(false);
                  //console.log('res in upload :::: ', JSON.stringify(res.data));
                })
                .catch(function (error) {
                  setBackdropOpen(false);
                  console.log("error in upload ::: ", error);
                });
            })
            .catch(function (error) {
              setBackdropOpen(false);
              console.log("errr ::: ", error);
            });
        } catch (e) {
          console.log("error ::: ", e);
        }
      } else {
        setData((prev) => ({
          ...prev,
          attachments: uploadedFile?.name,
          errorFields: {
            ...prev.errorFields,
            attachments: "Only jpg,jpeg extensions Files  are allowed",
          },
          errorStatus: {
            ...prev.errorStatus,
            attachments: true,
          },
        }));
      }
      //console.log('file name isisisi ::::: ', uploadedFile.name)
    }
  }, [uploadedFile]);
  function nonGstNewRow() {
    if (nonGstItems.length > 0) {
      if (Object.keys(nonGstItemEditedRow).length === 0) {
        setNonGstItems((prev) => [
          ...prev,
          {
            ledgerAccount: { label: "", value: "" },
            description: "",
            amount: "",
            editable: true,
            new: true,
          },
        ]);
        setNonGstItemEditedRow((prev) => ({
          ledgerAccount: { label: "", value: "" },
          description: "",
          amount: "",
          editable: true,
          new: true,
        }));
        setNonGstItemTempRow((prev) => ({
          ledgerAccount: { label: "", value: "" },
          description: "",
          amount: "",
          editable: true,
          new: true,
        }));
      }
    } else {
      setNonGstItems((prev) => [
        ...prev,
        {
          ledgerAccount: { label: "", value: "" },
          description: "",
          amount: "",
          editable: true,
          new: true,
        },
      ]);
      setNonGstItemEditedRow((prev) => ({
        ledgerAccount: { label: "", value: "" },
        description: "",
        amount: "",
        editable: true,
        new: true,
      }));
      setNonGstItemTempRow((prev) => ({
        ledgerAccount: { label: "", value: "" },
        description: "",
        amount: "",
        editable: true,
        new: true,
      }));
    }
  }
  function itemWiseNewRow() {
    // console.log(itemEditedRow);
    if (items.length > 0) {
      if (Object.keys(itemEditedRow).length === 0) {
        setItems((prev) => [
          ...prev,
          {
            itemCode: { label: "", value: "" },
            name: { label: "", value: "" },
            purchaseAccount: { label: "", value: "" },
            HSN: { label: "", value: "" },
            qty: 1,
            units: "",
            rate: 0,
            amount: 0,
            dicount: 0,
            taxableAMount: 0,
            GSTRate: "",
            IGST: "0.00",
            CGST: "0.00",
            SGST: "0.00",
            GSTCess: 0,
            netAmount: 0,
            editable: true,
            new: true,
          },
        ]);

        setItemEditedRow({
          itemCode: { label: "", value: "" },
          name: { label: "", value: "" },
          purchaseAccount: { label: "", value: "" },
          HSN: { label: "", value: "" },
          qty: 1,
          units: "",
          rate: 0,
          amount: 0,
          dicount: 0,
          taxableAMount: 0,
          GSTRate: "",
          IGST: "0.00",
          CGST: "0.00",
          SGST: "0.00",
          GSTCess: 0,
          netAmount: 0,
          editable: true,
          new: true,
        });
        setItemTempRow({
          itemCode: { label: "", value: "" },
          name: { label: "", value: "" },
          purchaseAccount: { label: "", value: "" },
          HSN: { label: "", value: "" },
          qty: 1,
          units: "",
          rate: 0,
          amount: 0,
          dicount: 0,
          taxableAMount: 0,
          GSTRate: "",
          IGST: "0.00",
          CGST: "0.00",
          SGST: "0.00",
          GSTCess: 0,
          netAmount: 0,
          editable: true,
          new: true,
        });
      }
    } else {
      setItems((prev) => [
        ...prev,
        {
          itemCode: { label: "", value: "" },
          name: { label: "", value: "" },
          purchaseAccount: { label: "", value: "" },
          HSN: { label: "", value: "" },
          qty: 1,
          units: "",
          rate: 0,
          amount: 0,
          dicount: 0,
          taxableAMount: 0,
          GSTRate: "",
          IGST: "0.00",
          CGST: "0.00",
          SGST: "0.00",
          GSTCess: 0,
          netAmount: 0,
          editable: true,
          new: true,
        },
      ]);

      setItemEditedRow({
        itemCode: { label: "", value: "" },
        name: { label: "", value: "" },
        purchaseAccount: { label: "", value: "" },
        HSN: { label: "", value: "" },
        qty: 1,
        units: "",
        rate: 0,
        amount: 0,
        dicount: 0,
        taxableAMount: 0,
        GSTRate: "",
        IGST: "0.00",
        CGST: "0.00",
        SGST: "0.00",
        GSTCess: 0,
        netAmount: 0,
        editable: true,
        new: true,
      });
      setItemTempRow({
        itemCode: { label: "", value: "" },
        name: { label: "", value: "" },
        purchaseAccount: { label: "", value: "" },
        HSN: { label: "", value: "" },
        qty: 1,
        units: "",
        rate: 0,
        amount: 0,
        dicount: 0,
        taxableAMount: 0,
        GSTRate: "",
        IGST: "0.00",
        CGST: "0.00",
        SGST: "0.00",
        GSTCess: 0,
        netAmount: 0,
        editable: true,
        new: true,
      });
    }
  }

  function nonItemWiseNewRow() {
    if (nonItems.length > 0) {
      if (Object.keys(nonItemEditedRow).length === 0) {
        setNonItems((prev) => [
          ...prev,
          {
            ledgerAccount: { label: "", value: "" },
            HSN: { label: "", value: "" },
            description: "",
            taxAMount: 0,
            GSTRate: "0",
            IGST: "0.00",
            CGST: "0.00",
            SGST: "0.00",
            GSTCess: 0,
            netAmount: 0,
            editable: true,
            new: true,
          },
        ]);
        setNonItemEditedRow({
          ledgerAccount: { label: "", value: "" },
          HSN: { label: "", value: "" },
          description: "",
          taxAMount: 0,
          GSTRate: "0",
          IGST: "0.00",
          CGST: "0.00",
          SGST: "0.00",
          GSTCess: 0,
          netAmount: 0,
          editable: true,
          new: true,
        });
        setNonItemTempRow({
          ledgerAccount: { label: "", value: "" },
          HSN: { label: "", value: "" },
          description: "",
          taxAMount: 0,
          GSTRate: "0",
          IGST: "0.00",
          CGST: "0.00",
          SGST: "0.00",
          GSTCess: 0,
          netAmount: 0,
          editable: true,
          new: true,
        });
      }
    } else {
      setNonItems((prev) => [
        ...prev,
        {
          ledgerAccount: { label: "", value: "" },
          HSN: { label: "", value: "" },
          description: "",
          taxAMount: 0,
          GSTRate: "0",
          IGST: "0.00",
          CGST: "0.00",
          SGST: "0.00",
          GSTCess: 0,
          netAmount: 0,
          editable: true,
          new: true,
        },
      ]);
      setNonItemEditedRow({
        ledgerAccount: { label: "", value: "" },
        HSN: { label: "", value: "" },
        description: "",
        taxAMount: 0,
        GSTRate: "0",
        IGST: "0.00",
        CGST: "0.00",
        SGST: "0.00",
        GSTCess: 0,
        netAmount: 0,
        editable: true,
        new: true,
      });
      setNonItemTempRow({
        ledgerAccount: { label: "", value: "" },
        HSN: { label: "", value: "" },
        description: "",
        taxAMount: 0,
        GSTRate: "0",
        IGST: "0.00",
        CGST: "0.00",
        SGST: "0.00",
        GSTCess: 0,
        netAmount: 0,
        editable: true,
        new: true,
      });
    }
  }

  function NewRowFile() {
    if (itemsRows.length > 0) {
      let arr = [...itemsRows];

      if (arr[itemsRows.length - 1].url !== "") {
        setItemsRows((prev) => [
          ...prev,
          { slNo: "", name: "", action: "", url: "" },
        ]);
      } else {
        setCompleteSnakbar(true);
        setWarningMessage("Please Select a File in Attachment Table");
      }
    } else {
      setItemsRows((prev) => [
        ...prev,
        { slNo: "", name: "", action: "", url: "" },
      ]);
    }
  }
  async function getPartyAddressEntityDetails(data) {
    const resPartyAddressEntityDetails = await API.graphql(
      graphqlOperation(getPartyAddressEntity, {
        ObjectID: data,
        ObjectType: "PartyDelivery",
      })
    );
    let partyAddressEntityData =
      resPartyAddressEntityDetails.data.getPartyAddressEntity;
    setPartyAddressEntity(partyAddressEntityData);
    if (partyAddressEntityData !== null) {
      setData((prev) => ({
        ...prev,
        deliveryAddress: partyAddressEntityData?.Line1,
        // billingAddress: partyAddressEntityData?.Line1,
      }));
      let nameOfState = "";
      stateArr.map((ele) => {
        if (
          ele.value ==
          resPartyAddressEntityDetails.data.getPartyAddressEntity.StateCode
        )
          nameOfState = ele.option;
      });
      setStateDelName(nameOfState);
      let nameOfDistrict = "";
      districtArr.map((ele) => {
        if (
          ele.value ==
          resPartyAddressEntityDetails.data.getPartyAddressEntity.City
        )
          nameOfDistrict = ele.option;
      });
      setDistrictDelName(nameOfDistrict);
      let nameOfCountry = "";
      countryArr.map((ele) => {
        if (
          ele.value ==
          resPartyAddressEntityDetails.data.getPartyAddressEntity.CountryCode
        )
          nameOfCountry = ele.option;
      });
      setCountryDelName(nameOfCountry);
    } else {
      setData((prev) => ({
        ...prev,
        deliveryAddress: "",
        billingAddress: "",
      }));
    }
  }
  async function getPartyBillAddressEntityDetails(data) {
    const resPartyAddressEntityDetails = await API.graphql(
      graphqlOperation(getPartyAddressEntity, {
        ObjectID: data,
        ObjectType: "PartyBilling",
      })
    );
    let partyAddressEntityData =
      resPartyAddressEntityDetails.data.getPartyAddressEntity;
    setPartyBillAddressEntity(partyAddressEntityData);
    if (partyAddressEntityData !== null) {
      setData((prev) => ({
        ...prev,
        // deliveryAddress: partyAddressEntityData?.Line1,
        billingAddress: partyAddressEntityData?.Line1,
      }));
      let nameOfState = "";
      stateArr.map((ele) => {
        if (
          ele.value ==
          resPartyAddressEntityDetails.data.getPartyAddressEntity.StateCode
        )
          nameOfState = ele.option;
      });
      setStateName(nameOfState);
      let nameOfDistrict = "";
      districtArr.map((ele) => {
        if (
          ele.value ==
          resPartyAddressEntityDetails.data.getPartyAddressEntity.City
        )
          nameOfDistrict = ele.option;
      });
      setDistrictName(nameOfDistrict);
      let nameOfCountry = "";
      countryArr.map((ele) => {
        if (
          ele.value ==
          resPartyAddressEntityDetails.data.getPartyAddressEntity.CountryCode
        )
          nameOfCountry = ele.option;
      });
      setCountryName(nameOfCountry);
    } else {
      setData((prev) => ({
        ...prev,
        deliveryAddress: "",
        billingAddress: "",
      }));
    }
  }
  async function getAdressDetailsByCrDrID(data) {
    try {
      console.log("data", data);
      const resPartyAddressEntityDetails = await API.graphql(
        graphqlOperation(getPartyAddressEntity, {
          ObjectID: data,
          ObjectType: "CreditDelivery",
        })
      );
      console.log(
        "partyAddressEntityData111",
        resPartyAddressEntityDetails.data.getPartyAddressEntity
      );
      setPartyAddressEntity(
        resPartyAddressEntityDetails.data.getPartyAddressEntity
      );
      if (resPartyAddressEntityDetails.data.getPartyAddressEntity != null) {
        setData((prev) => ({
          ...prev,
          deliveryAddress:
            resPartyAddressEntityDetails.data.getPartyAddressEntity?.Line1,
          // billingAddress: resPartyAddressEntityDetails.data.getPartyAddressEntity?.Line1,
        }));
        let nameOfState = "";
        stateArr.map((ele) => {
          if (
            ele.value ==
            resPartyAddressEntityDetails.data.getPartyAddressEntity?.StateCode
          )
            nameOfState = ele.option;
        });
        setStateDelName(nameOfState);
        let nameOfDistrict = "";
        districtArr.map((ele) => {
          if (
            ele.value ==
            resPartyAddressEntityDetails.data.getPartyAddressEntity?.City
          )
            nameOfDistrict = ele.option;
        });
        setDistrictDelName(nameOfDistrict);
        let nameOfCountry = "";
        countryArr.map((ele) => {
          if (
            ele.value ==
            resPartyAddressEntityDetails.data.getPartyAddressEntity?.CountryCode
          )
            nameOfCountry = ele.option;
        });
        setCountryDelName(nameOfCountry);
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  async function getBillAdressDetailsByCrDrID(data) {
    try {
      const resPartyBillAddressEntityDetails = await API.graphql(
        graphqlOperation(getPartyAddressEntity, {
          ObjectID: data,
          ObjectType: "CreditBilling",
        })
      );
      setPartyBillAddressEntity(
        resPartyBillAddressEntityDetails.data.getPartyAddressEntity
      );
      if (resPartyBillAddressEntityDetails.data.getPartyAddressEntity != null) {
        setData((prev) => ({
          ...prev,
          // deliveryAddress: resPartyAddressEntityDetails.data.getPartyAddressEntity?.Line1,
          billingAddress:
            resPartyBillAddressEntityDetails.data.getPartyAddressEntity?.Line1,
        }));
        let nameOfState = "";
        stateArr.map((ele) => {
          if (
            ele.value ==
            resPartyBillAddressEntityDetails.data.getPartyAddressEntity
              ?.StateCode
          )
            nameOfState = ele.option;
        });
        setStateName(nameOfState);
        let nameOfDistrict = "";
        districtArr.map((ele) => {
          if (
            ele.value ==
            resPartyBillAddressEntityDetails.data.getPartyAddressEntity?.City
          )
            nameOfDistrict = ele.option;
        });
        setDistrictName(nameOfDistrict);
        let nameOfCountry = "";
        countryArr.map((ele) => {
          if (
            ele.value ==
            resPartyBillAddressEntityDetails.data.getPartyAddressEntity
              ?.CountryCode
          )
            nameOfCountry = ele.option;
        });
        setCountryName(nameOfCountry);
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  async function getCompanyDetails() {
    try {
      let compID = localStorage.getItem("companyID");
      const res = await API.graphql(graphqlOperation(getCompany));
      let imgLogo = "";
      res.data.getCompany.relatedCompanyDetailsNew.map((ele) => {
        imgLogo = `${ele.CompanyLogoUrl}`;
        if (ele.RegistrationType == 1) {
          setData((prev) => ({
            ...prev,
            gstApplicable: "2",
          }));
        } else {
          setData((prev) => ({
            ...prev,
            gstApplicable: "1",
          }));
        }
      });
      if (imgLogo == `https://ledgerx365.s3.amazonaws.com/`) {
        setCompanyLogo(
          "data:image/png;base64,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"
        );
      } else {
        setCompanyLogo(imgLogo);
      }
      setCOmpanyDetails(res.data);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getCompanyDetails();
  }, []);

  function handlePrint(CreditNoteNumber) {
    const html = `
    <html>
  <head>
     <meta name="viewport" />
  </head>
  <body>
  <div style="min-height: 350px; margin-left: auto; margin-right: auto; width:95%;
  margin-left: auto; margin-right: auto; padding-top: 10px">
  <div style="width: 50%; float: left;">
  <div style="display: flex; flex-direction:column; padding-right: 25px">
  <span style="display:flex; flex-direction:row; justify-content: center">
  <img width="200px;height="200px"; src="${companyLogo}" 
  alt="CompanyLogo">
  </span>
  <span style="font-size: 25px; padding-bottom: 5px;
          display:flex; flex-direction:row; justify-content: center">
     ${companyDetails.getCompany?.CompanyName}
  </span>
  <span style="font-size: 25px; padding-bottom: 50px;
          display:flex; flex-direction:row; justify-content: center">
          ${companyDetails.getCompany?.relatedAddressEntity?.[0].Line1.replace(
            /[**   ,]+/g,
            ","
          ).slice(0, -1)}
          ${
            companyDetails.getCompany?.relatedAddressEntity?.[0].Line2 &&
            ", " +
              companyDetails.getCompany?.relatedAddressEntity?.[0].Line2.split(
                "**"
              ).join("\n")
          } 
          ${
            companyDetails.getCompany?.relatedAddressEntity?.[0].Line2 &&
            ", " +
              companyDetails.getCompany?.relatedAddressEntity?.[0].Line3.split(
                "**"
              ).join("\n")
          }
          ${
            companyDetails.getCompany?.relatedAddressEntity?.[0].PINCode &&
            -companyDetails.getCompany?.relatedAddressEntity?.[0].PINCode.split(
              "**"
            ).join("\n")
          }
  </span>
  <div style="font-size: 30px; padding-left: 10px;
          display:flex; flex-direction:column;">
          <div style="display: flex; flex-direction: row;">
          <span style="font-size: 15px; padding-bottom: 5px;">
              <strong>GST No : </strong>${
                companyDetails.getCompany?.relatedCompanyEntity?.[0].GSTIN
              }
          </span>
      </div>
  </div>
  </div>
  </div>
  <div style="width: 50%; float: right;">
  <div style="border: solid; border-bottom-width: 1px; border-bottom-color: black;
  border-left: none; border-right: none; border-top: none; display: flex;
  flex-direction:row; justify-content: flex-end; padding-right: 25px">
  <span style="font-size: 30px; font-weight: bolder;  padding-bottom: 10px;">
     CREDIT NOTE
  </span>
  </div>
  <div style="border: solid; border-bottom-width: 1px; border-bottom-color: black;
  border-left: none; border-right: none; border-top: none; display: flex;
  flex-direction:row; justify-content: space-between; padding: 10px">
  <div style="display: flex; flex-direction:column; ">
     <span style="font-size: 15px; padding-bottom: 5px;">
         Credit Note No:
     </span>
     <span style="font-size: 16px; font-weight: bold">
     ${CreditNoteNumber}
     </span>
  </div>
  <div style="display: flex; flex-direction:column; ">
     <span style="font-size: 15px;  padding-bottom: 5px; text-align:right;">
         Date & Time
     </span>
     <span style="font-size: 16px; font-weight: bold">
     ${moment(new Date()).format("DD/MMM/YYYY hh:mm A")}
     </span>
  </div>
  </div>
  <div style="border: solid; border-bottom-width: 1px; border-bottom-color: black;
  border-left: none; border-right: none; border-top: none; display: flex;
  flex-direction:row; justify-content: space-between; padding:10px">
  <div style="display: flex; flex-direction:column; ">
     <span style="font-size: 15px; padding-bottom: 5px;">
         Payment Mode
     </span>
     <span style="font-size: 18px; font-weight: bold">
         ${data.paymentType}
     </span>
  </div>
  <div style="display: flex; flex-direction:column; ">
     <span style="font-size: 15px;  padding-bottom: 5px;">
     ${data.paymentType === "Credit" ? "Due Date" : "Payment Date"}
  
     </span>
     <span style="font-size: 18px; font-weight: bold">
             ${
               data.paymentType === "Credit"
                 ? `${data.dueDate}`
                 : `${
                     data.invoiceDate === ""
                       ? moment(new Date()).format("DD/MMM/YYYY")
                       : moment(data.invoiceDate).format("DD/MMM/YYYY")
                   }`
             } 
     </span>
  </div>
  </div>
  <div style="border: solid; border-bottom-width: 1px; border-bottom-color: black;
  border-left: none; border-right: none; border-top: none; display: flex;
  flex-direction:row; justify-content: space-between; padding:10px">
  <div style="display: flex; flex-direction:column; ">
     <span style="font-size: 15px; padding-bottom: 5px;">
         Party Name : ${data?.partyName?.label}
     </span>
     <span style="font-size: 15px; padding-bottom: 5px;">
         GST Registration Number : ${data?.gstin}
     </span>
     <span style="font-size: 15px; padding-bottom: 5px;">
         Place of Supply / State Code : ${data?.placeOfSupply}
     </span>
  </div>
  </div>
  <div style="display: flex; flex-direction:row; justify-content: space-between; padding:10px">
 <div style="display: flex; flex-direction:row; justify-content: space-between; padding:10px">
 <div style="display: flex; flex-direction:column; ">
     <span style="font-size: 15px; padding-bottom: 5px;">
         <strong>Supplier Address</strong>
     </span>
     ${
       data.partyName.value != ""
         ? `
        <span
          
        >
          ${
            billingAddressDetails.billingAddress !== ""
              ? billingAddressDetails.billingAddress.replace(/[**  ,]+/g, ",")
              : data.billingAddress.replace(/[**  ,]+/g, ",")
          }
        </span>
        ${
          billingAddressDetails.stateCD !== "" || stateName !== ""
            ? `
          <span
           
          >
            ${
              billingAddressDetails.stateCD !== ""
                ? billingAddressDetails.stateCD
                : stateName
            }
            ,${countryName}
          </span>
          `
            : ` <span
         
          >
            ${countryName}
          </span>`
        }
        `
         : ``
     }
 </div>
 </div>
 <div style="display: flex; flex-direction:row; justify-content: space-between; padding:10px">
 <div style="display: flex; flex-direction:column; ">
     <span style="font-size: 15px; padding-bottom: 5px;">
         <strong>Delivery Address</strong>
     </span>
     ${
       data.partyName.value != ""
         ? `
      
        <span
         
        >
          ${
            deliveryAddressDetails.deliveryAddress !== ""
              ? deliveryAddressDetails.deliveryAddress.replace(/[**  ,]+/g, ",")
              : data.deliveryAddress.replace(/[**  ,]+/g, ",")
          }
        </span>
        ${
          deliveryAddressDetails.stateCD != "" || stateDelName !== ""
            ? `
          <span
            
          >
            ${
              deliveryAddressDetails.stateCD != ""
                ? deliveryAddressDetails.stateCD
                : stateDelName
            }
            ,${countryDelName}
          </span>`
            : `
          <span
          
          >
            ${countryDelName}
          </span>`
        }
  `
         : ``
     }
 </div>
 </div>
 </div>
  </div>
  </div>
  ${
    itemEntry
      ? `<table border="1" cellpadding="5" cellspacing= "0" width="95%"
         style="margin-left: auto; margin-right: auto; text-align: center;">
      <thead style="background-color: #DADBDD; font-weight: bold;">
          <tr>
              <td>#</td>
              <td>Item Name</td>
              <td>HSN Code</td>
              <td>Rate</td>
              <td>Qty</td>
              <td>Discount</td>
              <td>Gross Amt</td>
              <td>GST Rate </td>
              <td colspan="2">CGST</td>
              <td colspan="2">SGST</td>
              <td colspan="2">IGST</td>
              <td style="text-align:right">Total</td>
          </tr>
          <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>Rate</td>
              <td>Amount</td>
              <td>Rate</td>
              <td>Amount</td>
              <td>Rate</td>
              <td>Amount</td>
              <td></td>
          </tr>
      </thead>
      <tbody>
          ${
            items &&
            items.length > 0 &&
            items.map((item, index) => {
              return `<tr style="min-height: 100px">
                  <td>${index + 1}</td>
                  <td>${item.name.label}</td>
                  <td>${item.HSN.value}</td>
                  <td>${item.rate}</td>
                  <td>${item.qty}</td>
                  <td>${item.dicount}</td>
                  <td>${item.amount}</td>
                  <td>${item.GSTRate}</td>
                  <td>${item.CGST}</td>
              <td>${
                data.placeOfSupply === "KeralaDistrict"
                  ? (
                      (Number(item.taxableAMount) * Number(item.GSTRate)) /
                      200
                    ).toFixed(2)
                  : "0.00"
              }
                  </td>
                  <td>${item.SGST}</td>
                  <td>${
                    data.placeOfSupply === "KeralaDistrict"
                      ? (
                          (Number(item.taxableAMount) * Number(item.GSTRate)) /
                          200
                        ).toFixed(2)
                      : "0.00"
                  }
                  </td>
                  <td>${item.IGST}</td>
                  <td>${
                    data.placeOfSupply !== "KeralaDistrict"
                      ? (
                          (Number(item.taxableAMount) * Number(item.GSTRate)) /
                          100
                        ).toFixed(2)
                      : "0.00"
                  }
                  </td>
                  <td>${Number(item.netAmount).toFixed(2)}</td>
              </tr>`;
            })
          }
         </tbody>
         <tfoot style="font-weight: bold; background-color: #DADBDD;">
         <tr>
         <td colspan="5" style="text-align: right">TOTAL</td>
         <td></td>
         <td>${Number(totAmount).toFixed(2)}</td>
         <td></td>
         <td></td>
         <td></td>
         <td></td>
         <td></td>
         <td></td>
         <td></td>
         <td>${Number(totNetAmount).toFixed(2)}</td>
     </tr>
         </tfoot>
     </table>`
      : `<table border="1" cellpadding="5" cellspacing= "0" width="95%"
         style="margin-left: auto; margin-right: auto; text-align: center;">
         <thead style="background-color: #DADBDD; font-weight: bold;">
             <tr>
                 <td>#</td>
                 <td>Expense Ledger Account</td>
                 <td>HSN/SAC Code</td>
                 <td>Description</td>
                 <td>Taxable Amount</td>
                 <td>GST Rate</td>
                 <td>GST</td>
                 <td>GST Cess</td>
                 <td>Net Amount</td>
             </tr>
         </thead>
         <tbody>
             ${
               nonItems &&
               nonItems.length > 0 &&
               nonItems.map((item, index) => {
                 return `<tr style="min-height: 100px">
                 <td>${index + 1}</td>
                 <td>${item.ledgerAccount.label}</td>
                 <td>${item.HSN.value}</td>
                 <td>${item.description}</td>
                 <td>${item.taxAMount}</td>
                 <td>${item.GSTRate}</td>
                 <td>
                 ${
                   data.placeOfSupply == "KeralaDistrict"
                     ? MoneyFormat(
                         (Number(item.taxAMount) * Number(item.GSTRate / 100)) /
                           2 +
                           (Number(item.taxAMount) *
                             Number(item.GSTRate / 100)) /
                             2,
                         "en-IN"
                       )
                     : MoneyFormat(
                         Number(item.taxAMount) * Number(item.GSTRate / 100),
                         "en-IN"
                       )
                 }
                 </td>
                 <td>${Number(item?.GSTCess).toFixed(2)}</td>
                 <td>${Number(item?.netAmount).toFixed(2)}</td>
             </tr>`;
               })
             }
         </tbody>
         <tfoot style="font-weight: bold; background-color: #DADBDD;">
             <tr>
                 <td colspan="4" style="text-align: right">TOTAL</td>
                 <td>${Number(totTaxableAmount).toFixed(2)}</td>
                 <td></td>
                 <td>${Number(totGST).toFixed(2)}</td>
                 <td>${Number(totGstCess).toFixed(2)}</td>
                 <td>${Number(totNetAmount).toFixed(2)}</td>
             </tr>
         </tfoot>
     </table>`
  }
     <div style="min-height: 300px; margin-left: auto; margin-right: auto; width:95%;
                 border: double; border-width: 2px; border-color: black; margin-top: 15px">
                 <div style=" display: flex;">
                 <div style="width: 50%;">
             <div style="font-size: 17px; margin-top: 10px; margin-bottom: 25px; padding-left: 10px;">
                 IN WORDS : <strong>
                 ${toWords.convert(
                   Number(totNetAmount.toFixed(2)) - Number(data.adjustments)
                 )}
                 </strong>
             </div>
             <table border="1" cellpadding="5" width="95%"
                    style="text-align: center; margin-left: 10px">
                 <thead>
                     <tr style="font-weight: bold;">
                         <td>Particulars</td>
                         <td>Amount</td>
                         <td>CGST</td>
                         <td>SGST</td>
                         <td>IGST</td>
                     </tr>
                 </thead>
                 <tbody>
                     <tr>
                         <td>Taxable</td>
                         <td>${Number(totTaxableAmount).toFixed(2)}</td>
                         <td>${
                           data.placeOfSupply === "KeralaDistrict"
                             ? (Number(totGST) / 2).toFixed(2)
                             : "0.00"
                         }</td>
                         <td>${
                           data.placeOfSupply === "KeralaDistrict"
                             ? (Number(totGST) / 2).toFixed(2)
                             : "0.00"
                         }</td>
                         <td>${
                           data.placeOfSupply !== "KeralaDistrict"
                             ? Number(totGST).toFixed(2)
                             : "0.00"
                         }</td>
                     </tr>
                 </tbody>
             </table>
         </div>
         <div style="width: 50%; float: right;">
             <div style="display: flex; flex-direction:column; line-height: 1.8; ">
                 <div style="display: flex; flex-direction:row; justify-content: space-between;
                             font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
                     <span>Gross Value</span>
                     <span>${Number(totTaxableAmount).toFixed(2)}</span>
                 </div>
                 <div style="display: flex; flex-direction:row; justify-content: space-between;
                             font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
                     <span>Net Taxable Value</span>
                     <span>${(Number(totGST) + Number(totGstCess)).toFixed(
                       2
                     )}</span>
                 </div>
                 <div style="display: flex; flex-direction:row; justify-content: space-between;
                             font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
                     <span>Other Adjustments</span>
                     <span>${Number(data.adjustments).toFixed(2)}</span>
                 </div>
                 <div style="display: flex; flex-direction:row; justify-content: space-between;
                             font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
                     <span>Discount</span>
                     <span>${
                       Number(totAmount) - Number(totTaxableAmount) > 0
                         ? (
                             Number(totAmount) - Number(totTaxableAmount)
                           ).toFixed(2)
                         : "0.00"
                     }</span>
                 </div>
                 <div style="display: flex; flex-direction:row; justify-content: space-between;
                             font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
                     <span>CGST</span>
                     <span>${
                       data.placeOfSupply === "KeralaDistrict"
                         ? (Number(totGST) / 2).toFixed(2)
                         : "0.00"
                     }</span>
                 </div>
                 <div style="display: flex; flex-direction:row; justify-content: space-between;
                             font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
                     <span>SGST</span>
                     <span>${
                       data.placeOfSupply === "KeralaDistrict"
                         ? (Number(totGST) / 2).toFixed(2)
                         : "0.00"
                     }</span>
                 </div>
                 <div style="display: flex; flex-direction:row; justify-content: space-between;
                             font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
                     <span>IGST</span>
                     <span>${
                       data.placeOfSupply !== "KeralaDistrict"
                         ? Number(totGST).toFixed(2)
                         : "0.00"
                     }</span>
                 </div>
                
                 <div style="display: flex; flex-direction:row; justify-content: space-between;
                             font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
                     <strong>Gross Total</strong>
                     <strong>${(
                       Number(totNetAmount.toFixed(2)) -
                       Number(data.adjustments)
                     ).toFixed(2)}</strong>
                 </div>
             </div>
         </div>
     </div>
     <div style="font-size: 17px;padding-left: 10px; ">
     Customer Ref / Remarks : <strong> ${data.remarks}</strong>
 </div>
 </div>
     <div style="margin-left: auto; margin-right: auto; width:95%;
                 border: double; border-width: 2px; border-color: black; margin-top: 15px">
         <div style="padding:10px;">
             <strong>TERMS AND CONDITIONS : </strong>
             Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
             Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
             when an unknown printer took a galley of type and scrambled it to make a type specimen book. 
             It has survived not only five centuries, but also the leap into electronic typesetting, 
             remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset 
             sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like 
             Aldus PageMaker including versions of Lorem Ipsum.
         </div>
     </div>
     <div style="margin-left: auto; margin-right: auto; width:95%; display:flex; flex-direction:row;">
         <div style="width: 40%; padding:5px; border: 1px solid black;">
             <span>
                 <strong>DECLARATION : </strong>
                 It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.
             </span>
         </div>
         <div style="width: 35%; padding:5px; border: 1px solid black;">
             <div display:flex; flex-direction:column;>
                 <div style="text-align: center;">
                     <strong>Received The Item In Good Condition</strong>
                 </div>
                 <div style="margin-top: 15px; text-align: center;">
                     Customer Name and Signature
                 </div>
             </div>
         </div>
         <div style="width: 25%; padding:5px; border: 1px solid black;">
             <div display:flex; flex-direction:column;>
                 <div style="text-align: center;">
                     <strong>For ${companyDetails?.getCompany?.CompanyName.toUpperCase()}</strong>
                 </div>
                 <div style="margin-top: 15px; text-align: center;">
                     Authorized Signature
                 </div>
             </div>
         </div>
     </div>
  </body>
  </html>
    `;
    const nonGsthtml = `
    <html>
  <head>
     <meta name="viewport" />
  </head>
  <body>
  <div style="min-height: 350px; margin-left: auto; margin-right: auto; width:95%;
  margin-left: auto; margin-right: auto; padding-top: 10px">
  <div style="width: 50%; float: left;">
  <div style="display: flex; flex-direction:column; padding-right: 25px">
  <span style="display:flex; flex-direction:row; justify-content: center">
  <img width="200px;height="200px"; src="${companyLogo}" 
  alt="CompanyLogo">
  </span>
  <span style="font-size: 25px; padding-bottom: 5px;
          display:flex; flex-direction:row; justify-content: center">
     ${companyDetails.getCompany?.CompanyName}
  </span>
  <span style="font-size: 25px; padding-bottom: 50px;
          display:flex; flex-direction:row; justify-content: center">
          ${companyDetails.getCompany?.relatedAddressEntity?.[0].Line1.replace(
            /[**   ,]+/g,
            ","
          ).slice(0, -1)}
       
          ${
            companyDetails.getCompany?.relatedAddressEntity?.[0].Line2 &&
            ", " +
              companyDetails.getCompany?.relatedAddressEntity?.[0].Line2.split(
                "**"
              ).join("\n")
          } 
          ${
            companyDetails.getCompany?.relatedAddressEntity?.[0].Line2 &&
            ", " +
              companyDetails.getCompany?.relatedAddressEntity?.[0].Line3.split(
                "**"
              ).join("\n")
          }
          ${
            companyDetails.getCompany?.relatedAddressEntity?.[0].PINCode &&
            -companyDetails.getCompany?.relatedAddressEntity?.[0].PINCode.split(
              "**"
            ).join("\n")
          }
  </span>
  <div style="font-size: 30px; padding-left: 10px;
          display:flex; flex-direction:column;">
          <div style="display: flex; flex-direction: row;">
      </div>
  </div>
  </div>
  </div>
  <div style="width: 50%; float: right;">
  <div style="border: solid; border-bottom-width: 1px; border-bottom-color: black;
  border-left: none; border-right: none; border-top: none; display: flex;
  flex-direction:row; justify-content: flex-end; padding-right: 25px">
  <span style="font-size: 30px; font-weight: bolder;  padding-bottom: 10px;">
     CREDIT NOTE
  </span>
  </div>
  <div style="border: solid; border-bottom-width: 1px; border-bottom-color: black;
  border-left: none; border-right: none; border-top: none; display: flex;
  flex-direction:row; justify-content: space-between; padding: 10px">
  <div style="display: flex; flex-direction:column; ">
     <span style="font-size: 15px; padding-bottom: 5px;">
         Credit Note No:
     </span>
     <span style="font-size: 18px; font-weight: bold">
     ${CreditNoteNumber}
     </span>
  </div>
  <div style="display: flex; flex-direction:column; ">
     <span style="font-size: 15px;  padding-bottom: 5px; text-align:right;">
         Date & Time
     </span>
     <span style="font-size: 18px; font-weight: bold">
     ${moment(new Date()).format("DD/MMM/YYYY hh:mm A")}
     </span>
  </div>
  </div>
  <div style="border: solid; border-bottom-width: 1px; border-bottom-color: black;
  border-left: none; border-right: none; border-top: none; display: flex;
  flex-direction:row; justify-content: space-between; padding:10px">
  <div style="display: flex; flex-direction:column; ">
     <span style="font-size: 15px; padding-bottom: 5px;">
         Payment Mode
     </span>
     <span style="font-size: 18px; font-weight: bold">
         ${data.paymentType}
     </span>
  </div>
  <div style="display: flex; flex-direction:column; ">
     <span style="font-size: 15px;  padding-bottom: 5px;">
     ${data.paymentType === "Credit" ? "Due Date" : "Payment Date"}
  
     </span>
     <span style="font-size: 18px; font-weight: bold">
             ${
               data.paymentType === "Credit"
                 ? `${data.dueDate}`
                 : `${
                     data.invoiceDate === ""
                       ? moment(new Date()).format("DD/MMM/YYYY")
                       : moment(data.invoiceDate).format("DD/MMM/YYYY")
                   }`
             } 
     </span>
  </div>
  </div>
  <div style="border: solid; border-bottom-width: 1px; border-bottom-color: black;
  border-left: none; border-right: none; border-top: none; display: flex;
  flex-direction:row; justify-content: space-between; padding:10px">
  <div style="display: flex; flex-direction:column; ">
     <span style="font-size: 15px; padding-bottom: 5px;">
         Party Name : ${data?.partyName?.label}
     </span>
     <span style="font-size: 15px; padding-bottom: 5px;">
         Place of Supply / State Code : ${data?.placeOfSupply}
     </span>
  </div>
  </div>
  <div style="display: flex; flex-direction:row; justify-content: space-between; padding:10px">
 <div style="display: flex; flex-direction:row; justify-content: space-between; padding:10px">
 <div style="display: flex; flex-direction:column; ">
     <span style="font-size: 15px; padding-bottom: 5px;">
         <strong>Supplier Address</strong>
     </span>
     ${
       data.partyName.value != ""
         ? `
        <span
          
        >
          ${
            billingAddressDetails.billingAddress !== ""
              ? billingAddressDetails.billingAddress.replace(/[**  ,]+/g, ",")
              : data.billingAddress.replace(/[**  ,]+/g, ",")
          }
        </span>
        ${
          billingAddressDetails.stateCD !== "" || stateName !== ""
            ? `
          <span
           
          >
            ${
              billingAddressDetails.stateCD !== ""
                ? billingAddressDetails.stateCD
                : stateName
            }
            ,${countryName}
          </span>
          `
            : ` <span
         
          >
            ${countryName}
          </span>`
        }
        `
         : ``
     }
 </div>
 </div>
 <div style="display: flex; flex-direction:row; justify-content: space-between; padding:10px">
 <div style="display: flex; flex-direction:column; ">
     <span style="font-size: 15px; padding-bottom: 5px;">
         <strong>Delivery Address</strong>
     </span>
     ${
       data.partyName.value != ""
         ? `
      
        <span
         
        >
          ${
            deliveryAddressDetails.deliveryAddress !== ""
              ? deliveryAddressDetails.deliveryAddress.replace(/[**  ,]+/g, ",")
              : data.deliveryAddress.replace(/[**  ,]+/g, ",")
          }
        </span>
        ${
          deliveryAddressDetails.stateCD != "" || stateDelName !== ""
            ? `
          <span
            
          >
            ${
              deliveryAddressDetails.stateCD != ""
                ? deliveryAddressDetails.stateCD
                : stateDelName
            }
            ,${countryDelName}
          </span>`
            : `
          <span
          
          >
            ${countryDelName}
          </span>`
        }
  `
         : ``
     }
 </div>
 </div>
 </div>
  </div>
  </div>
             <table border="1" cellpadding="5" cellspacing= "0" width="95%"
            style="margin-left: auto; margin-right: auto; text-align: center;">
         <thead style="background-color: #DADBDD; font-weight: bold;">
             <tr>
                 <td>#</td>
                 <td>Ledger Account</td>
                 <td>Description</td>
                 <td>Amount</td>
             </tr>
         </thead>
         <tbody>
             ${
               nonGstItems &&
               nonGstItems.length > 0 &&
               nonGstItems.map((item, index) => {
                 return `<tr style="min-height: 100px">
                     <td>${index + 1}</td>
                     <td>${item.ledgerAccount.value}</td>
                     <td>${item.description}</td>
                     <td>${item.amount}</td>
                 </tr>`;
               })
             }
         </tbody>
         <tfoot style="font-weight: bold; background-color: #DADBDD;">
             <tr>
             <td colspan="3" style="text-align: right">TOTAL</td>
                 <td>${Number(totNetAmount).toFixed(2)}</td>
             </tr>
         </tfoot>
     </table>
  
  <div style="min-height: 200px; margin-left: auto; margin-right: auto; width:95%;
                 border: double; border-width: 2px; border-color: black; margin-top: 15px; padding-bottom: 10px">
                 <div style=" display: flex;">
                 <div style="width: 50%;">
             <div style="font-size: 17px; margin-top: 10px; margin-bottom: 25px; padding-left: 10px;">
             IN WORDS : <strong>
                 ${toWords.convert(
                   Number(totNetAmount.toFixed(2)) - +Number(data.adjustments)
                 )}
             </strong>
             </div>
         </div>
     <div style="width: 50%; float: right;">
             <div style="display: flex; flex-direction:column; line-height: 1.8;">
             <div style="display: flex; flex-direction:row; justify-content: space-between;
             font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 15px;">
     <span>Gross Value</span>
     <span>${Number(totAmount).toFixed(2)}</span>
  </div>
  <div style="display: flex; flex-direction:row; justify-content: space-between;
             font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
     <span>Round Off</span>
     <span>0.00</span>
  </div>
  <div style="display: flex; flex-direction:row; justify-content: space-between;
             font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
     <span>Discount</span>
     <span>${
       Number(totAmount) - Number(totNetAmount) > 0
         ? (Number(totAmount) - Number(totNetAmount)).toFixed(2)
         : "0.00"
     }</span>
  </div>
                 <div style="display: flex; flex-direction:row; justify-content: space-between;
                             font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
                     <span>Other Adjustments</span>
                     <span>${Number(data.adjustments).toFixed(2)}</span>
                 </div>
  <div style="display: flex; flex-direction:row; justify-content: space-between;
             font-size: 15px; padding-left: 15px; padding-right: 15px; margin-top: 5px;">
     <strong>Gross Total</strong>
     <strong>${(Number(totNetAmount) - Number(data.adjustments)).toFixed(
       2
     )}</strong>
  </div>
             </div>
         </div>
     </div>
     <div style="font-size: 17px; padding-left: 10px;">
     Customer Ref / Remarks : <strong> ${data.remarks} </strong>
 </div>
     <div style="margin-left: auto; margin-right: auto; width:95%;
                 border: double; border-width: 2px; border-color: black; margin-top: 15px">
         <div style="padding:10px;">
             <strong>TERMS AND CONDITIONS : </strong>
             Lorem Ipsum is simply dummy text of the printing and typesetting industry. 
             Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, 
             when an unknown printer took a galley of type and scrambled it to make a type specimen book. 
             It has survived not only five centuries, but also the leap into electronic typesetting, 
             remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset 
             sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like 
             Aldus PageMaker including versions of Lorem Ipsum.
         </div>
     </div>
     <div style="margin-left: auto; margin-right: auto; width:95%; display:flex; flex-direction:row;">
         <div style="width: 40%; padding:5px; border: 1px solid black;">
             <span>
                 <strong>DECLARATION : </strong>
                 It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.
             </span>
         </div>
         <div style="width: 35%; padding:5px; border: 1px solid black;">
             <div display:flex; flex-direction:column;>
                 <div style="text-align: center;">
                     <strong>Received The Item In Good Condition</strong>
                 </div>
                 <div style="margin-top: 15px; text-align: center;">
                     Customer Name and Signature
                 </div>
             </div>
         </div>
         <div style="width: 25%; padding:5px; border: 1px solid black;">
             <div display:flex; flex-direction:column;>
                 <div style="text-align: center;">
                     <strong>For ${companyDetails?.getCompany?.CompanyName.toUpperCase()}</strong>
                 </div>
                 <div style="margin-top: 15px; text-align: center;">
                     Authorized Signature
                 </div>
             </div>
         </div>
     </div>
  </body>
  </html>
    `;
    printJS({
      printable: data.gstApplicable == "1" ? html : nonGsthtml,
      type: "raw-html",
      documentTitle: "Credit Note",
    });
  }
  async function searchSAC(value) {
    try {
      const res = await API.graphql(
        graphqlOperation(searchHSN, { RowFrom: 0, LimitNo: 10000, Word: value })
      );
      console.log("res", res);
      if (res.data.searchHSN !== null) {
        let arr = [{ label: "", value: "" }];
        res.data.searchHSN.map((item) => {
          arr.push({
            label: `${item.HSNSACCode} - ${item.Description}`,
            value: `${item.HSNSACCode}`,
          });
        });
        setFilterHSN(arr);
      }
    } catch (error) {
      console.log(error);
    }
  }
  async function getSAC() {
    const res = await API.graphql(
      graphqlOperation(listHSN, { RowFrom: 100, LimitNo: 100 })
    );

    console.log(res.data);

    if (res.data.listHSN !== null) {
      let arr = [
        // { label: '', value: '' }
      ];
      res.data.listHSN.filter((ele) => {
        arr.push({
          label: `${ele.HSNSACCode} - ${ele.Description}`,
          value: `${ele.HSNSACCode}`,
        });
      });
      SetHSNCOdes(arr);
    }
  }
  async function searchSACItem(value) {
    try {
      const res = await API.graphql(
        graphqlOperation(searchHSN, { RowFrom: 0, LimitNo: 10000, Word: value })
      );
      let hsnObj = { label: "", value: "" };
      let arr = [];
      console.log("--------------------", value);
      if (value === 0) {
        arr.push({
          label: value,
          value: value,
        });
      }
      if (res.data.searchHSN !== null) {
        await Promise.all(
          res.data.searchHSN.map((item) => {
            arr.push({
              label: `${item.HSNSACCode} - ${item.Description}`,
              value: `${item.HSNSACCode}`,
            });
            if (Number(item.HSNSACCode) === Number(value)) {
              hsnObj = {
                label: `${item.HSNSACCode} - ${item.Description}`,
                value: `${item.HSNSACCode}`,
              };
            }
          })
        );
      }
      if (hsnObj.label === "" && value !== 0) {
        hsnObj = {
          label: value,
          value: value,
        };
      }
      setFilterHSN(arr);
      return { hsnObj, arr };
    } catch (error) {
      console.log(error);
    }
  }

  async function getAccountMasterData() {
    try {
      const res = await API.graphql(graphqlOperation(listAccountGroupMaster));
      let allAccount = [];
      let obj = {};
      res.data.listAccountGroupMaster.map((item) => {
        item.RelatedAccounts.map((subItem) => {
          allAccount.push({
            label: subItem.AccountName,
            value: subItem.AccountsID,
          });
          obj[subItem.AccountsID] = subItem.AccountName;
        });
      });
      allAccount = allAccount.sort(function (a, b) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
      let cashAccArr = res.data.listAccountGroupMaster.filter(
        (item) => item.AccountGroupID.split(" ").indexOf("CASH") !== -1
      );
      let cashAccName = [];
      cashAccArr[0].RelatedAccounts.map((item) => {
        let accName = item.AccountName;
        cashAccName.push({ label: accName, value: `${item.AccountsID}` });
        cashAccName = cashAccName.sort(function (a, b) {
          if (a.label < b.label) {
            return -1;
          }
          if (a.label > b.label) {
            return 1;
          }
          return 0;
        });
      });
      setCashAccount(cashAccName);
      let bankAccAr = res.data.listAccountGroupMaster.filter(
        (item) => item.AccountGroupID.split(" ").indexOf("BANK") !== -1
      );
      let bankAccName = [];
      bankAccAr[0].RelatedAccounts.map((item) => {
        let accName = item.AccountName;
        bankAccName.push({ label: accName, value: `${item.AccountsID}` });
      });
      bankAccName = bankAccName.sort(function (a, b) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
      setBankAccount(bankAccName);
      // allAccount.push({ label: '', value: '' })
      setAccName(allAccount);
      setAccountsObj(obj);
    } catch (error) {
      console.log(error);
    }
  }

  const [unitsObj, setUnitsObj] = useState({});
  async function getUnit(data) {
    const res = await API.graphql(
      graphqlOperation(getCodeTranslation, { CodeType: data })
    );

    // console.log(res.data.getCodeTranslation);

    let obj = {};
    let unitsArray = res?.data?.getCodeTranslation?.map((element) => {
      obj[element.CodeValue] = element.CodeText;
      return { option: element.CodeText, value: `${element.CodeValue}` };
    });
    setUnitsObj(obj);
    setunits(unitsArray);

    //console.log(unitsArray);
  }
  async function listSuppliers() {
    try {
      const res = await API.graphql(graphqlOperation(listPartymasters));
      console.log(res.data);
      if (res.data.listPartymasters != null) {
        setPartyMasters(res.data.listPartymasters);
        let arr = [];
        let optionarr = [];
        res.data.listPartymasters.filter((ele) => {
          // if (ele.PartyTypeCd === "SUPPLIER") {
          arr.push({
            option: ele?.PartyLegalName,
            value: `${ele?.PartyID}`,
            creditDays: ele.relatedPartyCreditDetails[0]?.CreditPeriodDuration,
            placeOfSupply: ele?.PlaceOfSupply,
            address: ele?.Address,
            gstin: ele?.relatedPartyGstDetails[0]?.GSTIN,
            accountsID: ele?.AccountsID,
          });
          optionarr.push({
            label:
              ele?.DisplayNameForInvFlag === "1"
                ? ele?.PartyDisplayName
                : ele?.PartyLegalName,
            value: ele.PartyID,
          });
          // }
        });
        optionarr = optionarr.sort(function (a, b) {
          if (a.label < b.label) {
            return -1;
          }
          if (a.label > b.label) {
            return 1;
          }
          return 0;
        });
        setSupplires(arr);
        setSupplierOptions(optionarr);
      }
    } catch (error) {
      //console.log(error);
    }
  }
  async function getInvoices() {
    try {
      const res = await API.graphql(
        graphqlOperation(listPartyInvoices, { PartyID: partyID })
      );
      let invoiceNos = [];
      res.data.listPartyInvoices.map((item) => {
        invoiceNos.push({
          label: `${item.InvoiceNumber}`,
          value: `${item.InvoiceID}`,
        });
      });
      setInvoices(invoiceNos);
    } catch (error) {
      console.log("error", error);
    }
  }
  async function getInvoiceNumbers(Id) {
    try {
      const res = await API.graphql(
        graphqlOperation(listPartyInvoices, { PartyID: Id })
      );
      console.log("listPartyInvoices", res);
      let invoiceNos = [];
      let invoiceArr = [];
      res.data.listPartyInvoices.map((item) => {
        invoiceNos.push({
          label: `${item.InvoiceNumber}`,
          value: `${item.InvoiceID}`,
        });
      });
      invoiceDetails.map((ele) => {
        invoiceNos.map((subele) => {
          if (ele.InvoiceID == subele.value) {
            invoiceArr.push({
              label: subele.label,
              value: subele.value,
            });
          }
        });
      });
      setData((prev) => ({
        ...prev,
        originalInvoiceNumber: invoiceArr,
      }));
    } catch (error) {
      console.log("error", error);
    }
  }
  useEffect(() => {
    getInvoiceNumbers(invPartyId);
  }, [CrDrId]);
  useEffect(() => {
    getInvoices();
  }, [partyID]);
  async function listItems() {
    try {
      const res = await API.graphql(graphqlOperation(listItemmasters));
      if (res.data.listItemmasters != null) {
        setAllItemData(res.data.listItemmasters);
        let arr = [];
        let itemCodeArr = [];
        res.data.listItemmasters.filter((ele) => {
          arr.push({ label: ele.ItemName, value: `${ele.ItemID}` });
        });
        res.data.listItemmasters.filter((ele) => {
          if (ele.ItemCode != "") {
            itemCodeArr.push({ label: ele.ItemCode, value: `${ele.ItemID}` });
          }
        });
        SetItemsName(arr);
        SetItemsCode(itemCodeArr);
      }
    } catch (error) {
      console.log(error);
    }
  }
  async function getStates(code) {
    // setBackdropOpen(true)
    const cities = await API.graphql(
      graphqlOperation(getCodeTranslation, { CodeType: code })
    );
    if (cities?.data?.getCodeTranslation != null) {
      let statesArray = (cities?.data?.getCodeTranslation).map((element) => {
        return {
          option: element.CodeText,
          value: `${element.CodeText}District`,
        };
      });
      SetCountrySTates(statesArray);
    }
    setBackdropOpen(false);
  }
  async function getItemType(Id) {
    try {
      const res = await API.graphql(graphqlOperation(listItemmasters));
      let type = "";
      res.data.listItemmasters.filter((item) => {
        if (item.ItemID == Id) {
          type = item.ItemType;
        }
      });
      console.log("result", type);
      setItemType(type);
    } catch (error) {
      console.log("err", error);
    }
  }
  useEffect(() => {
    getStates("IndiaState");
  }, []);

  useEffect(() => {
    getSAC();
    listSuppliers();
    listItems();
    getUnit("UNITS");
    getAccountMasterData();
  }, []);
  useEffect(() => {
    getAccountMasterData();
  }, [toAccountModal, additemModal, itemModal]);
  useEffect(() => {
    listItems();
  }, [additemModal, itemModal]);
  async function getItemData() {
    try {
      const res = await API.graphql(
        graphqlOperation(getItemmaster, { ItemID: ItemId })
      );
      let obj = {};
      if (ItemId !== "") {
        let gstrate = "";
        let itemRate = "";
        let cess = "";
        res.data.getItemmaster.relatedItemAmountDetails !== null &&
          res.data.getItemmaster?.relatedItemAmountDetails.map((ele) => {
            if (
              new Date().getTime() >=
                new Date(ele.EffectiveDate * 1000).getTime() &&
              new Date().getTime() <= new Date(ele.ExpiredDate * 1000)
            ) {
              gstrate = ele.GSTRATE;
              itemRate = ele.Amount;
              if (ele.GSTCompensationType === "Amount")
                cess = ele.GSTCompensationValue;
              else
                cess =
                  (Number(ele.Amount) * Number(ele.GSTCompensationValue)) / 100;
            } else if (ele.ExpiredDate == 0) {
              if (
                new Date().getTime() >=
                new Date(ele.EffectiveDate * 1000).getTime()
              ) {
                gstrate = ele.GSTRATE;
                itemRate = ele.Amount;
              }
              if (ele.GSTCompensationType === "Amount")
                cess = ele.GSTCompensationValue;
              else
                cess =
                  (Number(ele.Amount) * Number(ele.GSTCompensationValue)) / 100;
            }
          });

        let hsnCode = {};
        let hsnobj254 = {};
        hsnobj254 = await searchSACItem(res.data.getItemmaster.HSNID);
        hsnCode = hsnobj254.hsnObj;

        let accountobj = {
          label: "",
          value: "",
        };
        accName.map((code) => {
          if (code.value == res.data.getItemmaster.PurchaseAccountID) {
            accountobj = { label: code.label, value: code.value };
          }
        });
        let itemNameObj = {
          label: "",
          value: "",
        };
        itemsName?.map((ele) => {
          if (ele.value == res.data.getItemmaster.ItemID) {
            itemNameObj = {
              label: ele.label,
              value: ele.value,
            };
          }
        });
        let itemCodeObj = {
          label: "",
          value: "",
        };
        itemsCode?.map((ele) => {
          if (ele.value == res.data.getItemmaster.ItemID) {
            itemCodeObj = {
              label: ele.label,
              value: ele.value,
            };
          }
        });
        obj = { ...itemEditedRow };
        obj.itemCode = itemCodeObj;
        obj.purchaseAccount = accountobj;
        obj.units = res.data.getItemmaster.MeasurementCD;
        obj.GSTRate = gstrate;
        obj.rate = itemRate;
        obj.GSTCess = cess;
        obj.amount = itemRate;
        obj.taxableAMount = itemRate;
        obj.HSN = hsnCode;
        obj.name = itemNameObj;

        setItemEditedRow(obj);
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  async function getCurrentItemData() {
    try {
      const res = await API.graphql(
        graphqlOperation(getItemmaster, { ItemID: currentItemCode })
      );
      let obj = {};

      let gstrate = "";
      let itemRate = "";
      let cess = "";
      res.data.getItemmaster.relatedItemAmountDetails !== null &&
        res.data.getItemmaster?.relatedItemAmountDetails.map((ele) => {
          if (
            new Date().getTime() >=
              new Date(ele.EffectiveDate * 1000).getTime() &&
            new Date().getTime() <= new Date(ele.ExpiredDate * 1000)
          ) {
            gstrate = ele.GSTRATE;
            itemRate = ele.Amount;
            if (ele.GSTCompensationType === "Amount")
              cess = ele.GSTCompensationValue;
            else
              cess =
                (Number(ele.Amount) * Number(ele.GSTCompensationValue)) / 100;
          } else if (ele.ExpiredDate == 0) {
            if (
              new Date().getTime() >=
              new Date(ele.EffectiveDate * 1000).getTime()
            ) {
              gstrate = ele.GSTRATE;
              itemRate = ele.Amount;
            }
            if (ele.GSTCompensationType === "Amount")
              cess = ele.GSTCompensationValue;
            else
              cess =
                (Number(ele.Amount) * Number(ele.GSTCompensationValue)) / 100;
          }
        });

      let hsnCode = {};
      let hsnobj254 = {};
      hsnobj254 = await searchSACItem(res.data.getItemmaster.HSNID);
      hsnCode = hsnobj254.hsnObj;

      let accountobj = {
        label: "",
        value: "",
      };
      accName.map((code) => {
        if (code.value == res.data.getItemmaster.PurchaseAccountID) {
          accountobj = { label: code.label, value: code.value };
        }
      });
      let itemNameObj = {
        label: "",
        value: "",
      };

      itemNameObj = {
        label: res.data.getItemmaster.ItemName,
        value: res.data.getItemmaster.ItemID,
      };
      let itemCodeObj = {
        label: "",
        value: "",
      };

      itemCodeObj = {
        label: res.data.getItemmaster.ItemCode,
        value: res.data.getItemmaster.ItemID,
      };

      obj = { ...itemEditedRow };
      obj.itemCode = itemCodeObj;
      obj.purchaseAccount = accountobj;
      obj.units = res.data.getItemmaster.MeasurementCD;
      obj.GSTRate = gstrate;
      obj.rate = itemRate;
      obj.GSTCess = cess;
      obj.amount = itemRate;
      obj.taxableAMount = itemRate;
      obj.HSN = hsnCode;
      obj.name = itemNameObj;
      setItemEditedRow(obj);
    } catch (error) {
      console.log("error", error);
    }
  }
  useEffect(() => {
    getCurrentItemData();
  }, [additemModal]);
  useEffect(() => {
    getItemData();
  }, [itemModal, allItemData]);

  const [errorArr, setErrorArr] = useState({});
  useEffect(() => {
    let errorKeys = [];
    if (Object.keys(errorArr).length > 0) {
      for (const key in errorArr) {
        if (errorArr[key] === true) {
          errorKeys.push(key);
        }
      }
      if (errorKeys.length > 0) {
        let element = document?.getElementById(errorKeys[0]);
        element.scrollIntoView({ block: "center" });
      }
    }
  }, [errorArr]);

  function saveChangesInRows(ind) {
    let isvalid = true;
    let tempobj = { ...itemTempRow };
    let editedobj = { ...itemEditedRow };
    let requireds = [];
    let invalids = [];
    let corrects = [];

    if (editedobj.name.value === "") {
      isvalid = false;

      requireds.push("Item Name");
    }

    if (
      editedobj.qty !== "" &&
      !new RegExp(/^(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/).test(editedobj.qty)
    ) {
      isvalid = false;
      invalids("Quantity");
    }

    if (editedobj.qty !== 0 && (editedobj.rate == "" || editedobj.rate == 0)) {
      isvalid = false;
      //requireds += " Rate";
      requireds.push("Rate");
    }

    if (
      editedobj.rate !== "" &&
      !new RegExp(/^(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/).test(editedobj.rate)
    ) {
      isvalid = false;
      invalids.push("Rate");
    }

    if (editedobj.amount === 0) {
      isvalid = false;
      requireds.push("Amount");
    }

    if (
      editedobj.amount !== 0 &&
      !new RegExp(/^(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/).test(editedobj.amount)
    ) {
      isvalid = false;
      invalids.push("Amount");
    }

    if (
      editedobj.dicount !== "" &&
      !new RegExp(/^(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/).test(editedobj.dicount)
    ) {
      isvalid = false;
      // invalids += " Discount";
      invalids.push("Discount");
    }
    if (editedobj.dicount > editedobj.amount) {
      isvalid = false;
      corrects.push("Discount");
    }

    if (editedobj.GSTRate === "") {
      console.log(editedobj.GSTRate);
      isvalid = false;
      // requireds += " GST Rate";
      requireds.push("GST Rate");
    }

    if (
      editedobj.GSTCess !== "" &&
      !new RegExp(/^(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/).test(editedobj.GSTCess)
    ) {
      isvalid = false;
      // invalids += " GST Cess";
      invalids.push("GST Cess");
    }

    if (isvalid) {
      let obj = { ...itemEditedRow };
      obj.editable = false;
      obj.new = false;
      let arr = [...items];
      arr[ind] = obj;

      setItems(arr);
      setItemTempRow({});
      setItemEditedRow({});
      if (data.recordAmount !== "" || data.recordAmount != 0) {
        if (
          Number(totNetAmount) + Number(data.adjustments) >=
          data.recordAmount
        ) {
          setData((prev) => ({
            ...prev,
            errorStatus: {
              recordAmount: false,
            },
            errorFields: {
              recordAmount: "",
            },
          }));
        } else {
          setData((prev) => ({
            ...prev,
            errorStatus: {
              recordAmount: true,
            },
            errorFields: {
              recordAmount: "Amount should be less than Grand Total",
            },
          }));
        }
      }
    } else {
      if (requireds.length > 0) {
        if (requireds.length > 1) {
          requireds += " are required";
        } else if (requireds.length == 1) {
          requireds += " is required";
        }
      }

      if (invalids.length > 0) {
        if (invalids.length > 1) {
          invalids += " are Inavlid Data.Please Enter Correct Data";
        } else if (invalids.length == 1) {
          invalids += " is  Inavlid Data.Please Enter Correct Data";
        }
      }
      if (corrects.length > 0) {
        if (corrects.length >= 1) {
          corrects += " amount should be less than Amount";
        }
      }

      console.log("corrects.length", corrects.length);
      if (requireds.length >= 1 && corrects.length >= 1) {
        setWarningMessage(`${requireds} & ${corrects}`);
        setCompleteSnakbar(true);
      } else {
        setWarningMessage(`${requireds} ${corrects}`);
        setCompleteSnakbar(true);
      }
    }
  }
  function saveChangesInNonGstRows(ind) {
    let isvalid = true;
    let tempobj = { ...nonGstItemTempRow };
    let editedobj = { ...nonGstItemEditedRow };

    let requireds = [];
    let invalids = [];
    if (editedobj.ledgerAccount.value === "") {
      isvalid = false;
      // requireds += "Ledger Account";
      requireds.push("Ledger Account");
    }

    if (editedobj.amount === "" || editedobj.amount == 0) {
      isvalid = false;
      // requireds += " Amount";
      requireds.push("Amount");
    }

    if (
      editedobj.amount !== "" &&
      !new RegExp(/^(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/).test(editedobj.amount)
    ) {
      isvalid = false;
      // invalids += " Amount";
      invalids.push("Amount");
    }

    if (isvalid) {
      let obj = { ...nonGstItemEditedRow };
      obj.editable = false;
      obj.new = false;
      let arr = [...nonGstItems];
      arr[ind] = obj;

      setNonGstItems(arr);
      setNonGstItemTempRow({});
      setNonGstItemEditedRow({});
      if (data.recordAmount !== "" || data.recordAmount != 0) {
        if (
          Number(totNonGstNetAmount) + Number(data.adjustments) >=
          data.recordAmount
        ) {
          setData((prev) => ({
            ...prev,
            errorStatus: {
              recordAmount: false,
            },
            errorFields: {
              recordAmount: "",
            },
          }));
        } else {
          setData((prev) => ({
            ...prev,
            errorStatus: {
              recordAmount: true,
            },
            errorFields: {
              recordAmount: "Amount should be less than Grand Total",
            },
          }));
        }
      }
    } else {
      if (requireds.length > 0) {
        if (requireds.length > 1) {
          requireds += " are required";
        } else if (requireds.length == 1) {
          requireds += " is required";
        }
      }

      if (invalids.length > 0) {
        if (invalids.length > 1) {
          invalids += " are Inavlid Data.Please Enter Correct Data";
        } else if (invalids.length == 1) {
          invalids += " is  Inavlid Data.Please Enter Correct Data";
        }
      }
      if (requireds.length >= 1 && invalids.length >= 1) {
        setWarningMessage(`${requireds} & ${invalids}`);
        setCompleteSnakbar(true);
      } else {
        setWarningMessage(`${requireds} ${invalids}`);
        setCompleteSnakbar(true);
      }
    }
  }
  function closeChangesInNonGstRows(ind) {
    if (nonGstItemEditedRow.new) {
      let arr = [...nonGstItems].filter((item, index) => {
        if (ind != index) {
          return item;
        }
      });
      setNonGstItems(arr);
      setNonGstItemEditedRow({});
      setNonGstItemTempRow({});
    } else {
      let obj = { ...nonGstItemTempRow };
      obj.editable = false;
      obj.new = false;
      let arr = [...nonGstItems];
      arr[ind] = obj;

      setNonGstItems(arr);
      setNonGstItemEditedRow({});
      setNonGstItemTempRow({});
    }
  }
  function saveChangesInNonRows(ind) {
    let isvalid = true;
    let tempobj = { ...nonItemTempRow };
    let editedobj = { ...nonItemEditedRow };
    // let requireds = "";
    // let invalids = "";
    let requireds = [];
    let invalids = [];

    if (editedobj.ledgerAccount.value === "") {
      isvalid = false;
      // requireds += "Ledger Account";
      requireds.push("Ledger Account");
    }

    if (editedobj.taxAMount === "" || editedobj.taxAMount === 0) {
      isvalid = false;
      // requireds += " Taxable Amount";
      requireds.push("Taxable Amount");
    }

    if (
      editedobj.taxAMount !== "" &&
      !new RegExp(/^(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/).test(editedobj.taxAMount)
    ) {
      isvalid = false;
      // invalids += " Taxable Amount";
      invalids.push("Taxable Amount");
    }

    if (editedobj.GSTRate === "") {
      isvalid = false;
      // requireds += " GST Rate";
      requireds.push("GST Rate");
    }

    if (
      editedobj.GSTCess !== "" &&
      !new RegExp(/^(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/).test(editedobj.GSTCess)
    ) {
      isvalid = false;
      // invalids += " GST Cess";
      invalids.push("GST Cess");
    }

    if (isvalid) {
      let obj = { ...nonItemEditedRow };
      obj.editable = false;
      obj.new = false;
      let arr = [...nonItems];
      arr[ind] = obj;

      setNonItems(arr);
      setNonItemEditedRow({});
      setNonItemTempRow({});
      if (
        data.recordAmount !== "" &&
        Number(totNetAmount) + Number(data.adjustments) >= data.recordAmount
      ) {
        setData((prev) => ({
          ...prev,
          errorStatus: {
            recordAmount: true,
          },
          errorFields: {
            recordAmount: "Amount should be less than Grand Total",
          },
        }));
      } else {
        setData((prev) => ({
          ...prev,
          errorStatus: {
            recordAmount: false,
          },
          errorFields: {
            recordAmount: "",
          },
        }));
      }
    } else {
      if (requireds.length > 0) {
        if (requireds.length > 1) {
          requireds += " are required";
        } else if (requireds.length == 1) {
          requireds += " is required";
        }
      }

      if (invalids.length > 0) {
        if (invalids.length > 1) {
          invalids += " are Inavlid Data.Please Enter Correct Data";
        } else if (invalids.length == 1) {
          invalids += " is  Inavlid Data.Please Enter Correct Data";
        }
      }
      //  console.log("invalids",requireds)
      // setWarningMessage(`${requireds} ${invalids}`);
      // setCompleteSnakbar(true);
      if (requireds.length >= 1 && invalids.length >= 1) {
        setWarningMessage(`${requireds} & ${invalids}`);
        setCompleteSnakbar(true);
      } else {
        setWarningMessage(`${requireds} ${invalids}`);
        setCompleteSnakbar(true);
      }
    }
  }

  function closeChangesInRows(ind) {
    let isvalid = true;
    let tempobj = { ...itemTempRow };
    let editedobj = { ...itemEditedRow };

    if (tempobj.account == "") {
      isvalid = false;
    }

    if (tempobj.credit == "" && tempobj.debit == "") {
      isvalid = false;
    }

    if (itemEditedRow.new) {
      let arr = [...items].filter((item, index) => {
        if (ind != index) {
          return item;
        }
      });
      setItems(arr);
      setItemEditedRow({});
      setItemTempRow({});
    } else {
      let obj = { ...itemTempRow };
      obj.editable = false;
      obj.new = false;
      let arr = [...items];
      arr[ind] = obj;

      setItems(arr);
      setItemEditedRow({});
      setItemTempRow({});
    }
  }

  function noncloseChangesInRows(ind) {
    if (nonItemEditedRow.new) {
      let arr = [...nonItems].filter((item, index) => {
        if (ind != index) {
          return item;
        }
      });
      setNonItems(arr);
      setNonItemEditedRow({});
      setNonItemTempRow({});
    } else {
      let obj = { ...nonItemTempRow };
      obj.editable = false;
      obj.new = false;
      let arr = [...nonItems];
      arr[ind] = obj;

      setNonItems(arr);
      setNonItemEditedRow({});
      setNonItemTempRow({});
    }
  }
  useEffect(() => {
    let uniqueElements = [];
    uniqueElements = [...items];
    console.log("items", items);
    let obj = {};
    const elementCounts = uniqueElements.forEach((item) => {
      let amount = 0;

      items.filter((ele) => {
        if (ele.purchaseAccount?.value === item.purchaseAccount?.value) {
          amount += Number(ele.taxableAMount);
        }
      });

      obj[amount] = item;
    });
    let arr = [];
    for (const key in obj) {
      arr.push({
        amount: key,
        itemValue: obj[key],
      });
    }
    setJournalItems(arr);
  }, [items, allItemData]);
  useEffect(() => {
    let uniqueElements = [];
    uniqueElements = [...nonItems];

    let obj = {};
    const elementCounts = uniqueElements.forEach((item) => {
      let amount = 0;

      nonItems.filter((ele) => {
        if (ele.ledgerAccount.value === item.ledgerAccount.value) {
          amount += Number(ele.taxAMount);
        }
      });

      obj[amount] = item;
    });
    let arr = [];
    for (const key in obj) {
      arr.push({
        amount: key,
        itemValue: obj[key],
      });
    }
    setJournalNonItems(arr);
  }, [nonItems, params?.id]);
  useEffect(() => {
    let uniqueElements = [];
    uniqueElements = [...nonGstItems];

    let obj = {};
    const elementCounts = uniqueElements.forEach((item) => {
      let amount = 0;

      nonGstItems.filter((ele) => {
        if (ele.ledgerAccount.value === item.ledgerAccount.value) {
          amount += Number(ele.amount);
        }
      });

      obj[amount] = item;
    });
    let arr = [];
    for (const key in obj) {
      arr.push({
        amount: key,
        itemValue: obj[key],
      });
    }
    setJournalNonGstItems(arr);
  }, [nonGstItems, params?.id]);
  const journalHTML = `
  <html>
    <head>
      <meta name="viewport" />
    </head>
    <body>
      <table cellpadding="2" cellspacing= "0" width="95%" 
        style="margin-left: auto; margin-right: auto; margin-top: 10px;">
        <thead>
          <tr style="font-weight: bold;">
            <td width="60%">Particulars</td>
            <td width="20%" align="center">Debit(₹)</td>
            <td width="20%" align="center">Credit(₹)</td>
          </tr>
        </thead>
        <tbody>
          ${
            data.gstApplicable == "1"
              ? itemEntry
                ? journalItems.map((ele) => {
                    if (ele.itemValue.editable == false)
                      return `<tr style="color:#396afc;font-weight: bold;">
               ${
                 data.purchaseOrSalseFlag == "1"
                   ? Object.keys(ele.itemValue.purchaseAccount).length !== 0 &&
                     ele?.itemValue?.purchaseAccount?.value !== ""
                     ? `<td width="60%"> ${ele.itemValue.purchaseAccount?.label} Dr</td>`
                     : `<td width="60%"> Purchase A/C Dr</td>`
                   : `<td width="60%"> Sales Return A/c Dr</td>`
               }
                  <td width="20%" align="center">${MoneyFormat(
                    Number(ele.amount),
                    "en-IN"
                  )}</td>
                  <td width="20%" align="center"></td>
                </tr>
                `;
                  })
                : journalNonItems.map((ele) => {
                    if (ele.itemValue.editable === false)
                      return `<tr style="color:#396afc;font-weight: bold;">
                  <td width="60%"> ${ele.itemValue.ledgerAccount.label} Dr</td>
           
                  <td width="20%" align="center">${MoneyFormat(
                    Number(ele.amount),
                    "en-IN"
                  )}</td>
                  <td width="20%" align="center"></td>
                </tr>`;
                  })
              : journalNonGstItems.map((ele) => {
                  if (ele.itemValue.editable === false)
                    return `<tr style="color:#396afc;font-weight: bold;">
                  <td width="60%"> ${ele.itemValue.ledgerAccount.label} Dr</td>
           
                  <td width="20%" align="center">${MoneyFormat(
                    Number(ele.amount),
                    "en-IN"
                  )}</td>
                  <td width="20%" align="center"></td>
                </tr>`;
                })
          }
          ${
            data.reverseChargeFlag == 0 &&
            (data.purchaseOrSalseFlag == "1"
              ? Number(totGST) > 0
                ? data.placeOfSupply !== "KeralaDistrict"
                  ? `<tr style="color:#396afc;font-weight: bold;">
                  <td width="60%">IGST Input A/C Dr</td>
                  <td width="20%" align="center">${MoneyFormat(
                    Number(totGST),
                    "en-IN"
                  )}</td>
                  <td width="20%" align="center"></td>
                </tr>`
                  : `<tr style="color:#396afc;font-weight: bold;">
                  <td width="60%">CGST Input A/C Dr</td>
                  <td width="20%" align="center">${MoneyFormat(
                    Number(totGST) / 2,
                    "en-IN"
                  )}</td>
                  <td width="20%" align="center"></td>
                </tr>
                <tr style="color:#396afc;font-weight: bold;">
                  <td width="60%">SGST Input A/C Dr</td>
                  <td width="20%" align="center">${MoneyFormat(
                    Number(totGST) / 2,
                    "en-IN"
                  )}</td>
                  <td width="20%" align="center"></td>
                </tr>`
                : ``
              : Number(totGST) > 0
              ? data.placeOfSupply !== "KeralaDistrict"
                ? `<tr style="color:#396afc;font-weight: bold;">
                  <td width="60%">IGST Output A/C Dr</td>
                  <td width="20%" align="center">${MoneyFormat(
                    Number(totGST),
                    "en-IN"
                  )}</td>
                  <td width="20%" align="center"></td>
                </tr>`
                : `<tr style="color:#396afc;font-weight: bold;">
                  <td width="60%">CGST Output A/C Dr</td>
                  <td width="20%" align="center">${MoneyFormat(
                    Number(totGST) / 2,
                    "en-IN"
                  )}</td>
                  <td width="20%" align="center"></td>
                </tr>
                <tr style="color:#396afc;font-weight: bold;">
                  <td width="60%">SGST Output A/C Dr</td>
                  <td width="20%" align="center">${MoneyFormat(
                    Number(totGST) / 2,
                    "en-IN"
                  )}</td>
                  <td width="20%" align="center"></td>
                </tr>`
              : ``)
          }
          ${
            data.reverseChargeFlag == 0 &&
            (data.purchaseOrSalseFlag == "1"
              ? Number(totGstCess) > 0
                ? `<tr style="color:#396afc;font-weight: bold;">
              <td width="60%">GST Input Additional Cess A/c Dr</td>
              <td width="20%" align="center">${MoneyFormat(
                Number(totGstCess),
                "en-IN"
              )}</td>
              <td width="20%" align="center"></td>
            </tr>`
                : ``
              : Number(totGstCess) > 0
              ? `<tr style="color:#396afc;font-weight: bold;">
              <td width="60%">GST Output Additional Cess A/c Dr</td>
              <td width="20%" align="center">${MoneyFormat(
                Number(totGstCess),
                "en-IN"
              )}</td>
              <td width="20%" align="center"></td>
            </tr>`
              : ``)
          }
          ${
            data.adjustments != ""
              ? `<tr style="color:#396afc;font-weight: bold;">
              <td width="60%">Other Adjustments Dr</td>
              <td width="20%" align="center">${MoneyFormat(
                data.adjustments,
                "en-IN"
              )}</td>
              <td width="20%" align="center"></td>
            </tr>`
              : ``
          }
          ${
            data?.partyName.value !== ""
              ? `<tr style="color:#20e0cf;font-weight: bold;">
              <td width="60%" style="padding-left: 25px;">To ${
                data?.partyName.label
              } </td>
              <td width="20%" align="center"></td>
              <td width="20%" align="center">${MoneyFormat(
                data.gstApplicable == "1"
                  ? Number(totNetAmount) + Number(data.adjustments)
                  : Number(totNonGstNetAmount) + Number(data.adjustments),
                "en-IN"
              )}</td>
            </tr>`
              : ``
          }
          ${
            data.tdsFlag == 1
              ? `<tr style="color:#20e0cf;font-weight: bold;">
            <td width="60%" style="padding-left: 25px;">To TDS Payable</td>
            <td width="20%" align="center"></td>
            <td width="20%" align="center">${MoneyFormat(
              data.tdsAmount,
              "en-IN"
            )}</td>
          </tr>`
              : ``
          }
        ${
          (data.paymentType === "Cash" || data.paymentType === "Bank") &&
          paidAccountName
            ? `
            <tr height=15px></tr>
            <tr style="color:#396afc;font-weight: bold;">
              <td width="60%">${data?.partyName.label} Dr</td>
              <td width="20%" align="center">${MoneyFormat(
                data.recordAmount,
                "en-IN"
              )}</td>
              <td width="20%" align="center"></td>
            </tr>
            <tr style="color:#20e0cf;font-weight: bold;">
              <td width="60%" style="padding-left: 25px;">To ${
                paidAccountName.label
              }</td>
              <td width="20%" align="center"></td>
              <td width="20%" align="center">${MoneyFormat(
                data.recordAmount,
                "en-IN"
              )}</td>
            </tr>`
            : ``
        }
        </tbody>
      </table>
    </body>
  </html>
  `;
  useEffect(() => {
    window.addEventListener("beforeunload", alertUser);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
    };
  }, []);
  const alertUser = (e) => {
    e.preventDefault();
    e.returnValue = "";
    alert(e.returnValue);
  };
  async function getTransactionMasterData(data) {
    try {
      const res = await API.graphql(
        graphqlOperation(getTransactionMaster, { TransactionID: data })
      );
      console.log("bank", res.data.getTransactionMaster);
      setData((prev) => ({
        ...prev,
        bankRefNo: res.data?.getTransactionMaster?.BankReferenceNumber,
      }));
    } catch (error) {
      console.log("error", error);
    }
  }
  async function getCrDrMaster(data) {
    try {
      const res = await API.graphql(
        graphqlOperation(getCrDrNoteMaster, { CrDrNoteID: data })
      );
      if (res.data?.getCrDrNoteMaster !== null) {
        setInvPartyId(res.data?.getCrDrNoteMaster.PartyID);
        setPartyID(res.data?.getCrDrNoteMaster.PartyID);
        getTransactionMasterData(res.data?.getCrDrNoteMaster.TransactionID);
        setTransId(res.data?.getCrDrNoteMaster.TransactionID);
        setCrDrId(res.data?.getCrDrNoteMaster.CrDrNoteID);
        getAdressDetailsByCrDrID(res.data?.getCrDrNoteMaster.CrDrNoteID);
        getBillAdressDetailsByCrDrID(res.data?.getCrDrNoteMaster.CrDrNoteID);
        let groupID = "";
        suppliers.map((ele) => {
          if (ele.value == res.data?.getCrDrNoteMaster.PartyID) {
            groupID = ele.accountsID;
          }
        });
        setSelectedAccountGroupId(groupID);
        let from = new Date(
          Number(res.data?.getCrDrNoteMaster.CrDrNoteDate) * 1000
        );
        let fromyy = from.getFullYear();
        let frommm = from.getMonth() + 1;
        let fromdd = from.getDate();

        if (fromdd < 10) fromdd = "0" + fromdd;
        if (frommm < 10) frommm = "0" + frommm;

        const fromDate = fromyy + "-" + frommm + "-" + fromdd;
        let optionarr = [];
        let place = "";
        suppliers.map((ele) => {
          if (ele.value == res.data?.getCrDrNoteMaster.PartyID) {
            place = `${ele.placeOfSupply}`;
          }
        });

        partyMasters.map((ele) => {
          optionarr.push({
            label:
              ele?.DisplayNameForInvFlag === "1"
                ? ele?.PartyDisplayName
                : ele?.PartyLegalName,
            value: ele.PartyID,
          });
        });
        let PartyName = { label: "", value: "" };
        optionarr.map((ele) => {
          if (ele.value == res.data.getCrDrNoteMaster.PartyID) {
            PartyName = { label: ele.label, value: ele.value };
          }
        });

        let accountsName = { label: "", value: "" };
        let partAmount = "";
        let dispatchDate = "";
        let ewayBillNo = "";
        let vehicleNo = "";
        let comments = "";
        let tranCd = "";
        let account = { label: "", value: "" };
        // let hsnobj254 = {}
        if (res.data?.getCrDrNoteMaster.RelatedCrDrNoteInvoices.length > 0) {
          setinvoiceDetails(
            res.data?.getCrDrNoteMaster.RelatedCrDrNoteInvoices
          );
        }
        if (res.data?.getCrDrNoteMaster.PaymentType === "Credit") {
          let dudt = "";
          let tempEntryDate = new Date(
            res.data?.getCrDrNoteMaster.CrDrNoteDate * 1000
          ).toLocaleDateString();
          // let tempSupplierInvoiceDate = new Date(res.data?.getCrDrNoteMaster.SupplierInvoiceDate * 1000).toLocaleDateString()
          // if (tempSupplierInvoiceDate == "") {
          dudt = moment(tempEntryDate).add(
            res.data?.getCrDrNoteMaster.CreditDuration,
            "days"
          );
          // } else {
          //   dudt = moment(tempSupplierInvoiceDate).add(res.data?.getCrDrNoteMaster.CreditDuration, "days");
          // }
          let duedate = moment(dudt._d).format("DD MMM YYYY");
          setData((prev) => ({
            ...prev,
            dueDate: duedate,
          }));
        }

        res.data.getCrDrNoteMaster.RelatedCrDrNoteDetails.map((ele) => {
          let from = new Date(Number(ele.DispatchDate) * 1000);
          let fromyy = from.getFullYear();
          let frommm = from.getMonth() + 1;
          let fromdd = from.getDate();

          if (fromdd < 10) fromdd = "0" + fromdd;
          if (frommm < 10) frommm = "0" + frommm;

          dispatchDate = fromyy + "-" + frommm + "-" + fromdd;
          partAmount = ele.PartAmount;
          ewayBillNo = ele.EWAYBillNumber;
          vehicleNo = ele.VehicleNumber;
          comments = ele.Comments.split("**");
          tranCd = ele.TransportationCD;
          // account = ele.AccountID;
          accName.map((subele) => {
            if (ele.AccountID == subele.value) {
              accountsName = { label: subele.label, value: subele.value };
            }
          });
          let IDValid = false;
          if (res.data?.getCrDrNoteMaster.PaymentType == "Cash") {
            cashAccount.map((item) => {
              if (ele.AccountID == item.value) {
                account = { label: item.label, value: item.value };
                IDValid = true;
              }
            });
          }
          if (res.data?.getCrDrNoteMaster.PaymentType == "Cash") {
            bankAccount.map((item) => {
              if (ele.AccountID == item.value) {
                account = { label: item.label, value: item.value };
                IDValid = true;
              }
            });
          }
          if (!IDValid) setPaidAccountFlag(true);
        });
        setPaidAccountFlag(false);
        setData((prev) => ({
          ...prev,
          creditNoteDate: fromDate,
          creditNote: res.data?.getCrDrNoteMaster.CrDrNoteNumber,
          partyName: PartyName,
          gstApplicable: res.data?.getCrDrNoteMaster.GSTTypeCD,
          paymentType: res.data?.getCrDrNoteMaster.PaymentType,
          creditToAccount: account,
          recordAmount: partAmount,
          dateOfDispatch: dispatchDate,
          eWayBill: ewayBillNo,
          vehicleNumber: vehicleNo,
          remarks: comments.join("\n"),
          transpotationMode: tranCd,
          placeOfSupply: place,
          creditPeriod: res.data?.getCrDrNoteMaster.CreditDuration,
          purchaseOrSalseFlag: res.data.getCrDrNoteMaster.PSFlag,
          reverseChargeFlag: res.data.getCrDrNoteMaster.ReverseChargeFlag,
        }));
      }

      if (res.data?.getCrDrNoteMaster.RelatedCrDrAttachment.length > 0) {
        let items = [];
        res.data?.getCrDrNoteMaster.RelatedCrDrAttachment.map((item, ind) => {
          items.push({
            slNo: "",
            name: item.AttachmentName,
            action: "",
            url: item.AttachmentURL,
          });
        });
        setItemsRows(items);
      }
      if (res.data?.getCrDrNoteMaster.GSTTypeCD == "1") {
        console.log(
          "res.data?.getCrDrNoteMaster.RelatedCrDrNoteLineItems",
          res.data?.getCrDrNoteMaster.RelatedCrDrNoteLineItems
        );
        if (res.data?.getCrDrNoteMaster.RelatedCrDrNoteLineItems.length > 0) {
          let arr = [];
          await Promise.all(
            res.data?.getCrDrNoteMaster.RelatedCrDrNoteLineItems.map(
              async (ele, ind) => {
                let hsnCode = {};
                let itemName = { label: "", value: "" };
                let itemcode = { label: "", value: "" };
                let hsnobj254 = {};
                hsnobj254 = await searchSACItem(ele.HSNSACCode);
                hsnCode = hsnobj254.hsnObj;
                let accountobj = {};
                if (res.data.getCrDrNoteMaster.PSFlag == "1") {
                  allItemData.map((subele) => {
                    if (ele.ItemID == subele.ItemID) {
                      ele.PurchaseAccountID = subele.PurchaseAccountID;
                    }
                  });
                } else {
                  allItemData.map((subele) => {
                    if (ele.ItemID == subele.ItemID) {
                      ele.PurchaseAccountID = subele.SalesAccountID;
                    }
                  });
                }
                accName.map((code) => {
                  if (code.value == ele.PurchaseAccountID) {
                    accountobj = { label: code.label, value: code.value };
                  }
                });

                itemsName.map((name) => {
                  if (name.value == ele.ItemID) {
                    itemName = { label: name.label, value: name.value };
                  }
                });
                itemsCode.map((item) => {
                  if (item.value == ele.ItemID) {
                    itemcode = { label: item.label, value: item.value };
                  }
                });
                arr.push({
                  itemCode: itemcode,
                  name: itemName,
                  HSN: hsnCode,
                  // HSN: { label: "", value: "" },
                  qty: ele.Quantity,
                  purchaseAccount: accountobj,
                  units: ele.UnitTypeCD,
                  rate: ele.ItemRate,
                  amount: ele.ItemAmount,
                  dicount: ele.ItemDiscount,
                  taxableAMount:
                    Number(ele.Quantity) *
                    (Number(ele.ItemRate) - Number(ele.ItemDiscount)),
                  GSTRate: ele.GSTRate,
                  IGST: "0",
                  CGST: "0",
                  SGST: "0",
                  GSTCess: ele.GSTCess,
                  netAmount: ele.NetAmount,
                  editable: false,
                  new: false,
                });
              }
            )
          );

          setItems(arr);
          setItemEditedRow({});
          setItemTempRow({});
          setItemEntry(true);

          console.log(arr);
        }
        if (
          res.data?.getCrDrNoteMaster.RelatedCrDrNoteLineNonItems.length > 0
        ) {
          let arr = [];
          await Promise.all(
            res.data?.getCrDrNoteMaster.RelatedCrDrNoteLineNonItems.map(
              async (ele, ind) => {
                let accountobj = {};
                accName.map((code) => {
                  if (code.value == ele.LedgerAccountID) {
                    accountobj = { label: code.label, value: code.value };
                  }
                });

                let hsnCode = {};
                let hsnobj254 = {};
                hsnobj254 = await searchSACItem(ele.HSNSACCode);
                hsnCode = hsnobj254.hsnObj;

                arr.push({
                  ledgerAccount: accountobj,
                  HSN: hsnCode,
                  description: ele.ItemDescription,
                  taxAMount: ele.TaxableAmount,
                  GSTRate: ele.GSTRate,
                  IGST: "0.00",
                  CGST: "0.00",
                  SGST: "0.00",
                  GSTCess: ele.GSTCess,
                  netAmount: ele.NetAmount,
                  editable: false,
                  new: false,
                });
              }
            )
          );

          console.log(arr);
          setNonItems(arr);
          setNonItemEditedRow({});
          setNonItemTempRow({});
          setItemEntry(false);

          console.log(arr);
        }
      } else {
        if (
          res.data?.getCrDrNoteMaster.RelatedCrDrNoteLineNonItems.length > 0
        ) {
          let arr = [];
          await Promise.all(
            res.data?.getCrDrNoteMaster.RelatedCrDrNoteLineNonItems.map(
              async (ele, ind) => {
                let accountobj = {};
                accName.map((code) => {
                  if (code.value == ele.LedgerAccountID) {
                    accountobj = { label: code.label, value: code.value };
                  }
                });

                arr.push({
                  ledgerAccount: accountobj,
                  HSN: 0,
                  description: ele.ItemDescription,
                  taxAMount: 0,
                  GSTRate: 0,
                  IGST: "0.00",
                  CGST: "0.00",
                  SGST: "0.00",
                  GSTCess: 0,
                  amount: ele.NetAmount,
                  editable: false,
                  new: false,
                });
              }
            )
          );

          console.log(arr);
          setNonGstItems(arr);
          setNonGstItemEditedRow({});
          setNonGstItemTempRow({});
          setItemEntry(false);

          console.log(arr);
        }
      }
    } catch (error) {
      console.log("error1111", error);
    }
    setBackdropOpen(false);
  }
  useEffect(() => {
    if (HSNCodes.length > 0 && itemsName.length > 0 && suppliers.length > 0) {
      if (params?.id) {
        setBackdropOpen(true);
        // getCrDrMaster(params?.id);
      }
    }
  }, [HSNCodes, itemsName, suppliers, accountsObj]);
  async function saveChanges(params) {
    const {
      gstApplicable,
      partyName,
      billingAddress,
      placeOfSupply,
      deliveryAddress,
      originalInvoiceDate,
      originalInvoiceNumber,
      creditNote,
      bankRefNo,
      creditNoteDate,
      paymentType,
      recordAmount,
      creditToAccount,
      purchaseOrSalseFlag,
      reverseChargeFlag,
    } = data;
    const formData = {
      gstApplicable,
      partyName,
      billingAddress,
      placeOfSupply,
      deliveryAddress,
      originalInvoiceDate,
      originalInvoiceNumber,
      bankRefNo,
      creditNoteDate,
      paymentType,
      creditToAccount,
      recordAmount,
      purchaseOrSalseFlag,
      reverseChargeFlag,
    };
    const comments = data.remarks.split("\n");
    if (formVaidation(formData)) {
      setBackdropOpen(true);
      let isvalid = true;
      let toastVal = false;
      //   if (data.gstApplicable === "1") {
      //     if (itemEntry) {
      //       if (items.length == 0) {
      //         isvalid = false;
      //         toastVal = true;
      //       } else {
      //         items.map((row) => {
      //           if (row.editable == true) {
      //             isvalid = false;
      //           }
      //         });
      //       }
      //     } else {
      //       if (nonItems.length == 0) {
      //         isvalid = false;
      //         toastVal = true;
      //       } else {
      //         nonItems.map((row) => {
      //           if (row.editable == true) {
      //             isvalid = false;
      //           }
      //         });
      //       }
      //     }
      //   } else {
      //     if (nonGstItems.length == 0) {
      //       isvalid = false;
      //       toastVal = true;
      //     } else {
      //       nonGstItems.map((row) => {
      //         if (row.editable == true) {
      //           isvalid = false;
      //         }
      //       });
      //     }
      //   }
      //   if (isvalid) {
      //     let order = 1;
      //     const transactionMasterData = {
      //       BankReferenceNumber: bankRefNo == "" ? 0 : bankRefNo,
      //       Comments: comments.join("**"),
      //       EntryDate: Math.floor(new Date(creditNoteDate).getTime() / 1000),
      //       TransactionTypeCD: "CreditNote",
      //     };
      //     const restransactionMaster = await API.graphql(
      //       graphqlOperation(createTransactionMaster, {
      //         createTransactionMasterInput: transactionMasterData,
      //       })
      //     );

      //     const creditMasterData = {
      //       CrDrNoteDate: Math.floor(new Date(creditNoteDate).getTime() / 1000),
      //       CrDrNoteTypeCD: "CreditNote",
      //       DeliveryAddressID:
      //         partyAddressEntity == null ? 0 : partyAddressEntity.ID,
      //       GSTTypeCD: gstApplicable,
      //       GrandTotalAmount:
      //         Number(totNetAmount.toFixed(2)) + Number(data.adjustments),
      //       InvoiceTypeCD: "",
      //       CreditDuration: data.creditPeriod === "" ? 0 : data.creditPeriod,
      //       PartyID: partyName.value,
      //       PaymentType: paymentType,
      //       TransactionID:
      //         restransactionMaster.data.createTransactionMaster.TransactionID,
      //       PSFlag: purchaseOrSalseFlag,
      //       ReverseChargeFlag: reverseChargeFlag,
      //     };
      //     const resCreditMasterData = await API.graphql(
      //       graphqlOperation(createCrDrNoteMaster, {
      //         createCrDrNoteMasterInput: creditMasterData,
      //       })
      //     );
      //     setCreditNoteNumber(
      //       resCreditMasterData.data.createCrDrNoteMaster.CrDrNoteNumber
      //     );
      //     const creditDetailsData = {
      //       AccountID:
      //         creditToAccount.value == undefined ? "" : creditToAccount.value,
      //       Comments: comments.join("**"),
      //       CrDrNoteID: resCreditMasterData.data.createCrDrNoteMaster.CrDrNoteID,
      //       DispatchDate:
      //         data.dateOfDispatch === ""
      //           ? 0
      //           : Math.floor(new Date(data.dateOfDispatch).getTime() / 1000),
      //       EWAYBillNumber: data.eWayBill,
      //       PartAmount: recordAmount === "" ? 0 : recordAmount,
      //       TotalAdjustments: data.adjustments === "" ? 0 : data.adjustments,
      //       TotalGST: totGST,
      //       TotalGSTCess: totGstCess,
      //       TotalTaxableAmount: totTaxableAmount,
      //       TransportationCD: data.transpotationMode,
      //       VehicleNumber: data.vehicleNumber,
      //     };
      //     const rescreditDetailsData = await API.graphql(
      //       graphqlOperation(createCrDrNoteDetails, {
      //         createCrDrNoteDetailsInput: creditDetailsData,
      //       })
      //     );
      //     let imageData = {};
      //     let attachmentId = Math.floor(Math.random() * 1000 + 1);
      //     itemsRows.map(async (ele) => {
      //       imageData = {
      //         AttachmentID: attachmentId,
      //         AttachmentName: ele.name,
      //         AttachmentURL: ele.url,
      //         CrDrNoteID:
      //           resCreditMasterData.data.createCrDrNoteMaster.CrDrNoteID,
      //       };
      //       const resImageData = await API.graphql(
      //         graphqlOperation(createCrDrAttachment, {
      //           createCrDrAttachmentInput: imageData,
      //         })
      //       );
      //     });
      //     let creditInvoiceData = {};
      //     data.originalInvoiceNumber.map(async (ele) => {
      //       creditInvoiceData = {
      //         CrDrNoteID:
      //           resCreditMasterData.data.createCrDrNoteMaster.CrDrNoteID,
      //         InvoiceID: ele.value === "" ? 0 : ele.value,
      //       };
      //       const resCreditInvoiceData = await API.graphql(
      //         graphqlOperation(createCrDrNoteInvoices, {
      //           createCrDrNoteInvoicesInput: creditInvoiceData,
      //         })
      //       );
      //     });
      //     if (data.gstApplicable == "1") {
      //       if (itemEntry) {
      //         let lineItemsData = {};
      //         items?.map(async (ele, index) => {
      //           lineItemsData = {
      //             CrDrNoteID:
      //               resCreditMasterData.data.createCrDrNoteMaster.CrDrNoteID,
      //             CrDrNoteItemID: 1,
      //             GSTAmount: 0,
      //             GSTRate: ele.GSTRate == "" ? 0 : ele.GSTRate,
      //             GSTTypeCD: data.gstApplicable === "yes" ? 1 : 2,
      //             GSTCess: ele.GSTCess,
      //             HSNSACCode: ele.HSN.value == "" ? 0 : ele.HSN.value,
      //             ItemAmount: ele.amount,
      //             ItemDiscount: Number(ele.dicount),
      //             ItemID: ele.name.value == "" ? 0 : ele.name.value,
      //             ItemRate: Number(ele.rate),
      //             LineItemNumber: index,
      //             LineItemType: "LINE",
      //             NetAmount: ele.netAmount,
      //             Quantity: Number(ele.qty),
      //             UnitTypeCD: ele.units,
      //           };
      //           const resLineItemsData = await API.graphql(
      //             graphqlOperation(createCrDrNoteLineItems, {
      //               createCrDrNoteLineItemsInput: lineItemsData,
      //             })
      //           );
      //         });
      //       } else {
      //         let nonItemsData = {};
      //         nonItems.map(async (ele) => {
      //           nonItemsData = {
      //             CrDrNoteID:
      //               resCreditMasterData.data.createCrDrNoteMaster.CrDrNoteID,
      //             CrDrNoteItemID: 1,
      //             HSNSACCode: ele.HSN.value === "" ? 0 : ele.HSN.value,
      //             GSTAmount: 0,
      //             GSTRate: ele.GSTRate,
      //             GSTCess: ele.GSTCess,
      //             GSTTypeCD: data.gstApplicable === "yes" ? 1 : 2,
      //             ItemDescription: ele.description,
      //             LedgerAccountID: ele.ledgerAccount.value,
      //             LineItemType: "NONELINE",
      //             NetAmount: ele.netAmount,
      //             TaxableAmount: ele.taxAMount,
      //           };
      //           const resNonItemsData = await API.graphql(
      //             graphqlOperation(createCrDrNoteLineNonItems, {
      //               createCrDrNoteLineNonItemsInput: nonItemsData,
      //             })
      //           );
      //         });
      //       }
      //     } else {
      //       let nonGsTData = {};
      //       nonGstItems.map(async (ele) => {
      //         nonGsTData = {
      //           CrDrNoteID:
      //             resCreditMasterData.data.createCrDrNoteMaster.CrDrNoteID,
      //           CrDrNoteItemID: 1,
      //           HSNSACCode: 0,
      //           GSTAmount: 0,
      //           GSTRate: 0,
      //           GSTTypeCD: 2,
      //           ItemDescription: ele.description,
      //           LedgerAccountID: ele.ledgerAccount.value,
      //           LineItemType: "NONLINE",
      //           NetAmount: ele.amount,
      //           TaxableAmount: 0,
      //           GSTCess: 0,
      //         };

      //         const resNonGstItemsData = await API.graphql(
      //           graphqlOperation(createCrDrNoteLineNonItems, {
      //             createCrDrNoteLineNonItemsInput: nonGsTData,
      //           })
      //         );
      //       });
      //     }

      //     // saveAddressDetails(
      //     //   resCreditMasterData.data.createCrDrNoteMaster.CrDrNoteID
      //     // );
      //     // addTransactionDetails(
      //     //   restransactionMaster.data.createTransactionMaster.TransactionID
      //     // );
      //     localStorage.setItem("saveEvent", true);
      //     if (params.print != true) {
      //       handlePrint(
      //         resCreditMasterData.data.createCrDrNoteMaster.CrDrNoteNumber
      //       );
      //     //   if (ModalEvent == true) {
      //     //     handleClose();
      //     //   } else {
      //     //     navigate("/alldebitnote");
      //     //   }
      //     } else {
      //       navigate("/allcreditnote");
      //     }
      //   } else {
      //     if (toastVal) {
      //       setEntrySnakbar(true);
      //       setBackdropOpen(false);
      //     } else {
      //       setWarningMessage("Please complete your action in Entry Table");
      //       setBackdropOpen(false);
      //       setCompleteSnakbar(true);
      //     }
      //   }
    } else {
      setErrorArr({ ...data.errorStatus });
    }
  }
  async function addTransactionDetails(transactionID) {
    try {
      let order = 1;
      const partyEntry = {
        AccountID: selectedGroupId,
        Comments: data.remarks,
        CreditAmount: (
          Number(totNetAmount.toFixed(2)) + Number(data.adjustments)
        ).toFixed(2),
        DebitAmount: 0,
        EntryOrderNumber: order,
        TransactionID: transactionID,
        TransactionTypeCD: "Credit",
      };
      order = order + 1;

      const resPartyEntry = await API.graphql(
        graphqlOperation(createTransactionDetails, {
          createTransactionDetailsInput: partyEntry,
        })
      );

      if (itemEntry) {
        items.length !== 0 &&
          items.map(async (item, ind) => {
            let itemEntryObj = {
              AccountID:
                data.purchaseOrSalseFlag == "1"
                  ? item.purchaseAccount.value
                  : "SAL2",
              Comments: "",
              CreditAmount: 0,
              DebitAmount: Number(item.taxableAMount).toFixed(2),
              EntryOrderNumber: order,
              TransactionID: transactionID,
              TransactionTypeCD: "Debit",
            };
            order = order + 1;
            console.log("itemEntryObj", itemEntryObj);
            const resitemEntryObj = await API.graphql(
              graphqlOperation(createTransactionDetails, {
                createTransactionDetailsInput: itemEntryObj,
              })
            );
          });
      } else {
        nonItems.length !== 0 &&
          nonItems.map(async (item, ind) => {
            let nonItemEntryObj = {
              AccountID: item.ledgerAccount.value,
              Comments: item.description,

              CreditAmount: 0,
              DebitAmount: Number(item.taxAMount).toFixed(2),

              EntryOrderNumber: order,
              TransactionID: transactionID,
              TransactionTypeCD: "Debit",
            };
            order = order + 1;

            const resnonitemEntryObj = await API.graphql(
              graphqlOperation(createTransactionDetails, {
                createTransactionDetailsInput: nonItemEntryObj,
              })
            );
          });
      }
      if (data.placeOfSupply === "KeralaDistrict") {
        const cgstEntry = {
          AccountID: "CGSTI",
          Comments: "",
          CreditAmount: 0,
          DebitAmount: (Number(totGST) / 2).toFixed(2),
          EntryOrderNumber: order,

          TransactionID: transactionID,
          TransactionTypeCD: "Debit",
        };
        order = order + 1;
        const sgstEntry = {
          AccountID: "SGSTI",
          Comments: "",
          CreditAmount: 0,
          DebitAmount: (Number(totGST) / 2).toFixed(2),
          EntryOrderNumber: order,
          TransactionID: transactionID,
          TransactionTypeCD: "Debit",
        };
        order = order + 1;
        const rescgstEntry = await API.graphql(
          graphqlOperation(createTransactionDetails, {
            createTransactionDetailsInput: cgstEntry,
          })
        );

        const ressgstEntry = await API.graphql(
          graphqlOperation(createTransactionDetails, {
            createTransactionDetailsInput: sgstEntry,
          })
        );
      } else {
        const igstEntry = {
          AccountID: "IGSTI",
          Comments: "",
          CreditAmount: 0,
          DebitAmount: Number(totGST).toFixed(2),
          EntryOrderNumber: order,
          TransactionID: transactionID,
          TransactionTypeCD: "Debit",
        };
        order = order + 1;
        console.log("igstEntry", igstEntry);
        const resigstEntry = await API.graphql(
          graphqlOperation(createTransactionDetails, {
            createTransactionDetailsInput: igstEntry,
          })
        );
      }
      if (totGstCess !== 0) {
        const gstCessEntry = {
          AccountID: "GSTIC",
          Comments: "",
          CreditAmount: 0,
          DebitAmount: Number(totGstCess).toFixed(2),
          EntryOrderNumber: order,
          TransactionID: transactionID,
          TransactionTypeCD: "Credit",
        };
        order = order + 1;
        console.log("gstCessEntry", gstCessEntry);
        const resgstCessEntry = await API.graphql(
          graphqlOperation(createTransactionDetails, {
            createTransactionDetailsInput: gstCessEntry,
          })
        );
      }
      if (Number(data.adjustments) > 0) {
        const adjustmentsEntry = {
          AccountID: "GSTIAC",
          Comments: "",
          CreditAmount: 0,
          DebitAmount: Number(data.adjustments).toFixed(2),
          EntryOrderNumber: order,
          TransactionID: transactionID,
          TransactionTypeCD: "Debit",
        };
        order = order + 1;

        const resadjustmentsEntry = await API.graphql(
          graphqlOperation(createTransactionDetails, {
            createTransactionDetailsInput: adjustmentsEntry,
          })
        );
      }

      if (data.paymentType === "Cash" || data.paymentType === "Bank") {
        const cashBankEntry = {
          AccountID: data.creditToAccount.value,
          Comments: "",
          CreditAmount: Number(data.recordAmount).toFixed(2),
          DebitAmount: 0,
          EntryOrderNumber: order,
          TransactionID: transactionID,
          TransactionTypeCD: "Credit",
        };
        order = order + 1;

        const rescashBankEntry = await API.graphql(
          graphqlOperation(createTransactionDetails, {
            createTransactionDetailsInput: cashBankEntry,
          })
        );

        const bankcashEntry = {
          AccountID: selectedGroupId,
          Comments: "",
          CreditAmount: 0,
          DebitAmount: Number(data.recordAmount).toFixed(2),
          EntryOrderNumber: order,
          TransactionID: transactionID,
          TransactionTypeCD: "Debit",
        };
        order = order + 1;

        const resbankcashEntry = await API.graphql(
          graphqlOperation(createTransactionDetails, {
            createTransactionDetailsInput: bankcashEntry,
          })
        );
      }
    } catch (error) {
      console.log("error", error);
    }
  }
  async function saveAddressDetails(CrDrNoteID) {
    try {
      let add =
        deliveryAddressDetails?.deliveryAddress !== ""
          ? deliveryAddressDetails?.deliveryAddress.split("\n")
          : data.deliveryAddress?.split("\n");
      const addressDetails = {
        City:
          deliveryAddressDetails?.district != ""
            ? deliveryAddressDetails?.district
            : partyAddressEntity?.City,
        CountryCode:
          deliveryAddressDetails?.country != ""
            ? deliveryAddressDetails?.country
            : partyAddressEntity?.CountryCode,
        Line1: add.join("**"),
        Line2: "",
        Line3: "",
        ObjectID: CrDrNoteID,
        ObjectType: "CreditDelivery",
        PINCode:
          deliveryAddressDetails?.pincode != ""
            ? deliveryAddressDetails?.pincode
            : partyAddressEntity?.PINCode,
        StateCode:
          deliveryAddressDetails?.states != ""
            ? deliveryAddressDetails?.states
            : partyAddressEntity?.StateCode,
      };
      const resPartyAddressEntity = await API.graphql(
        graphqlOperation(createPartyAddressEntity, {
          createPartyAddressEntityInput: addressDetails,
        })
      );

      let billAdd =
        billingAddressDetails?.billingAddress !== ""
          ? billingAddressDetails?.billingAddress.split("\n")
          : data.billingAddress?.split("\n");
      const billaddressDetails = {
        City:
          billingAddressDetails?.district != ""
            ? billingAddressDetails?.district
            : partyBillAddressEntity?.City,
        CountryCode:
          billingAddressDetails?.country != ""
            ? billingAddressDetails?.country
            : partyBillAddressEntity?.CountryCode,
        Line1: billAdd.join("**"),
        Line2: "",
        Line3: "",
        ObjectID: CrDrNoteID,
        ObjectType: "CreditBilling",
        PINCode:
          billingAddressDetails?.pincode != ""
            ? billingAddressDetails?.pincode
            : partyBillAddressEntity.PINCode,
        StateCode:
          billingAddressDetails?.states != ""
            ? billingAddressDetails?.states
            : partyBillAddressEntity?.StateCode,
      };
      const resBillAddressEntity = await API.graphql(
        graphqlOperation(createPartyAddressEntity, {
          createPartyAddressEntityInput: billaddressDetails,
        })
      );
    } catch (error) {}
  }
  async function updateAddressDetails(CrDrId) {
    try {
      let add =
        deliveryAddressDetails?.deliveryAddress !== ""
          ? deliveryAddressDetails?.deliveryAddress.split("\n")
          : data.deliveryAddress.split("\n");
      const addressDetails = {
        City:
          deliveryAddressDetails.district != ""
            ? deliveryAddressDetails.district
            : partyAddressEntity?.City,
        CountryCode:
          deliveryAddressDetails.country != ""
            ? deliveryAddressDetails.country
            : partyAddressEntity?.CountryCode,
        Line1: add.join("**"),
        Line2: "",
        Line3: "",
        ObjectID: CrDrId,
        ObjectType: "CreditDelivery",
        PINCode:
          deliveryAddressDetails.pincode != ""
            ? deliveryAddressDetails.pincode
            : partyAddressEntity?.PINCode,
        StateCode:
          deliveryAddressDetails?.states != ""
            ? deliveryAddressDetails?.states
            : partyAddressEntity?.StateCode,
      };
      const resPartyAddressEntity = await API.graphql(
        graphqlOperation(updatePartyAddressEntity, {
          updatePartyAddressEntityInput: addressDetails,
        })
      );
      let billAdd =
        billingAddressDetails?.billingAddress !== ""
          ? billingAddressDetails?.billingAddress.split("\n")
          : data.billingAddress.split("\n");
      const billaddressDetails = {
        City:
          billingAddressDetails.district != ""
            ? billingAddressDetails.district
            : partyBillAddressEntity?.City,
        CountryCode:
          billingAddressDetails.country != ""
            ? billingAddressDetails.country
            : partyBillAddressEntity?.CountryCode,
        Line1: billAdd.join("**"),
        Line2: "",
        Line3: "",
        ObjectID: CrDrId,
        ObjectType: "CreditBilling",
        PINCode:
          billingAddressDetails.pincode != ""
            ? billingAddressDetails.pincode
            : partyBillAddressEntity?.PINCode,
        StateCode:
          billingAddressDetails.states != ""
            ? billingAddressDetails.states
            : partyBillAddressEntity?.StateCode,
      };
      const resBillAddressEntity = await API.graphql(
        graphqlOperation(updatePartyAddressEntity, {
          updatePartyAddressEntityInput: billaddressDetails,
        })
      );
    } catch (error) {}
  }
  async function saveEditChanges() {
    const {
      gstApplicable,
      partyName,
      billingAddress,
      placeOfSupply,
      deliveryAddress,
      originalInvoiceDate,
      originalInvoiceNumber,
      creditNoteDate,
      creditPeriod,
      paymentType,
      bankRefNo,
      recordAmount,
      creditToAccount,
      purchaseOrSalseFlag,
      reverseChargeFlag,
    } = data;
    const formData = {
      gstApplicable,
      partyName,
      billingAddress,
      placeOfSupply,
      deliveryAddress,
      originalInvoiceDate,
      originalInvoiceNumber,
      creditPeriod,
      bankRefNo,
      creditNoteDate,
      paymentType,
      creditToAccount,
      recordAmount,
      purchaseOrSalseFlag,
      reverseChargeFlag,
    };
    const comments = data.remarks.split("\n");
    if (formVaidation(formData)) {
      setBackdropOpen(true);
      let isvalid = true;
      let toastVal = false;
      //   if (data.gstApplicable === "1") {
      //     if (itemEntry) {
      //       if (items.length == 0) {
      //         isvalid = false;
      //         toastVal = true;
      //       } else {
      //         items.map((row) => {
      //           if (row.editable == true) {
      //             isvalid = false;
      //           }
      //         });
      //       }
      //     } else {
      //       if (nonItems.length == 0) {
      //         isvalid = false;
      //         toastVal = true;
      //       } else {
      //         nonItems.map((row) => {
      //           if (row.editable == true) {
      //             isvalid = false;
      //           }
      //         });
      //       }
      //     }
      //   } else {
      //     if (nonGstItems.length == 0) {
      //       isvalid = false;
      //       toastVal = true;
      //     } else {
      //       nonGstItems.map((row) => {
      //         if (row.editable == true) {
      //           isvalid = false;
      //         }
      //       });
      //     }
      //   }
      //   if (isvalid) {
      //     let order = 1;
      //     const updateTransmasterData = {
      //       BankReferenceNumber: bankRefNo == "" ? 0 : bankRefNo,
      //       EntryDate: Math.floor(new Date(creditNoteDate).getTime() / 1000),
      //       Comments: comments.join("**"),
      //       TransactionID: transId,
      //       VoucherNumber: data.creditNote,
      //       TransactionTypeCD: "CreditNote",
      //     };
      //     const updateTransmaster = await API.graphql(
      //       graphqlOperation(updateTransactionMaster, {
      //         updateTransactionMasterInput: updateTransmasterData,
      //       })
      //     );

      //     const CrDrMasterData = {
      //       CrDrNoteDate: Math.floor(new Date(creditNoteDate).getTime() / 1000),
      //       CrDrNoteID: CrDrId,
      //       CrDrNoteTypeCD: "CreditNote",
      //       DeliveryAddressID:
      //         partyAddressEntity == null ? 0 : partyAddressEntity.ID,
      //       GSTTypeCD: gstApplicable,
      //       GrandTotalAmount:
      //         Number(totNetAmount.toFixed(2)) + Number(data.adjustments),
      //       InvoiceTypeCD: "",
      //       CreditDuration: data.creditPeriod === "" ? 0 : data.creditPeriod,
      //       PartyID: partyName.value,
      //       PaymentType: paymentType,
      //       TransactionID: transId,
      //       PSFlag: purchaseOrSalseFlag,
      //       ReverseChargeFlag: reverseChargeFlag,
      //     };
      //     const updateCrDrmaster = await API.graphql(
      //       graphqlOperation(updateCrDrNoteMaster, {
      //         updateCrDrNoteMasterInput: CrDrMasterData,
      //       })
      //     );
      //     const CrDrDetailsData = {
      //       AccountID:
      //         creditToAccount.value == undefined ? "" : creditToAccount.value,
      //       Comments: comments.join("**"),
      //       CrDrNoteID: CrDrId,
      //       DispatchDate:
      //         data.dateOfDispatch === ""
      //           ? 0
      //           : Math.floor(new Date(data.dateOfDispatch).getTime() / 1000),
      //       EWAYBillNumber: data.eWayBill,
      //       PartAmount: recordAmount === "" ? 0 : recordAmount,
      //       TotalAdjustments: data.adjustments === "" ? 0 : data.adjustments,
      //       TotalGST: totGST,
      //       TotalGSTCess: totGstCess,
      //       TotalTaxableAmount: totTaxableAmount,
      //       TransportationCD: data.transpotationMode,
      //       VehicleNumber: data.vehicleNumber,
      //     };
      //     const updateCrDrDetails = await API.graphql(
      //       graphqlOperation(updateCrDrNoteDetails, {
      //         updateCrDrNoteDetailsInput: CrDrDetailsData,
      //       })
      //     );
      //     let CrDrInvoiceData = {};
      //     const deleteInvoiceData = await API.graphql(
      //       graphqlOperation(deleteCrDrNoteInvoices, {
      //         CrDrNoteID: CrDrId,
      //       })
      //     );
      //     data.originalInvoiceNumber.map(async (ele) => {
      //       CrDrInvoiceData = {
      //         CrDrNoteID: CrDrId,
      //         InvoiceID: ele.value === "" ? 0 : ele.value,
      //       };
      //       const updateCrDrInvoice = await API.graphql(
      //         graphqlOperation(createCrDrNoteInvoices, {
      //           createCrDrNoteInvoicesInput: CrDrInvoiceData,
      //         })
      //       );
      //     });
      //     const deleteAttach = await API.graphql(
      //       graphqlOperation(deleteCrDrAttachment, {
      //         CrDrNoteID: CrDrId,
      //       })
      //     );
      //     let imageData = {};
      //     let attachmentId = Math.floor(Math.random() * 1000 + 1);
      //     itemsRows.map(async (ele) => {
      //       imageData = {
      //         AttachmentID: attachmentId,
      //         AttachmentName: ele.name,
      //         AttachmentURL: ele.url,
      //         CrDrNoteID: CrDrId,
      //       };
      //       const resImageData = await API.graphql(
      //         graphqlOperation(createCrDrAttachment, {
      //           createCrDrAttachmentInput: imageData,
      //         })
      //       );
      //     });
      //     console.log(deleteAttach);
      //     const deletelineItemsData = await API.graphql(
      //       graphqlOperation(deleteCrDrNoteLineItems, {
      //         CrDrNoteID: CrDrId,
      //       })
      //     );
      //     const deletenonItemsData = await API.graphql(
      //       graphqlOperation(deleteCrDrNoteLineNonItems, {
      //         CrDrNoteID: CrDrId,
      //       })
      //     );
      //     if (data.gstApplicable == "1") {
      //       if (itemEntry) {
      //         let lineItemsData = {};
      //         items?.map(async (ele, index) => {
      //           lineItemsData = {
      //             CrDrNoteID: CrDrId,
      //             CrDrNoteItemID: 1,
      //             GSTAmount: 0,
      //             GSTRate: ele.GSTRate == "" ? 0 : ele.GSTRate,
      //             GSTTypeCD: data.gstApplicable === "yes" ? 1 : 2,
      //             GSTCess: ele.GSTCess == "" ? 0 : ele.GSTCess,
      //             HSNSACCode: ele.HSN.value == "" ? 0 : ele.HSN.value,
      //             ItemAmount: ele.amount,
      //             ItemDiscount: Number(ele.dicount),
      //             ItemID: ele.name.value == "" ? 0 : ele.name.value,
      //             ItemRate: Number(ele.rate),
      //             LineItemNumber: index,
      //             LineItemType: "LINE",
      //             NetAmount: ele.netAmount,
      //             Quantity: Number(ele.qty),
      //             UnitTypeCD: ele.units,
      //           };

      //           const resLineItemsData = await API.graphql(
      //             graphqlOperation(createCrDrNoteLineItems, {
      //               createCrDrNoteLineItemsInput: lineItemsData,
      //             })
      //           );
      //         });
      //       } else {
      //         let nonItemsData = {};
      //         nonItems.map(async (ele) => {
      //           nonItemsData = {
      //             CrDrNoteID: CrDrId,
      //             CrDrNoteItemID: 1,
      //             HSNSACCode: ele.HSN.value === "" ? 0 : ele.HSN.value,
      //             GSTAmount: 0,
      //             GSTRate: ele.GSTRate,
      //             GSTCess: ele.GSTCess == "" ? 0 : ele.GSTCess,
      //             GSTTypeCD: data.gstApplicable === "yes" ? 1 : 2,
      //             ItemDescription: ele.description,
      //             LedgerAccountID: ele.ledgerAccount.value,
      //             LineItemType: "NONELINE",
      //             NetAmount: ele.netAmount,
      //             TaxableAmount: ele.taxAMount,
      //           };

      //           const resNonItemsData = await API.graphql(
      //             graphqlOperation(createCrDrNoteLineNonItems, {
      //               createCrDrNoteLineNonItemsInput: nonItemsData,
      //             })
      //           );
      //         });
      //       }
      //     } else {
      //       let nonGstData = {};
      //       nonGstItems.map(async (ele) => {
      //         nonGstData = {
      //           CrDrNoteID: CrDrId,
      //           CrDrNoteItemID: 0,
      //           HSNSACCode: 0,
      //           GSTAmount: 0,
      //           GSTRate: 0,
      //           GSTTypeCD: data.gstApplicable === "yes" ? 1 : 2,
      //           GSTCess: 0,
      //           ItemDescription: ele.description,
      //           LedgerAccountID: ele.ledgerAccount.value,
      //           LineItemType: "",
      //           NetAmount: ele.amount,
      //           TaxableAmount: 0,
      //         };

      //         const resNonGstItemsData = await API.graphql(
      //           graphqlOperation(createCrDrNoteLineNonItems, {
      //             createCrDrNoteLineNonItemsInput: nonGstData,
      //           })
      //         );
      //       });
      //     }

      //     updateAddressDetails(CrDrId);

      //     const deleteTrans = await API.graphql(
      //       graphqlOperation(deleteTransactionDetails, {
      //         TransactionID: transId,
      //       })
      //     );
      //     if (deleteTrans.data.deleteTransactionDetails !== null) {
      //       addTransactionDetails(transId);
      //     }
      //     localStorage.setItem("updateEvent", true);
      //     navigate("/allcreditnote");
      //   } else {
      //     if (toastVal) {
      //       setEntrySnakbar(true);
      //       setBackdropOpen(false);
      //     } else {
      //       setWarningMessage("Please complete your action in Entry Table");
      //       setBackdropOpen(false);
      //       setCompleteSnakbar(true);
      //     }
      //   }
    } else {
      setErrorArr({ ...data.errorStatus });
    }
  }
  function importFile(e, rowindex) {
    if (e.target.files[0]) {
      if (Number(e.target.files[0]?.size) <= 1048576) {
        setBackdropOpen(true);
        try {
          let data = "";
          let config = {
            method: "post",
            url: `https://7sunotu86c.execute-api.us-east-1.amazonaws.com/Prod/api/PresignedURL/PreSignedUrl?filename=${e.target.files[0].name}&contentType=${e.target.files[0].type}`,
            // url: `https://xd8ts5ub3e.execute-api.us-east-1.amazonaws.com/Prod/api/PreSigned/PreSignedUrl?filename=${e.target.files[0].name}&contentType=${e.target.files[0].type}`,
            headers: {},
            data: data,
          };

          axios(config)
            .then(function (response) {
              //console.log('res :::: ', response.data);
              let config2 = {
                method: "put",
                url: response.data,
                headers: {
                  "Content-Type": `${e.target.files[0].type}`,
                },
                data: e.target.files[0],
              };

              axios(config2)
                .then(function (res) {
                  setImageName(e.target.files[0].name);
                  // setUploadedFile((prev) => [...prev, e.target.files[0].name]);

                  let arr = [...itemsRows];
                  arr[
                    rowindex
                  ].url = `https://ledgerx365.s3.amazonaws.com/${e.target.files[0].name}`;

                  setItemsRows(arr);
                  console.log("arr", arr);
                  setBackdropOpen(false);
                  //console.log('res in upload :::: ', JSON.stringify(res.data));
                })
                .catch(function (error) {
                  setBackdropOpen(false);
                  console.log("error in upload ::: ", error);
                });
            })
            .catch(function (error) {
              setBackdropOpen(false);
              console.log("errr ::: ", error);
            });
        } catch (e) {
          console.log("error ::: ", e);
        }
      } else {
        setCompleteSnakbar(true);
        setWarningMessage("File size should be less than 1MB");
      }
    }
  }
  function formVaidation(objData) {
    let isvalid = true;
    let obj = { ...data };

    Object.keys(objData).map((itemKey) => {
      if (itemKey === "gstApplicable") {
        if (objData[itemKey].trim().length <= 0) {
          isvalid = false;
          obj.errorFields.gstApplicable = "GST Applicable is required";
          obj.errorStatus.gstApplicable = true;
        } else {
          // isvalid=true;
          obj.errorFields.gstApplicable = "";
          obj.errorStatus.gstApplicable = false;
        }
      }

      if (itemKey === "purchaseOrSalseFlag") {
        if (objData[itemKey].length == 0 || objData[itemKey] == "") {
          isvalid = false;
          obj.errorFields.purchaseOrSalseFlag =
            "Please Select Purchase or Additional Sales";
          obj.errorStatus.purchaseOrSalseFlag = true;
        } else {
          // isvalid=true;
          obj.errorFields.purchaseOrSalseFlag = "";
          obj.errorStatus.purchaseOrSalseFlag = false;
        }
      }

      if (itemKey === "partyName") {
        if (objData[itemKey].value.length <= 0) {
          isvalid = false;
          obj.errorFields.partyName = "Party Name is required";
          obj.errorStatus.partyName = true;
        } else {
          obj.errorFields.partyName = "";
          obj.errorStatus.partyName = false;
        }
      }
      if (itemKey === "remarks") {
        if (obj.errorStatus.partyName == false) {
          if (objData[itemKey].trim().length <= 0) {
            isvalid = false;
            obj.errorFields.remarks = "Comments/Remarks is required";
            obj.errorStatus.remarks = true;
          } else if (objData[itemKey].trim().length > 150) {
            isvalid = false;
            obj.errorFields.remarks =
              "Comments/Remarks should be less than 150 characters";
            obj.errorStatus.remarks = true;
          } else {
            obj.errorFields.remarks = "";
            obj.errorStatus.remarks = false;
          }
        }
      }
      if (itemKey === "creditNoteDate") {
        if (obj.errorStatus.partyName == false) {
          if (objData[itemKey].trim().length <= 0) {
            isvalid = false;
            obj.errorFields.creditNoteDate = "Invoice Date is required";
            obj.errorStatus.creditNoteDate = true;
          } else {
            obj.errorFields.creditNoteDate = "";
            obj.errorStatus.creditNoteDate = false;
          }
        }
      }
      if (itemKey === "paymentType") {
        if (obj.errorStatus.partyName == false) {
          if (objData[itemKey].trim().length <= 0) {
            isvalid = false;
            obj.errorFields.paymentType = "Payment Type is required";
            obj.errorStatus.paymentType = true;
          } else {
            obj.errorFields.paymentType = "";
            obj.errorStatus.paymentType = false;
          }
        }
      }
      if (itemKey === "recordAmount") {
        let total =
          objData["gstApplicable"] == "1" ? totNetAmount : totNonGstNetAmount;
        if (
          objData["paymentType"] == "Cash" ||
          objData["paymentType"] == "Bank"
        ) {
          if (objData[itemKey] == 0) {
            isvalid = false;
            obj.errorFields.recordAmount = "Record Amount is required";
            obj.errorStatus.recordAmount = true;
          } else if (
            !new RegExp(/^(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/).test(
              objData[itemKey]
            )
          ) {
            isvalid = false;
            obj.errorFields.recordAmount = "Invalid Amount Format";
            obj.errorStatus.recordAmount = true;
          } else if (
            Number(objData[itemKey]) >
            Number(total) + Number(data.adjustments)
          ) {
            isvalid = false;
            obj.errorFields.recordAmount =
              "Amount should be less than Grand Total.";
            obj.errorStatus.recordAmount = true;
          } else {
            obj.errorFields.recordAmount = "";
            obj.errorStatus.recordAmount = false;
          }
        }
      }
      if (itemKey === "creditToAccount") {
        if (
          objData["paymentType"] == "Cash" ||
          objData["paymentType"] == "Bank"
        ) {
          if (objData[itemKey] == "") {
            isvalid = false;
            obj.errorFields.creditToAccount = "Received To Account is required";
            obj.errorStatus.creditToAccount = true;
          } else {
            obj.errorFields.creditToAccount = "";
            obj.errorStatus.creditToAccount = false;
          }
        }
      }
      if (itemKey === "creditPeriod") {
        if (objData["paymentType"] == "Credit") {
          if (objData[itemKey] > 1000 || objData[itemKey] < 0) {
            isvalid = false;
            obj.errorFields.creditPeriod =
              "Credit period should between 0 and 1000";
            obj.errorStatus.creditPeriod = true;
          } else {
            obj.errorFields.creditPeriod = "";
            obj.errorStatus.creditPeriod = false;
          }
        }
      }
      if (itemKey === "bankRefNo") {
        if (objData["paymentType"] == "Bank") {
          if (objData[itemKey].trim().length <= 0) {
            isvalid = false;
            obj.errorFields.bankRefNo = "Bank Reference Number is required";
            obj.errorStatus.bankRefNo = true;
          } else if (!new RegExp(/^\d{9,18}$/).test(objData[itemKey])) {
            isvalid = false;
            obj.errorFields.bankRefNo = "Invalid Bank Reference Number ";
            obj.errorStatus.bankRefNo = true;
          } else {
            obj.errorFields.bankRefNo = "";
            obj.errorStatus.bankRefNo = false;
          }
        }
      }

      if (itemKey === "adjustments") {
        let total =
          data.gstApplicable == "1"
            ? Number(totNetAmount) + Number(data.adjustments)
            : Number(totNonGstNetAmount) + Number(data.adjustments);
        if (
          !new RegExp(/^[+-]?(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/).test(
            objData[itemKey]
          ) &&
          objData[itemKey].trim().length > 0
        ) {
          isvalid = false;
          obj.errorFields.adjustments = "Invalid Amount Format";
          obj.errorStatus.adjustments = true;
        } else if (total < 0) {
          isvalid = false;
          obj.errorFields.adjustments =
            "Grand Total  should not be -ve please adjust amount correctly";
          obj.errorStatus.adjustments = true;
        } else {
          obj.errorFields.adjustments = "";
          obj.errorStatus.adjustments = false;
        }
      }

      if (itemKey === "placeOfSupply") {
        if (obj.errorStatus.partyName == false) {
          if (objData[itemKey].trim().length <= 0) {
            isvalid = false;
            obj.errorFields.placeOfSupply = "Place Of Supply is required";
            obj.errorStatus.placeOfSupply = true;
          } else {
            obj.errorFields.placeOfSupply = "";
            obj.errorStatus.placeOfSupply = false;
          }
        }
      }
      if (itemKey === "remarks") {
        if (obj.errorStatus.partyName == false) {
          if (objData[itemKey].trim().length <= 0) {
            isvalid = false;
            obj.errorFields.remarks = "Comments/Remarks is required";
            obj.errorStatus.remarks = true;
          } else if (objData[itemKey].trim().length > 150) {
            isvalid = false;
            obj.errorFields.remarks =
              "Comments/Remarks should be less than 150 characters";
            obj.errorStatus.remarks = true;
          } else {
            obj.errorFields.remarks = "";
            obj.errorStatus.remarks = false;
          }
        }
      }
      // }
    });

    setData(obj);

    return isvalid;
  }

  return (
    <Box
      sx={{
        padding:
          ModalEvent === true
            ? { xs: "20px 20px 20px 20px", sm: "30px 30px 0px 30px" }
            : { xs: "80px 20px 20px 20px", sm: "70px 30px 20px 80px" },
      }}
    >
      <Box sx={{ marginTop: "20px" }}>
        {params?.view == true && (
          <Alert
            variant="standard"
            sx={{ boxShadow: "none", marginBottom: "20px" }}
            severity="info"
          >
            Fields are disabled. If you want to make changes{" "}
            <Link
              underline="hover"
              sx={{ cursor: "pointer" }}
              onClick={() =>
                navigate("/editcreditnote", {
                  state: { id: params?.id },
                })
              }
            >
              Enable Edit
            </Link>
          </Alert>
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          marginTop: ModalEvent !== true ? "20px" : "0px",
        }}
      >
        {companyDetails?.getCompany?.relatedCompanyDetailsNew?.[0]
          .RegistrationType !== 1 ? (
          <Box
            sx={{
              flex: { sm: 1, md: 2 },
              borderRadius: "12px",
              padding: { xs: "10px 0px", sm: "10px 10px" },
              backgroundColor: "#fff",
              marginRight: { xs: "0px", sm: "20px" },
              boxShadow:
                "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
              ":hover": {
                boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
              },
              transition: "all 1s ease-in-out",
              marginBottom: { xs: "20px", sm: "0px" },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexWrap: { xs: "wrap", md: "nowrap" },
                flexDirection: { xs: "column", md: "row" },
                marginBottom: "0px",
                width: "100%",
              }}
            >
              <Box sx={{ flex: { xs: 1, md: 0.5 }, m: 1 }}>
                <Box sx={{ flex: 1 }}>
                  <Box
                    sx={{
                      position: "relative",
                      border: "solid 1px",
                      borderColor:
                        data.errorStatus.gstApplicable === true
                          ? "danger.main"
                          : "input.border",
                      borderRadius: "4px",
                      padding: "9px 14px",
                      boxSizing: "border-box",
                      ".css-ahj2mt-MuiTypography-root": {
                        fontSize: "12px",
                        color:
                          data.errorStatus.gstApplicable === true
                            ? "danger.main"
                            : "input.font",
                      },
                      ".css-1n70hd2-MuiButtonBase-root-MuiRadio-root": {
                        padding: "0px",
                        margin: "0px 5px",
                      },
                      ".css-1rfdfc4-MuiButtonBase-root-MuiRadio-root": {
                        padding: "0px",
                        margin: "0px 5px",
                        color: "input.border",
                      },
                      ".css-1rfdfc4-MuiButtonBase-root-MuiRadio-root.Mui-checked":
                        {
                          color: "mary.main",
                        },
                    }}
                  >
                    <Typography
                      error={
                        data.errorStatus.gstApplicable === true ? true : false
                      }
                      sx={{
                        fontSize: "0.75em",
                        letterSpacing: "0.00938em",
                        position: "absolute",
                        top: "-10px",
                        left: "9px",
                        background: "#fff",
                        padding: "0px 3px",
                        color:
                          data.errorStatus.gstApplicable == true
                            ? "danger.main"
                            : "input.label",
                      }}
                    >
                      GST Applicable <span style={{ color: "#e55353" }}>*</span>
                    </Typography>
                    <RadioGroup
                      disabled={params?.view == true ? true : false}
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "row", sm: "row" },
                      }}
                      name="gstApplicable"
                      onChange={(e) => {
                        const name = e.target.name;
                        const value = e.target.value;
                        setGstFlag(value);
                        console.log("value", gstFlag);
                        if (value === "") {
                          setData((prev) => ({
                            ...prev,
                            ["gstApplicable"]: value,
                            ["errorStatus"]: {
                              ...prev.errorStatus,
                              ["gstApplicable"]: true,
                            },
                            ["errorFields"]: {
                              ...prev.errorFields,
                              ["gstApplicable"]: "GST Applicable is required",
                            },
                          }));
                        } else {
                          if (data.partyName.value !== "") {
                            if (data.gstApplicable == "1") {
                              setWarningText(
                                "If you Switch to Non GST Entry , then the GST Entry is cleared"
                              );
                            } else {
                              setWarningText(
                                "If you Switch to  GST Entry , then the Non GST Entry is cleared"
                              );
                            }
                            setGstWarningModal(true);
                          } else {
                            setData((prev) => ({
                              ...prev,
                              ["gstApplicable"]: value,
                              ["errorStatus"]: {
                                ...prev.errorStatus,
                                ["gstApplicable"]: false,
                              },
                              ["errorFields"]: {
                                ...prev.errorFields,
                                ["gstApplicable"]: "",
                              },
                            }));
                          }
                        }
                      }}
                      value={data.gstApplicable}
                    >
                      <FormControlLabel
                        name="gstApplicable"
                        disabled={params?.view == true ? true : false}
                        value="1"
                        control={<Radio size="small" disableRipple />}
                        label="Yes"
                      />
                      <FormControlLabel
                        name="gstApplicable"
                        disabled={params?.view == true ? true : false}
                        value="2"
                        control={<Radio size="small" />}
                        label="No"
                      />
                    </RadioGroup>
                  </Box>
                  <Typography
                    sx={{
                      marginTop: "2px",
                      marginLeft: "10px",
                      marginBottom: "0px",
                      fontSize: "11px",
                      color: "danger.main",
                    }}
                  >
                    {data.errorFields.gstApplicable}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ flex: { xs: 1, md: 0.5 }, m: 1 }}>
                <Box
                  sx={{
                    flex: 1,
                  }}
                >
                  <Autocomplete
                    disabled={params?.view == true ? true : false}
                    disablePortal
                    id="partyName"
                    required={true}
                    disableClearable
                    options={supplierOptions}
                    isOptionEqualToValue={(option, value) =>
                      option.value == value.value
                    }
                    value={data.partyName}
                    onChange={(e, newValue) => {
                      setSupplierNameEnabled(false);
                      setPartyID(newValue.value);
                      getPartyAddressEntityDetails(newValue.value);
                      getPartyBillAddressEntityDetails(newValue.value);
                      let add = "";
                      let placeSupply = "";
                      let gstin = "";
                      let supplier = "";
                      let creditDays = "";
                      let duedate = "";
                      suppliers.map((ele) => {
                        if (ele.value == newValue.value) {
                          setAccountBalance("");
                          displayBalance(ele.accountsID);
                          setSelectedAccountGroupId(ele.accountsID);
                          setCreditPeriod(ele.creditDays);
                          creditDays = ele.creditDays;
                          supplier = ele.option;
                          if (ele.placeOfSupply == "") {
                            placeSupply = "";
                          } else {
                            placeSupply = ele.placeOfSupply;
                          }

                          if (ele.gstin == "") {
                            gstin = "";
                          } else {
                            gstin = ele.gstin;
                          }
                        }
                      });

                      if (data.invoiceDate == "") {
                        let dud = moment(data.entryDate).add(
                          creditDays,
                          "days"
                        );
                        duedate = moment(dud._d).format("DD MMM YYYY");
                      } else {
                        let dudt = moment(data.invoiceDate).add(
                          creditDays,
                          "days"
                        );
                        duedate = moment(dudt._d).format("DD MMM YYYY");
                      }

                      console.log(duedate, creditDays);
                      if (newValue.value === "") {
                        setData((prev) => ({
                          ...prev,
                          partyName: newValue,
                          dueDate: "",
                          placeOfSupply: "",
                          gstin: "",
                          address: "",
                          supplier: "",
                          creditPeriod: creditDays,
                          errorStatus: {
                            ...prev.errorStatus,
                            partyName: true,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            partyName: "Party Name is required",
                          },
                        }));
                      } else {
                        setPartyID(newValue.value);
                        setData((prev) => ({
                          ...prev,
                          dueDate: duedate,
                          partyName: newValue,
                          placeOfSupply: placeSupply,
                          gstin: gstin,
                          deliveryAddress: "",
                          billingAddress: "",
                          supplier: supplier,
                          creditPeriod: creditDays,
                          errorStatus: {
                            ...prev.errorStatus,
                            partyName: false,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            partyName: "",
                          },
                        }));
                      }
                    }}
                    sx={{
                      ".css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                        {
                          paddingBottom: "5px",
                        },
                      ".css-lcu7oo-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                        {
                          paddingTop: "6px",
                          paddingBottom: "5px",
                          paddingLeft: "6px",
                        },
                    }}
                    size="small"
                    renderInput={(params) => (
                      <TextField
                        required={true}
                        error={
                          data.errorStatus.partyName === true ? true : false
                        }
                        sx={{
                          ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                            {
                              padding: "8.5px 7px",
                            },
                          ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                            {
                              fontSize: "14px",
                            },
                          label: {
                            fontSize: "14px",
                          },
                          ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root": {
                            fontSize: "14px",
                          },
                          ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                            color: "input.font",
                          },
                          ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                            borderColor: "input.border",
                          },
                          ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root": {
                            color: "input.font",
                          },
                          ".css-14qz1ij-MuiListItemText-root": {
                            margin: "0px",
                          },
                          ".css-wgai2y-MuiFormLabel-asterisk": {
                            color: "danger.main",
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        {...params}
                        label="Party Name"
                      />
                    )}
                  />
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography
                      sx={{
                        marginTop: "2px",
                        marginLeft: "10px",
                        marginBottom: "0px",
                        fontSize: "11px",
                        color: "danger.main",
                      }}
                    >
                      {data.errorFields.partyName}
                    </Typography>
                    <Typography
                      sx={{
                        justifyContent: "flex-end",
                        color:
                          params?.view == true
                            ? "input.border"
                            : "primary.main",
                        display: "flex",
                        alignItems: "center",
                        fontSize: "13px",
                        marginTop: { xs: "5px" },
                      }}
                    >
                      <AccountBalanceIcon sx={{ fontSize: "18px" }} /> Balance
                      Amount : ₹ {accountBalance}
                      <Typography
                        disabled={params?.view == true ? true : false}
                        color={
                          params?.view == true ? "input.border" : "primary.main"
                        }
                        href="#"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: params?.view == true ? "default" : "",
                        }}
                      ></Typography>
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                flex: 1,
                m: 1,
                backgroundColor: "#f4f9f8",
                borderRadius: "10px",
                padding: "10px",
                ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                  backgroundColor: "#fff",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexWrap: { xs: "wrap", md: "nowrap" },
                  flexDirection: { xs: "column", md: "row" },
                  marginBottom: "0px",
                  width: "100%",
                }}
              >
                <Box sx={{ flex: { xs: 1, md: 0.5 }, m: 1 }}>
                  <TextField
                    id="customerOrderNo"
                    name="customerOrderNo"
                    label="Customer Order Number"
                    variant="outlined"
                    size="small"
                    type=""
                    required={true}
                    fullWidth
                  />
                </Box>
                <Box sx={{ flex: { xs: 1, md: 0.5 }, m: 1 }}>
                  <TextField
                    error={
                      data.errorStatus.creditNoteDate === true ? true : false
                    }
                    id="creditNoteDate"
                    name="creditNoteDate"
                    label="Invoice Date"
                    variant="outlined"
                    size="small"
                    type="date"
                    required={true}
                    disabled={
                      data.partyName.value == "" || params?.view == true
                        ? true
                        : false
                    }
                    value={data.creditNoteDate}
                    fullWidth
                    onChange={(e) => {
                      const name = e.target.name;
                      const value = e.target.value;
                      if (value === "") {
                        setData((prev) => ({
                          ...prev,
                          ["creditNoteDate"]: value,
                          ["errorStatus"]: {
                            ...prev.errorStatus,
                            ["creditNoteDate"]: true,
                          },
                          ["errorFields"]: {
                            ...prev.errorFields,
                            ["creditNoteDate"]: "Invoice is required",
                          },
                        }));
                      } else {
                        setData((prev) => ({
                          ...prev,
                          ["creditNoteDate"]: value,
                          ["errorStatus"]: {
                            ...prev.errorStatus,
                            ["creditNoteDate"]: false,
                          },
                          ["errorFields"]: {
                            ...prev.errorFields,
                            ["creditNoteDate"]: "",
                          },
                        }));
                      }
                    }}
                    sx={{
                      ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                        fontSize: "14px",
                      },
                      label: {
                        fontSize: "14px",
                      },
                      ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root": {
                        fontSize: "14px",
                      },
                      ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                        color: "input.font",
                      },
                      ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                        borderColor: "input.border",
                      },
                      ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root": {
                        color: "input.font",
                      },
                      ".css-14qz1ij-MuiListItemText-root": {
                        margin: "0px",
                      },
                      ".css-wgai2y-MuiFormLabel-asterisk": {
                        color: "danger.main",
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  ></TextField>
                  <Typography
                    sx={{
                      marginTop: "2px",
                      marginLeft: "10px",
                      marginBottom: "0px",
                      fontSize: "11px",
                      color: "danger.main",
                    }}
                  >
                    {data.errorFields.creditNoteDate}
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: { xs: "wrap", md: "nowrap" },
                  flexDirection: { xs: "column", md: "row" },
                  marginBottom: "0px",
                  width: "100%",
                }}
              >
                <Box sx={{ flex: { xs: 1, md: 0.5 }, m: 1 }}>
                  <Box
                    sx={{
                      flex: 1,
                      display: "flex",
                      justifyContent: { sm: "flex-start" },
                      alignItems: "center",
                      padding: "8px",
                      borderRadius: "4px",
                      backgroundColor: "#a0a1a11a",
                      position: "relative",
                      "&:hover": {
                        cursor: params?.view == true ? "" : "pointer",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        borderRadius: "4px",
                        paddingLeft: "8px",
                        paddingRight: "8px",
                        backgroundColor: "white",
                        position: "absolute",
                        top: "-8px",
                        right: "8px",
                        color: "#808080",
                        textTransform: "capitalize",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      Voucher number
                    </Typography>
                    <Typography sx={{ color: "#808080" }}>
                      <span style={{ fontWeight: "bold" }}>#</span>
                      {data.creditNote}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ flex: { xs: 1, md: 0.5 }, m: 1 }}>
                  <Autocomplete
                    size="small"
                    multiple
                    options={invoices}
                    getOptionLabel={(option) => option.label}
                    disableCloseOnSelect
                    disabled={
                      data.partyName.value == "" || params?.view == true
                        ? true
                        : false
                    }
                    value={data.originalInvoiceNumber}
                    onChange={(e, newValue) => {
                      console.log("newValue", newValue);
                      setData((prev) => ({
                        ...prev,
                        originalInvoiceNumber: newValue,
                        errorStatus: {
                          ...prev.errorStatus,
                          originalInvoiceNumber: false,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          originalInvoiceNumber: "",
                        },
                      }));
                      console.log("dddd", data.originalInvoiceNumber);
                    }}
                    renderInput={(params) => (
                      <TextField
                        error={
                          data.errorStatus.originalInvoiceNumber === true
                            ? true
                            : false
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        {...params}
                        variant="outlined"
                        label="Original Invoice Number"
                      />
                    )}
                    renderOption={(props, option, { selected }) => (
                      <MenuItem
                        {...props}
                        key={option.value}
                        value={option.value}
                        sx={{ justifyContent: "space-between", m: 1 }}
                      >
                        {
                          <Checkbox
                            color="info"
                            checked={selected ? true : false}
                          />
                        }
                        {option.label}
                      </MenuItem>
                    )}
                  />

                  <Typography
                    sx={{
                      marginTop: "2px",
                      marginLeft: "10px",
                      marginBottom: "0px",
                      fontSize: "11px",
                      color: "danger.main",
                    }}
                  >
                    {data.errorFields.originalInvoiceNumber}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        ) : (
          <Box
            sx={{
              flex: { sm: 1, md: 2 },
              borderRadius: "12px",
              padding: { xs: "10px 0px", sm: "10px 10px" },
              backgroundColor: "#fff",
              marginRight: { xs: "0px", sm: "20px" },
              boxShadow:
                "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
              ":hover": {
                boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
              },
              transition: "all 1s ease-in-out",
              marginBottom: { xs: "20px", sm: "0px" },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexWrap: { xs: "wrap", md: "nowrap" },
                flexDirection: { xs: "column", md: "row" },
                marginBottom: "0px",
                width: "100%",
              }}
            >
              <Box sx={{ flex: { xs: 1, md: 0.5 }, m: 1 }}>
                <Box
                  sx={{
                    flex: 1,
                  }}
                >
                  <Autocomplete
                    disabled={params?.view == true ? true : false}
                    disablePortal
                    id="partyName"
                    required={true}
                    disableClearable
                    options={supplierOptions}
                    isOptionEqualToValue={(option, value) =>
                      option.value == value.value
                    }
                    value={data.partyName}
                    onChange={(e, newValue) => {
                      setSupplierNameEnabled(false);
                      setPartyID(newValue.value);
                      getPartyAddressEntityDetails(newValue.value);
                      getPartyBillAddressEntityDetails(newValue.value);
                      let add = "";
                      let placeSupply = "";
                      let gstin = "";
                      let supplier = "";
                      let creditDays = "";
                      let duedate = "";
                      suppliers.map((ele) => {
                        if (ele.value == newValue.value) {
                          setAccountBalance("");
                          displayBalance(ele.accountsID);
                          setSelectedAccountGroupId(ele.accountsID);
                          setCreditPeriod(ele.creditDays);
                          creditDays = ele.creditDays;
                          supplier = ele.option;
                          if (ele.placeOfSupply == "") {
                            placeSupply = "";
                          } else {
                            placeSupply = ele.placeOfSupply;
                          }

                          if (ele.gstin == "") {
                            gstin = "";
                          } else {
                            gstin = ele.gstin;
                          }
                        }
                      });

                      if (data.invoiceDate == "") {
                        let dud = moment(data.entryDate).add(
                          creditDays,
                          "days"
                        );
                        duedate = moment(dud._d).format("DD MMM YYYY");
                      } else {
                        let dudt = moment(data.invoiceDate).add(
                          creditDays,
                          "days"
                        );
                        duedate = moment(dudt._d).format("DD MMM YYYY");
                      }

                      console.log(duedate, creditDays);
                      if (newValue.value === "") {
                        setData((prev) => ({
                          ...prev,
                          partyName: newValue,
                          dueDate: "",
                          placeOfSupply: "",
                          gstin: "",
                          address: "",
                          supplier: "",
                          creditPeriod: creditDays,
                          errorStatus: {
                            ...prev.errorStatus,
                            partyName: true,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            partyName: "Party Name is required",
                          },
                        }));
                      } else {
                        setPartyID(newValue.value);
                        setData((prev) => ({
                          ...prev,
                          dueDate: duedate,
                          partyName: newValue,
                          placeOfSupply: placeSupply,
                          gstin: gstin,
                          deliveryAddress: "",
                          billingAddress: "",
                          supplier: supplier,
                          creditPeriod: creditDays,
                          errorStatus: {
                            ...prev.errorStatus,
                            partyName: false,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            partyName: "",
                          },
                        }));
                      }
                    }}
                    sx={{
                      ".css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                        {
                          paddingBottom: "5px",
                        },
                      ".css-lcu7oo-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                        {
                          paddingTop: "6px",
                          paddingBottom: "5px",
                          paddingLeft: "6px",
                        },
                    }}
                    size="small"
                    renderInput={(params) => (
                      <TextField
                        required={true}
                        error={
                          data.errorStatus.partyName === true ? true : false
                        }
                        sx={{
                          ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                            {
                              padding: "8.5px 7px",
                            },
                          ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                            {
                              fontSize: "14px",
                            },
                          label: {
                            fontSize: "14px",
                          },
                          ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root": {
                            fontSize: "14px",
                          },
                          ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                            color: "input.font",
                          },
                          ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                            borderColor: "input.border",
                          },
                          ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root": {
                            color: "input.font",
                          },
                          ".css-14qz1ij-MuiListItemText-root": {
                            margin: "0px",
                          },
                          ".css-wgai2y-MuiFormLabel-asterisk": {
                            color: "danger.main",
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        {...params}
                        label="Party Name"
                      />
                    )}
                  />
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography
                      sx={{
                        marginTop: "2px",
                        marginLeft: "10px",
                        marginBottom: "0px",
                        fontSize: "11px",
                        color: "danger.main",
                      }}
                    >
                      {data.errorFields.partyName}
                    </Typography>
                    <Typography
                      sx={{
                        justifyContent: "flex-end",
                        color:
                          params?.view == true
                            ? "input.border"
                            : "primary.main",
                        display: "flex",
                        alignItems: "center",
                        fontSize: "13px",
                        marginTop: { xs: "5px" },
                      }}
                    >
                      <AccountBalanceIcon sx={{ fontSize: "18px" }} /> Balance
                      Amount : ₹ {accountBalance}
                      <Typography
                        disabled={params?.view == true ? true : false}
                        color={
                          params?.view == true ? "input.border" : "primary.main"
                        }
                        href="#"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: params?.view == true ? "default" : "",
                        }}
                      ></Typography>
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box sx={{ flex: { xs: 1, md: 0.5 }, m: 1 }}>
                <TextField
                  error={
                    data.errorStatus.creditNoteDate === true ? true : false
                  }
                  id="creditNoteDate"
                  name="creditNoteDate"
                  label="Credit Note Date"
                  variant="outlined"
                  size="small"
                  type="date"
                  required={true}
                  disabled={
                    data.partyName.value == "" || params?.view == true
                      ? true
                      : false
                  }
                  value={data.creditNoteDate}
                  fullWidth
                  onChange={(e) => {
                    const name = e.target.name;
                    const value = e.target.value;
                    if (value === "") {
                      setData((prev) => ({
                        ...prev,
                        ["creditNoteDate"]: value,
                        ["errorStatus"]: {
                          ...prev.errorStatus,
                          ["creditNoteDate"]: true,
                        },
                        ["errorFields"]: {
                          ...prev.errorFields,
                          ["creditNoteDate"]: "Credit Note Date is required",
                        },
                      }));
                    } else {
                      setData((prev) => ({
                        ...prev,
                        ["creditNoteDate"]: value,
                        ["errorStatus"]: {
                          ...prev.errorStatus,
                          ["creditNoteDate"]: false,
                        },
                        ["errorFields"]: {
                          ...prev.errorFields,
                          ["creditNoteDate"]: "",
                        },
                      }));
                    }
                  }}
                  sx={{
                    ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                      fontSize: "14px",
                    },
                    label: {
                      fontSize: "14px",
                    },
                    ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root": {
                      fontSize: "14px",
                    },
                    ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                      color: "input.font",
                    },
                    ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      borderColor: "input.border",
                    },
                    ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root": {
                      color: "input.font",
                    },
                    ".css-14qz1ij-MuiListItemText-root": {
                      margin: "0px",
                    },
                    ".css-wgai2y-MuiFormLabel-asterisk": {
                      color: "danger.main",
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                ></TextField>
                <Typography
                  sx={{
                    marginTop: "2px",
                    marginLeft: "10px",
                    marginBottom: "0px",
                    fontSize: "11px",
                    color: "danger.main",
                  }}
                >
                  {data.errorFields.creditNoteDate}
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                flex: 1,
                m: 1,
                backgroundColor: "#f4f9f8",
                borderRadius: "10px",
                padding: "10px",
                ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                  backgroundColor: "#fff",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexWrap: { xs: "wrap", md: "nowrap" },
                  flexDirection: { xs: "column", md: "row" },
                  marginBottom: "0px",
                  width: "100%",
                }}
              ></Box>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: { xs: "wrap", md: "nowrap" },
                  flexDirection: { xs: "column", md: "row" },
                  marginBottom: "0px",
                  width: "100%",
                }}
              >
                <Box sx={{ flex: { xs: 1, md: 0.5 }, m: 1 }}>
                  <Box
                    sx={{
                      flex: 1,
                      display: "flex",
                      justifyContent: { sm: "flex-start" },
                      alignItems: "center",
                      padding: "8px",
                      borderRadius: "4px",
                      backgroundColor: "#a0a1a11a",
                      position: "relative",
                      "&:hover": {
                        cursor: params?.view == true ? "" : "pointer",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        borderRadius: "4px",
                        paddingLeft: "8px",
                        paddingRight: "8px",
                        backgroundColor: "white",
                        position: "absolute",
                        top: "-8px",
                        right: "8px",
                        color: "#808080",
                        textTransform: "capitalize",
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                    >
                      Credit Note number
                    </Typography>
                    <Typography sx={{ color: "#808080" }}>
                      <span style={{ fontWeight: "bold" }}>#</span>
                      {data.creditNote}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ flex: { xs: 1, md: 0.5 }, m: 1 }}>
                  <Autocomplete
                    size="small"
                    multiple
                    options={invoices}
                    getOptionLabel={(option) => option.label}
                    disableCloseOnSelect
                    disabled={
                      data.partyName.value == "" || params?.view == true
                        ? true
                        : false
                    }
                    value={data.originalInvoiceNumber}
                    onChange={(e, newValue) => {
                      console.log("newValue", newValue);
                      setData((prev) => ({
                        ...prev,
                        originalInvoiceNumber: newValue,
                        errorStatus: {
                          ...prev.errorStatus,
                          originalInvoiceNumber: false,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          originalInvoiceNumber: "",
                        },
                      }));
                      console.log("dddd", data.originalInvoiceNumber);
                    }}
                    renderInput={(params) => (
                      <TextField
                        error={
                          data.errorStatus.originalInvoiceNumber === true
                            ? true
                            : false
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        {...params}
                        variant="outlined"
                        label="Original Invoice Number"
                      />
                    )}
                    renderOption={(props, option, { selected }) => (
                      <MenuItem
                        {...props}
                        key={option.value}
                        value={option.value}
                        sx={{ justifyContent: "space-between", m: 1 }}
                      >
                        {
                          <Checkbox
                            color="info"
                            checked={selected ? true : false}
                          />
                        }
                        {option.label}
                      </MenuItem>
                    )}
                  />

                  <Typography
                    sx={{
                      marginTop: "2px",
                      marginLeft: "10px",
                      marginBottom: "0px",
                      fontSize: "11px",
                      color: "danger.main",
                    }}
                  >
                    {data.errorFields.originalInvoiceNumber}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        )}
        <Box
          sx={{
            flex: 1,
            borderRadius: "12px",
            padding: { xs: "10px 0px", sm: "10px 18px" },
            backgroundColor: "#fff",
            boxShadow:
              "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
            ":hover": {
              boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
            },
            transition: "all 1s ease-in-out",
          }}
        >
          <Box sx={{ flex: { xs: 1, md: 0.5 } }}>
            <Box
              sx={{
                flex: 1,
                marginBottom: "10px",
              }}
            >
              {totNonGstNetAmount != 0 ||
                (totTaxableAmount != 0 && (
                  <>
                    {data.gstApplicable == "1" ? (
                      <>
                        <Typography
                          sx={{
                            fontSize: "12px",
                            color: "#888888",
                            display: "flex",
                            alignItems: "center",
                            textTransform: "capitalize",
                          }}
                          variant="h5"
                        >
                          <Avatar
                            alt=" "
                            src="none"
                            sx={{
                              width: 8,
                              height: 8,
                              marginRight: "5px",
                              backgroundColor: "input.border",
                            }}
                          />
                          Total Taxable Amount
                        </Typography>
                        <Typography
                          sx={{ fontSize: "16px", color: "#000" }}
                          variant="h5"
                        >
                          ₹{" "}
                          {MoneyFormat(
                            Number(totTaxableAmount).toFixed(2),
                            "en-IN"
                          )}
                        </Typography>
                      </>
                    ) : (
                      <>
                        <Typography
                          sx={{
                            fontSize: "12px",
                            color: "#888888",
                            display: "flex",
                            alignItems: "center",
                            textTransform: "capitalize",
                          }}
                          variant="h5"
                        >
                          <Avatar
                            alt=" "
                            src="none"
                            sx={{
                              width: 8,
                              height: 8,
                              marginRight: "5px",
                              backgroundColor: "#ccccb3",
                            }}
                          />
                          Total Amount
                        </Typography>
                        <Typography
                          sx={{ fontSize: "16px", color: "#000" }}
                          variant="h5"
                        >
                          ₹{" "}
                          {MoneyFormat(
                            Number(totNonGstNetAmount).toFixed(2),
                            "en-IN"
                          )}
                        </Typography>
                      </>
                    )}
                  </>
                ))}
            </Box>
          </Box>
          <Box sx={{ display: "flex" }}>
            <Box
              sx={{
                marginBottom: "10px",
                flex: 1,
              }}
            >
              {totGST != 0 && (
                <>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: "#888888",
                      display: "flex",
                      alignItems: "center",
                      textTransform: "capitalize",
                    }}
                    variant="h5"
                  >
                    <Avatar
                      alt=" "
                      src="none"
                      sx={{
                        width: 8,
                        height: 8,
                        marginRight: "5px",
                        backgroundColor: "#ccccb3",
                      }}
                    />
                    GST
                    {/* ₹ {totGST.toFixed(2)} */}
                  </Typography>
                  <Typography
                    sx={{ fontSize: "16px", color: "#000" }}
                    variant="h5"
                  >
                    ₹ {MoneyFormat(Number(totGST).toFixed(2), "en-IN")}
                  </Typography>
                </>
              )}
            </Box>
            <Box
              sx={{
                marginBottom: "10px",
                flex: 1,
              }}
            >
              {totGstCess != 0 && (
                <>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: "#888888",
                      display: "flex",
                      alignItems: "center",
                      textTransform: "capitalize",
                    }}
                    variant="h5"
                  >
                    <Avatar
                      alt=" "
                      src="none"
                      sx={{
                        width: 8,
                        height: 8,
                        marginRight: "5px",
                        backgroundColor: "#ccccb3",
                      }}
                    />
                    GST Cess
                  </Typography>
                  <Typography
                    sx={{ fontSize: "16px", color: "#000" }}
                    variant="h5"
                  >
                    ₹ {MoneyFormat(Number(totGstCess).toFixed(2), "en-IN")}
                  </Typography>
                </>
              )}
            </Box>
          </Box>

          {data.gstApplicable == "1" ? (
            <Box
              sx={{
                borderBottom: "dashed 1px #ccc",
                borderTop: "dashed 1px #ccc",
                padding: "10px 0px",
                marginBottom: "10px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: "17px",
                    marginBottom: "0px",
                    color: "primary.main",
                  }}
                >
                  Grand Total
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    color: "#000",
                    fontSize: "32px",
                  }}
                >
                  ₹
                  {MoneyFormat(
                    Number(totNetAmount.toFixed(2)) + Number(data.adjustments),
                    "en-IN"
                  )}
                </Typography>
              </Box>
              <Typography
                textAlign="center"
                sx={{
                  fontSize: "11px",
                  fontWeight: 500,
                  color: "rgba(0,0,0,0.6)",
                  backgroundColor: "background.tablebg",
                  padding: "5px 8px",
                  borderRadius: "20px",
                  marginTop: "10px",
                  display: "inline-block",
                }}
              >
                {toWords.convert(
                  Number(totNetAmount.toFixed(2)) + Number(data.adjustments)
                )}
              </Typography>
            </Box>
          ) : (
            <Box
              sx={{
                borderBottom: "dashed 1px #ccc",
                borderTop: "dashed 1px #ccc",
                padding: "10px 0px",
                marginBottom: "10px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: "17px",
                    marginBottom: "0px",
                    color: "primary.main",
                  }}
                >
                  Grand Total
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    color: "#000",
                    fontSize: "32px",
                  }}
                >
                  ₹
                  {MoneyFormat(
                    Number(totNonGstNetAmount.toFixed(2)) +
                      Number(data.adjustments),
                    "en-IN"
                  )}
                </Typography>
              </Box>
              <Typography
                textAlign="center"
                sx={{
                  fontSize: "11px",
                  fontWeight: 500,
                  color: "rgba(0,0,0,0.6)",
                  backgroundColor: "background.tablebg",
                  padding: "5px 8px",
                  borderRadius: "20px",
                  marginTop: "10px",
                  display: "inline-block",
                }}
              >
                {toWords.convert(
                  isNaN(
                    Number(totNonGstNetAmount.toFixed(2)) +
                      Number(data.adjustments)
                  )
                    ? 0
                    : Number(totNonGstNetAmount.toFixed(2)) +
                        Number(data.adjustments)
                )}
              </Typography>
            </Box>
          )}
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: { sm: "flex-start" },
                alignItems: "center",
                marginRight: "20px",

                ".css-1kpioai-MuiButtonBase-root-MuiCheckbox-root": {
                  color: "input.border",
                },
                ".css-1kpioai-MuiButtonBase-root-MuiCheckbox-root.Mui-checked":
                  {
                    color: "primary.main",
                  },
                ".css-pjm1bd-MuiButtonBase-root-MuiCheckbox-root": {
                  padding: "0px",
                },
              }}
            >
              <Checkbox
                size="small"
                id="ineligibleITCFlag"
                disabled={params?.view == true ? true : false}
                checked={data.ineligibleITCFlag == 1 ? true : false}
                disableRipple
                onChange={(e) => {
                  if (e.target.checked) {
                    setData((prev) => ({
                      ...prev,
                      ineligibleITCFlag: 1,
                    }));
                  } else {
                    setData((prev) => ({
                      ...prev,
                      ineligibleITCFlag: 0,
                    }));
                  }
                }}
              />
              <FormLabel
                htmlFor="ineligibleITCFlag"
                sx={{
                  fontSize: "14px",
                  marginLeft: "5px",
                  color: "input.font",
                }}
              >
                Ineligible ITC
              </FormLabel>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: { sm: "flex-start" },
                alignItems: "center",
                ".css-1kpioai-MuiButtonBase-root-MuiCheckbox-root": {
                  color: "input.border",
                },
                ".css-1kpioai-MuiButtonBase-root-MuiCheckbox-root.Mui-checked":
                  {
                    color: "primary.main",
                  },
                ".css-pjm1bd-MuiButtonBase-root-MuiCheckbox-root": {
                  padding: "0px",
                },
              }}
            >
              <Checkbox
                size="small"
                id="reverseChargeFlag"
                disabled={params?.view == true ? true : false}
                checked={data.reverseChargeFlag == 1 ? true : false}
                disableRipple
                onChange={(e) => {
                  if (e.target.checked) {
                    setData((prev) => ({
                      ...prev,
                      reverseChargeFlag: 1,
                    }));
                  } else {
                    setData((prev) => ({
                      ...prev,
                      reverseChargeFlag: 0,
                    }));
                  }
                }}
              />
              <FormLabel
                htmlFor="reverseChargeFlag"
                sx={{
                  fontSize: "14px",
                  marginLeft: "5px",
                  color: "input.font",
                }}
                disabled={params?.view != true ? false : true}
              >
                Reverse Charge Applicable
              </FormLabel>
            </Box>
          </Box>
        </Box>
      </Box>
      {data.gstApplicable === "2" ? (
        <Paper
          sx={{
            width: "100%",
            borderRadius: "12px",
            overflow: "hidden",
            marginTop: "20px",
            boxShadow:
              "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
            ":hover": {
              boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
            },
            transition: "all 1s ease-in-out",
            ".MuiTableCell-root": {
              padding: "10px 5px",
              fontSize: "13px",
            },
            ".MuiTableCell-head": {
              backgroundColor: "background.tablebg",
              padding: "10px 8px",
              borderBottom: "0px",
              fontSize: "13px",
              fontWeight: "bold",
            },
            ".MuiTableCell-head:first-of-type": {
              borderTopLeftRadius: "6px",
              borderBottomLeftRadius: "6px",
            },
            ".MuiTableCell-head:last-child": {
              borderTopRightRadius: "6px",
              borderBottomRightRadius: "6px",
            },
          }}
        >
          <Box sx={{ padding: { xs: "10px 10px", sm: "10px 20px" } }}>
            <TableContainer
              sx={{
                scrollbarWidth: "thin",
                "&::-webkit-scrollbar": {
                  width: "0.4em",
                  height: "0.4em",
                },
                "&::-webkit-scrollbar-track": {
                  background: `${theme.palette.primary.main}47`,
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "primary.main",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: `${theme.palette.primary.main}47`,
                },
              }}
            >
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {nonGSTTableHeader.map((column) => {
                      if (params?.view != true) {
                        return (
                          <TableCell
                            key={column.id}
                            // sx={{minWidth:column.width}}
                          >
                            {column.label}
                          </TableCell>
                        );
                      } else {
                        return (
                          column.label != "Action" && (
                            <TableCell
                              key={column.id}
                              // sx={{minWidth:column.width}}
                            >
                              {column.label}
                            </TableCell>
                          )
                        );
                      }
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {nonGstItems.length > 0 ? (
                    nonGstItems.map((col, index) => {
                      console.log("col", col);

                      if (col.editable) {
                        return (
                          <TableRow hover role="checkbox" key={index}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell sx={{ minWidth: "150px" }}>
                              <Autocomplete
                                // disablePortal
                                id="ledgerAccount"
                                disabled={
                                  data.partyName.value == "" ? true : false
                                }
                                disableClearable
                                options={accName}
                                isOptionEqualToValue={(option, value) =>
                                  option.value == value.value
                                }
                                value={nonGstItemEditedRow.ledgerAccount}
                                onChange={(e, newValue) => {
                                  console.log("newValue", newValue);
                                  setNonGstItemEditedRow((prev) => ({
                                    ...prev,
                                    ledgerAccount: newValue,
                                  }));
                                }}
                                sx={{
                                  ".css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                                    {
                                      paddingBottom: "5px",
                                    },
                                  ".css-lcu7oo-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                                    {
                                      paddingTop: "6px",
                                      paddingBottom: "5px",
                                      paddingLeft: "6px",
                                    },
                                }}
                                size="small"
                                renderInput={(params) => (
                                  <TextField
                                    sx={{
                                      ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                                        {
                                          padding: "8.5px 7px",
                                        },
                                      ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                        {
                                          fontSize: "14px",
                                        },
                                      label: {
                                        fontSize: "14px",
                                      },
                                      ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root":
                                        {
                                          fontSize: "14px",
                                        },
                                      ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                        {
                                          color: "input.font",
                                        },
                                      ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                        {
                                          borderColor: "input.border",
                                        },
                                      ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root":
                                        {
                                          color: "input.font",
                                        },
                                      ".css-14qz1ij-MuiListItemText-root": {
                                        margin: "0px",
                                      },
                                      ".css-wgai2y-MuiFormLabel-asterisk": {
                                        color: "danger.main",
                                      },
                                    }}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    {...params}
                                    label="Ledger Account"
                                    required={true}
                                  />
                                )}
                              />
                            </TableCell>
                            <TableCell sx={{ minWidth: "150px" }}>
                              <TextField
                                disabled={
                                  data.partyName.value == "" ? true : false
                                }
                                value={nonGstItemEditedRow?.description}
                                onChange={(e) => {
                                  const value = e.target.value;

                                  setNonGstItemEditedRow((prev) => ({
                                    ...prev,
                                    description: value,
                                  }));
                                }}
                                id="description"
                                label=""
                                type="text"
                                variant="outlined"
                                size="small"
                                fullWidth
                                sx={{
                                  ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                                    {
                                      padding: "8.5px 7px",
                                    },
                                  ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                    {
                                      fontSize: "14px",
                                    },
                                  label: {
                                    fontSize: "14px",
                                  },
                                  ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                    {
                                      color: "input.font",
                                    },
                                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "input.border",
                                    },
                                  ".css-wgai2y-MuiFormLabel-asterisk": {
                                    color: "danger.main",
                                  },
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            </TableCell>
                            <TableCell sx={{ minWidth: "100px" }}>
                              <TextField
                                name="amount"
                                disabled={
                                  data.partyName.value == "" ? true : false
                                }
                                value={nonGstItemEditedRow.amount}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  console.log(value);

                                  setNonGstItemEditedRow((prev) => ({
                                    ...prev,
                                    amount: value,
                                  }));
                                }}
                                id="amount"
                                type="number"
                                label="Amount"
                                variant="outlined"
                                size="small"
                                required={true}
                                fullWidth
                                sx={{
                                  minWidth: "100px",
                                  maxWidth: "100px",
                                  ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                    {
                                      fontSize: "14px",
                                    },
                                  label: {
                                    fontSize: "14px",
                                  },
                                  ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root":
                                    {
                                      fontSize: "14px",
                                    },
                                  ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                    {
                                      color: "input.font",
                                    },
                                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "input.border",
                                    },
                                  ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root":
                                    {
                                      color: "input.font",
                                    },
                                  ".css-wgai2y-MuiFormLabel-asterisk": {
                                    color: "danger.main",
                                  },
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                InputProps={{
                                  inputProps: {
                                    min: 0,
                                  },
                                }}
                                onKeyPress={(event) => {
                                  if (
                                    event?.key === "-" ||
                                    event?.key === "+"
                                  ) {
                                    event.preventDefault();
                                  }
                                }}
                              ></TextField>
                            </TableCell>
                            {params?.view !== true && (
                              <TableCell align="center">
                                <Box
                                  sx={{
                                    display: "flex",
                                    // justifyContent: "center",
                                  }}
                                >
                                  <IconButton
                                    disableRipple
                                    aria-label="delete"
                                    disabled={
                                      data.partyName.value == "" ? true : false
                                    }
                                    sx={{
                                      margin: "0px 2px",
                                      padding: "5px",
                                      backgroundColor: "#83ff7b7a",
                                    }}
                                    onClick={() => {
                                      if (params?.view != true) {
                                        saveChangesInNonGstRows(index);
                                      }
                                    }}
                                  >
                                    <DoneIcon
                                      sx={{
                                        fontSize: "18px",
                                        color:
                                          data.partyName.value !== ""
                                            ? "#34994f"
                                            : "#C9C9C9",
                                      }}
                                    />
                                  </IconButton>
                                  {nonGstItems.length > 1 && (
                                    <IconButton
                                      disableRipple
                                      aria-label="delete"
                                      sx={{
                                        margin: "0px 2px",
                                        padding: "5px",
                                        backgroundColor: "#fbc7c78c",
                                      }}
                                      onClick={() => {
                                        if (params?.view != true) {
                                          closeChangesInNonGstRows(index);
                                        }
                                      }}
                                    >
                                      <CloseIcon
                                        sx={{
                                          fontSize: "18px",
                                          color: "#eb6a6a",
                                        }}
                                      />
                                    </IconButton>
                                  )}
                                </Box>
                              </TableCell>
                            )}
                          </TableRow>
                        );
                      } else {
                        return (
                          <TableRow hover role="checkbox" key={index}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{col.ledgerAccount.label}</TableCell>
                            <TableCell>{col.description}</TableCell>
                            <TableCell>{col.amount}</TableCell>
                            {params?.view !== true && (
                              <TableCell align="center">
                                <Box
                                  sx={{
                                    display: "flex",
                                    // justifyContent: "center",
                                  }}
                                >
                                  <IconButton
                                    disabled={
                                      Object.keys(nonGstItemTempRow).length == 0
                                        ? false
                                        : true
                                    }
                                    disableRipple
                                    aria-label="delete"
                                    sx={{
                                      margin: "0px 2px",
                                      padding: "5px",
                                      backgroundColor: "#b1d1f97d",
                                    }}
                                    onClick={() => {
                                      if (params?.view != true) {
                                        if (
                                          Object.keys(nonGstItemTempRow)
                                            .length == 0
                                        ) {
                                          setNonGstItemTempRow(col);
                                          setNonGstItemEditedRow(col);
                                          let arr = [...nonGstItems];
                                          console.log("arrr", arr);
                                          arr[index].editable = true;
                                          arr[index].new = false;
                                          setNonGstItems(arr);
                                        }
                                      }
                                    }}
                                  >
                                    <EditIcon
                                      sx={{
                                        fontSize: "15px",
                                        color: "#6096d9",
                                      }}
                                    />
                                  </IconButton>
                                  <IconButton
                                    disabled={
                                      Object.keys(nonGstItemTempRow).length == 0
                                        ? false
                                        : true
                                    }
                                    disableRipple
                                    aria-label="delete"
                                    sx={{
                                      margin: "0px 2px",
                                      padding: "5px",
                                      backgroundColor: "#fbc7c78c",
                                    }}
                                    onClick={() => {
                                      if (params?.view != true) {
                                        if (
                                          Object.keys(nonGstItemTempRow)
                                            .length == 0
                                        ) {
                                          setDeleteNonGSTEntriesModal(true);
                                          setNonGSTEntryIndex(index);
                                        }
                                      }
                                    }}
                                  >
                                    <DeleteIcon
                                      sx={{
                                        fontSize: "15px",
                                        color: "#eb6a6a",
                                      }}
                                    />
                                  </IconButton>
                                </Box>
                              </TableCell>
                            )}
                          </TableRow>
                        );
                      }
                    })
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={15}>
                        No Items Found
                      </TableCell>
                    </TableRow>
                  )}
                  <TableRow>
                    <TableCell colSpan={3} sx={{ fontWeight: 600 }}>
                      Total (₹)
                    </TableCell>
                    {/* <TableCell colSpan={1} sx={{ fontWeight: 600 }}>
             {totAmount}
           </TableCell>
           <TableCell colSpan={1} sx={{ fontWeight: 600 }}>
             {totAmount - totTaxableAmount}
           </TableCell>
           <TableCell colSpan={2} sx={{ fontWeight: 600 }}>
             {totTaxableAmount}
           </TableCell>
           <TableCell
             align="center"
             colSpan={1}
             sx={{ fontWeight: 600 }}
           >
             {totGST.toFixed(2)}
           </TableCell>
           <TableCell colSpan={1} sx={{ fontWeight: 600 }}>
             {totGstCess}
           </TableCell> */}
                    <TableCell colSpan sx={{ fontWeight: 600 }}>
                      {totNonGstNetAmount.toFixed(2)}
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Box>
              <Button
                disableRipple
                disableElevation
                size="small"
                variant="text"
                d
                onClick={() => nonGstNewRow()}
                startIcon={<AddBox />}
                sx={{
                  fontSize: "14px",
                  marginTop: "15px",
                }}
                disabled={
                  Object.keys(nonGstItemTempRow).length > 0 ||
                  params?.view == true
                    ? true
                    : false
                }
              >
                Add New Line
              </Button>
            </Box>
            {/* <Typography onClick={() => itemWiseNewRow()} sx={{justifyContent:'flex-start',color:'primary.main',display:'flex',alignItems:'center',fontSize:'14px',marginTop:'15px',width:'130px',padding:'10px',cursor:'pointer'}}><AddBox fontSize='small' sx={{marginRight:'5px'}} /> Add New Line</Typography> */}
          </Box>
        </Paper>
      ) : itemEntry ? (
        <Paper
          sx={{
            width: "100%",
            borderRadius: "12px",
            overflow: "hidden",
            marginTop: "20px",
            boxShadow:
              "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
            ":hover": {
              boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
            },
            transition: "all 1s ease-in-out",
            ".MuiTableCell-root": {
              padding: "10px 5px",
              fontSize: "13px",
            },
            ".MuiTableCell-head": {
              backgroundColor: "background.tablebg",
              padding: "10px 8px",
              borderBottom: "0px",
              fontSize: "13px",
              fontWeight: "bold",
            },
            ".MuiTableCell-head:first-of-type": {
              borderTopLeftRadius: "6px",
              borderBottomLeftRadius: "6px",
            },
            ".MuiTableCell-head:last-child": {
              borderTopRightRadius: "6px",
              borderBottomRightRadius: "6px",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              borderBottom: "solid 0px gray",
              justifyContent: "space-around",
              padding: { xs: "10px 10px", sm: "10px 20px" },
            }}
          >
            <Box
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "10px 0px",
                color: "primary.main",
                borderBottom: "solid 2px",
                borderColor: "primary.main",
                cursor: params?.view == true ? "" : "pointer",
              }}
              onClick={() => {
                if (params?.view !== true) {
                  if (params?.id == undefined || null) {
                    setItemEntry(true);
                  }
                }
              }}
            >
              <FormatListBulleted sx={{ marginRight: "10px" }} /> Item Wise
              Entry
            </Box>
            <Box
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "10px 0px",
                color: "#ccccb3",
                borderBottom: "solid 2px #fff",
                cursor: params?.view == true ? "" : "pointer",
              }}
              onClick={() => {
                if (params?.view !== true) {
                  if (items.length > 0) {
                    if (items.length == 1 && itemEditedRow.editable) {
                      setItemEntry(false);
                    } else {
                      setSwitchedTo("nonItems");
                      setWarningText(
                        "If you Switch to Non-Item Wise Entry , then the Item Wise Entry Table is cleared."
                      );
                      setItemsWarningModal(true);
                    }
                  } else {
                    setItemEntry(false);
                  }
                }
              }}
            >
              <FilterListOff sx={{ marginRight: "10px" }} /> Non-Item Wise Entry
            </Box>
          </Box>
          <Box sx={{ padding: { xs: "10px 10px", sm: "10px 20px" } }}>
            <TableContainer
              sx={{
                // maxHeight: 440,
                scrollbarWidth: "thin",
                "&::-webkit-scrollbar": {
                  width: "0.4em",
                  height: "0.4em",
                },
                "&::-webkit-scrollbar-track": {
                  background: `${theme.palette.primary.main}47`,
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "primary.main",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: `${theme.palette.primary.main}47`,
                },
              }}
            >
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {itemWiseHeader.map((column) => {
                      if (params?.view != true) {
                        return (
                          <TableCell
                            key={column.id}
                            // sx={{minWidth:column.width}}
                          >
                            {column.label}
                          </TableCell>
                        );
                      } else {
                        return (
                          column.label != "Action" && (
                            <TableCell
                              key={column.id}
                              // sx={{minWidth:column.width}}
                            >
                              {column.label}
                            </TableCell>
                          )
                        );
                      }
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items.length > 0 ? (
                    items.map((col, index) => {
                      if (col.editable) {
                        return (
                          <TableRow hover role="checkbox" key={index}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell sx={{ minWidth: "150px" }}>
                              <Box
                                sx={{
                                  flex: { xs: 1, sm: 0.5 },

                                  position: "relative",
                                  marginTop: "15px",
                                }}
                              >
                                <Autocomplete
                                  id="combo-box-demo"
                                  disableClearable
                                  options={itemsCode}
                                  disabled={
                                    data.partyName.value == "" ? true : false
                                  }
                                  value={itemEditedRow.itemCode}
                                  isOptionEqualToValue={(option, value) =>
                                    option.value == value.value
                                  }
                                  onChange={async (e, newValue) => {
                                    console.log("itemnewvalue", newValue);
                                    setItemId(newValue.value);
                                    getItemType(newValue.value);
                                    if (newValue !== null) {
                                      let obj = {};
                                      let hsnobj254 = {};
                                      await Promise.all(
                                        allItemData?.map(async (item) => {
                                          if (item.ItemID == newValue.value) {
                                            hsnobj254 = await searchSACItem(
                                              item.HSNID
                                            );
                                          }
                                        })
                                      );
                                      allItemData?.map((item) => {
                                        if (item.ItemID == newValue.value) {
                                          let gstrate = "";
                                          let itemRate = "";
                                          let cess = "";
                                          item.relatedItemAmountDetails !==
                                            null &&
                                            item?.relatedItemAmountDetails.map(
                                              (ele) => {
                                                // console.log(ele);
                                                if (
                                                  new Date().getTime() >=
                                                    new Date(
                                                      ele.EffectiveDate * 1000
                                                    ).getTime() &&
                                                  new Date().getTime() <=
                                                    new Date(
                                                      ele.ExpiredDate * 1000
                                                    )
                                                ) {
                                                  gstrate = ele.GSTRATE;
                                                  itemRate = ele.Amount;
                                                  if (
                                                    ele.GSTCompensationType ===
                                                    "Amount"
                                                  )
                                                    cess =
                                                      ele.GSTCompensationValue;
                                                  else
                                                    cess =
                                                      (Number(ele.Amount) *
                                                        Number(
                                                          ele.GSTCompensationValue
                                                        )) /
                                                      100;
                                                } else if (
                                                  ele.ExpiredDate == 0
                                                ) {
                                                  if (
                                                    new Date().getTime() >=
                                                    new Date(
                                                      ele.EffectiveDate * 1000
                                                    ).getTime()
                                                  ) {
                                                    gstrate = ele.GSTRATE;
                                                    itemRate = ele.Amount;
                                                  }
                                                  if (
                                                    ele.GSTCompensationType ===
                                                    "Amount"
                                                  )
                                                    cess =
                                                      ele.GSTCompensationValue;
                                                  else
                                                    cess =
                                                      (Number(ele.Amount) *
                                                        Number(
                                                          ele.GSTCompensationValue
                                                        )) /
                                                      100;
                                                }
                                              }
                                            );

                                          let hsnobj = { label: "", value: "" };
                                          HSNCodes?.map((code) => {
                                            if (code.value == item.HSNID) {
                                              console.log(code);
                                              hsnobj = {
                                                label: code.label,
                                                value: code.value,
                                              };
                                            }
                                          });

                                          let accountobj = {
                                            label: "",
                                            value: "",
                                          };
                                          accName?.map((code) => {
                                            if (
                                              data.purchaseOrSalseFlag == "1"
                                            ) {
                                              if (
                                                code.value ==
                                                item.PurchaseAccountID
                                              ) {
                                                console.log(code);
                                                accountobj = {
                                                  label: code.label,
                                                  value: code.value,
                                                };
                                              }
                                            } else {
                                              if (
                                                code.value ==
                                                item.SalesAccountID
                                              ) {
                                                console.log(code);
                                                accountobj = {
                                                  label: "Sales Return A/C",
                                                  value: "",
                                                };
                                              }
                                            }
                                          });
                                          let itemNameObj = {
                                            label: "",
                                            value: "",
                                          };
                                          itemsName?.map((ele) => {
                                            if (ele.value == item.ItemID) {
                                              itemNameObj = {
                                                label: ele.label,
                                                value: ele.value,
                                              };
                                            }
                                          });

                                          obj = { ...itemEditedRow };
                                          obj.itemCode = newValue;
                                          obj.purchaseAccount = accountobj;
                                          obj.units = item.MeasurementCD;
                                          obj.GSTRate = gstrate;
                                          obj.rate = itemRate;
                                          obj.GSTCess = cess;
                                          obj.amount = itemRate;
                                          obj.taxableAMount = itemRate;
                                          obj.HSN = hsnobj254.hsnObj;
                                          obj.HSNArray = hsnobj254.arr;
                                          obj.name = itemNameObj;
                                          console.log("obj", obj);
                                        }
                                      });

                                      setItemEditedRow(obj);
                                    }
                                  }}
                                  sx={{
                                    ".css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                                      {
                                        paddingBottom: "5px",
                                      },
                                    ".css-lcu7oo-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                                      {
                                        paddingTop: "6px",
                                        paddingBottom: "5px",
                                        paddingLeft: "6px",
                                      },
                                  }}
                                  size="small"
                                  renderInput={(params) => (
                                    <TextField
                                      sx={{
                                        ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                                          {
                                            padding: "8.5px 7px",
                                          },
                                        ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                          {
                                            fontSize: "14px",
                                          },
                                        label: {
                                          fontSize: "14px",
                                        },
                                        ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root":
                                          {
                                            fontSize: "14px",
                                          },
                                        ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                          {
                                            color: "input.font",
                                          },
                                        ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                          {
                                            borderColor: "input.border",
                                          },
                                        ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root":
                                          {
                                            color: "input.font",
                                          },
                                        ".css-14qz1ij-MuiListItemText-root": {
                                          margin: "0px",
                                        },
                                        ".css-wgai2y-MuiFormLabel-asterisk": {
                                          color: "danger.main",
                                        },
                                      }}
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      {...params}
                                      required={true}
                                      label="Item Code"
                                    />
                                  )}
                                />
                              </Box>
                            </TableCell>
                            <TableCell sx={{ minWidth: "150px" }}>
                              <Box
                                sx={{
                                  flex: { xs: 1, sm: 0.5 },
                                  position: "relative",
                                  marginTop: "15px",
                                }}
                              >
                                {
                                  // ItemId != "" ||
                                  itemEditedRow?.name?.value !== "" ? (
                                    <Typography
                                      sx={{
                                        justifyContent: "flex-art",
                                        color: "primary.main",
                                        display: "flex",
                                        alignItems: "center",
                                        fontSize: "13px",
                                        position: "absolute",
                                        right: "0",
                                        top: "-24px",
                                      }}
                                    >
                                      <Link
                                        disabled={
                                          itemEditedRow?.name?.label == ""
                                            ? true
                                            : false
                                        }
                                        color={
                                          params?.view == true ||
                                          itemEditedRow?.name?.label == ""
                                            ? "input.border"
                                            : "primary.main"
                                        }
                                        href="#"
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          cursor:
                                            params?.view == true ||
                                            itemEditedRow?.name?.label == ""
                                              ? "default"
                                              : "",
                                        }}
                                        onClick={(event) => {
                                          // event.preventDefault();
                                          if (
                                            params?.view !== true &&
                                            itemEditedRow?.name?.label !== ""
                                            // state.salesInvoice == 1
                                          ) {
                                            setItemId(
                                              itemEditedRow?.name?.value
                                            );
                                            getItemType(
                                              itemEditedRow?.name?.value
                                            );
                                            setBackdropOpen(true);
                                            setItemModal(true);
                                          }
                                        }}
                                      >
                                        <EditIcon
                                          disabled={
                                            params?.view == true ||
                                            itemEditedRow?.name?.label == ""
                                              ? true
                                              : false
                                          }
                                          fontSize="8px"
                                          sx={{ marginRight: "5px" }}
                                        />
                                        Edit Item
                                      </Link>
                                    </Typography>
                                  ) : (
                                    <Typography
                                      sx={{
                                        justifyContent: "flex-art",
                                        color: "primary.main",
                                        display: "flex",
                                        alignItems: "center",
                                        fontSize: "13px",
                                        position: "absolute",
                                        right: "0",
                                        top: "-24px",
                                      }}
                                    >
                                      <Link
                                        disabled={
                                          itemEditedRow?.name?.label == ""
                                            ? true
                                            : false
                                        }
                                        color={
                                          params?.view == true ||
                                          data?.partyName?.value == ""
                                            ? "input.border"
                                            : "primary.main"
                                        }
                                        href="#"
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          cursor:
                                            params?.view == true ||
                                            itemEditedRow?.name?.label == ""
                                              ? "default"
                                              : "",
                                        }}
                                        onClick={(event) => {
                                          setBackdropOpen(true);
                                          setAddItemModal(true);
                                        }}
                                      >
                                        <AddIcon
                                          disabled={
                                            params?.view == true ||
                                            data?.partyName?.value == ""
                                              ? true
                                              : false
                                          }
                                          fontSize="8px"
                                          sx={{ marginRight: "5px" }}
                                        />
                                        Add Item
                                      </Link>
                                    </Typography>
                                  )
                                }
                                <Autocomplete
                                  // disablePortal
                                  id="combo-box-demo"
                                  disableClearable
                                  options={itemsName}
                                  {...defaultProps}
                                  value={itemEditedRow.name}
                                  disabled={
                                    data.partyName.value == "" ? true : false
                                  }
                                  isOptionEqualToValue={(option, value) =>
                                    option.value == value.value
                                  }
                                  onChange={async (e, newValue) => {
                                    setItemId(newValue.value);
                                    getItemType(newValue.value);
                                    if (newValue !== null) {
                                      let obj = {};
                                      let hsnobj254 = {};
                                      await Promise.all(
                                        allItemData?.map(async (item) => {
                                          if (item.ItemID == newValue.value) {
                                            hsnobj254 = await searchSACItem(
                                              item.HSNID
                                            );
                                          }
                                        })
                                      );
                                      allItemData?.map((item) => {
                                        if (item.ItemID == newValue.value) {
                                          //console.log(item);
                                          let gstrate = "";
                                          let itemRate = "";
                                          let cess = "";
                                          item.relatedItemAmountDetails !==
                                            null &&
                                            item?.relatedItemAmountDetails.map(
                                              (ele) => {
                                                // console.log(ele);
                                                if (
                                                  new Date().getTime() >=
                                                    new Date(
                                                      ele.EffectiveDate * 1000
                                                    ).getTime() &&
                                                  new Date().getTime() <=
                                                    new Date(
                                                      ele.ExpiredDate * 1000
                                                    )
                                                ) {
                                                  gstrate = ele.GSTRATE;
                                                  itemRate = ele.Amount;
                                                  if (
                                                    ele.GSTCompensationType ===
                                                    "Amount"
                                                  )
                                                    cess =
                                                      ele.GSTCompensationValue;
                                                  else
                                                    cess =
                                                      (Number(ele.Amount) *
                                                        Number(
                                                          ele.GSTCompensationValue
                                                        )) /
                                                      100;
                                                } else if (
                                                  ele.ExpiredDate == 0
                                                ) {
                                                  if (
                                                    new Date().getTime() >=
                                                    new Date(
                                                      ele.EffectiveDate * 1000
                                                    ).getTime()
                                                  ) {
                                                    gstrate = ele.GSTRATE;
                                                    itemRate = ele.Amount;
                                                  }
                                                  if (
                                                    ele.GSTCompensationType ===
                                                    "Amount"
                                                  )
                                                    cess =
                                                      ele.GSTCompensationValue;
                                                  else
                                                    cess =
                                                      (Number(ele.Amount) *
                                                        Number(
                                                          ele.GSTCompensationValue
                                                        )) /
                                                      100;
                                                }
                                              }
                                            );

                                          let accountobj = {
                                            label: "",
                                            value: "",
                                          };
                                          accName?.map((code) => {
                                            if (
                                              data.purchaseOrSalseFlag == "1"
                                            ) {
                                              if (
                                                code.value ==
                                                item.PurchaseAccountID
                                              ) {
                                                console.log(code);
                                                accountobj = {
                                                  label: code.label,
                                                  value: code.value,
                                                };
                                              }
                                            } else {
                                              if (
                                                code.value ==
                                                item.SalesAccountID
                                              ) {
                                                console.log(code);
                                                accountobj = {
                                                  label: "Sales Return A/c",
                                                  value: "",
                                                };
                                              }
                                            }
                                          });
                                          let itemCodeObj = {
                                            label: "",
                                            value: "",
                                          };
                                          itemsCode?.map((ele) => {
                                            if (ele.value == item.ItemID) {
                                              itemCodeObj = {
                                                label: ele.label,
                                                value: ele.value,
                                              };
                                            }
                                          });
                                          obj = { ...itemEditedRow };
                                          obj.name = newValue;
                                          obj.purchaseAccount = accountobj;
                                          obj.units = item.MeasurementCD;
                                          obj.GSTRate = gstrate;
                                          obj.rate = itemRate;
                                          obj.GSTCess = cess;
                                          obj.amount = itemRate;
                                          obj.taxableAMount = itemRate;
                                          obj.itemCode = itemCodeObj;
                                          obj.HSN = hsnobj254.hsnObj;
                                          obj.HSNArray = hsnobj254.arr;
                                        }
                                      });

                                      setItemEditedRow(obj);
                                    }
                                  }}
                                  sx={{
                                    ".css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                                      {
                                        paddingBottom: "5px",
                                      },
                                    ".css-lcu7oo-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                                      {
                                        paddingTop: "6px",
                                        paddingBottom: "5px",
                                        paddingLeft: "6px",
                                      },
                                  }}
                                  size="small"
                                  renderInput={(params) => (
                                    <TextField
                                      sx={{
                                        ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                                          {
                                            padding: "8.5px 7px",
                                          },
                                        ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                          {
                                            fontSize: "14px",
                                          },
                                        label: {
                                          fontSize: "14px",
                                        },
                                        ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root":
                                          {
                                            fontSize: "14px",
                                          },
                                        ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                          {
                                            color: "input.font",
                                          },
                                        ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                          {
                                            borderColor: "input.border",
                                          },
                                        ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root":
                                          {
                                            color: "input.font",
                                          },
                                        ".css-14qz1ij-MuiListItemText-root": {
                                          margin: "0px",
                                        },
                                        ".css-wgai2y-MuiFormLabel-asterisk": {
                                          color: "danger.main",
                                        },
                                      }}
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      {...params}
                                      required={true}
                                      label="Item name"
                                    />
                                  )}
                                />
                              </Box>
                            </TableCell>
                            {/* <TableCell sx={{ minWidth: "100px" }}>

                              <Autocomplete
                                disablePortal
                                id="purchaseAccount"
                                disableClearable
                                options={accName}
                                disabled={
                                  itemEditedRow.name.label == "" ? true : false
                                }
                                isOptionEqualToValue={(option, value) =>
                                  option.value == value.value
                                }
                                value={itemEditedRow.purchaseAccount}
                                onChange={(e, newValue) => {
                                  console.log(newValue);
                                  setItemEditedRow((prev) => ({
                                    ...prev,
                                    purchaseAccount: newValue,
                                  }));
                                }}
                                sx={{
                                  ".css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                                  {
                                    paddingBottom: "5px",
                                  },
                                  ".css-lcu7oo-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                                  {
                                    paddingTop: "6px",
                                    paddingBottom: "5px",
                                    paddingLeft: "6px",
                                  },
                                }}
                                size="small"
                                renderInput={(params) => (
                                  <TextField
                                    sx={{
                                      ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                                      {
                                        padding: "8.5px 7px",
                                      },
                                      ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                      {
                                        fontSize: "14px",
                                      },
                                      label: {
                                        fontSize: "14px",
                                      },
                                      ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root":
                                      {
                                        fontSize: "14px",
                                      },
                                      ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                      {
                                        color: "input.font",
                                      },
                                      ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                      {
                                        borderColor: "input.border",
                                      },
                                      ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root":
                                      {
                                        color: "input.font",
                                      },
                                      ".css-14qz1ij-MuiListItemText-root": {
                                        margin: "0px",
                                      },
                                      ".css-wgai2y-MuiFormLabel-asterisk": {
                                        color: "danger.main",
                                      },
                                    }}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    {...params}
                                    label=""
                                  />
                                )}
                              />
                            </TableCell> */}
                            <TableCell sx={{ minWidth: "200px" }}>
                              <Autocomplete
                                disablePortal
                                id="hsnCode"
                                disableClearable
                                options={filterHSN}
                                onInputChange={(e, value) => {
                                  if (value.length >= 3) {
                                    setCompleteSnakbar(false);
                                    setSearchValue(value.length);
                                    searchSAC(value);
                                  } else {
                                    if (e) {
                                      setCompleteSnakbar(true);
                                      setWarningMessage(
                                        "Use atleast 3 characters"
                                      );
                                    }
                                  }
                                }}
                                disabled={
                                  itemEditedRow.name.label == "" ? true : false
                                }
                                isOptionEqualToValue={(option, value) =>
                                  option.value == value.value
                                }
                                value={itemEditedRow.HSN}
                                onChange={(e, newValue) => {
                                  console.log(newValue);
                                  setItemEditedRow((prev) => ({
                                    ...prev,
                                    HSN: newValue,
                                  }));
                                }}
                                sx={{
                                  mt: "15px",
                                  ".css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                                    {
                                      paddingBottom: "5px",
                                    },
                                  ".css-lcu7oo-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                                    {
                                      paddingTop: "6px",
                                      paddingBottom: "5px",
                                      paddingLeft: "6px",
                                    },
                                }}
                                size="small"
                                renderInput={(params) => (
                                  <TextField
                                    sx={{
                                      ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                                        {
                                          padding: "8.5px 7px",
                                        },
                                      ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                        {
                                          fontSize: "14px",
                                        },
                                      label: {
                                        fontSize: "14px",
                                      },
                                      ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root":
                                        {
                                          fontSize: "14px",
                                        },
                                      ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                        {
                                          color: "input.font",
                                        },
                                      ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                        {
                                          borderColor: "input.border",
                                        },
                                      ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root":
                                        {
                                          color: "input.font",
                                        },
                                      ".css-14qz1ij-MuiListItemText-root": {
                                        margin: "0px",
                                      },
                                      ".css-wgai2y-MuiFormLabel-asterisk": {
                                        color: "danger.main",
                                      },
                                    }}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    {...params}
                                    label=""
                                  />
                                )}
                              />
                            </TableCell>
                            <TableCell sx={{ minWidth: "50px" }}>
                              <TextField
                                value={itemEditedRow?.qty}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  let amount = "";
                                  let taxableAmount = "";
                                  if (value !== "") {
                                    if (itemEditedRow.rate !== "") {
                                      amount =
                                        Number(value) *
                                        Number(itemEditedRow.rate);
                                      if (itemEditedRow.dicount !== "") {
                                        taxableAmount =
                                          Number(amount) -
                                          Number(itemEditedRow.dicount);
                                      } else {
                                        taxableAmount = Number(amount);
                                      }
                                    } else {
                                      amount = "";
                                      taxableAmount = "";
                                    }
                                  } else {
                                    amount = "";
                                    taxableAmount = "";
                                  }
                                  setItemEditedRow((prev) => ({
                                    ...prev,
                                    qty: value,
                                    amount: amount,
                                    taxableAMount: taxableAmount,
                                  }));
                                }}
                                disabled={
                                  itemEditedRow.name.label == "" ? true : false
                                }
                                id="qty"
                                label=""
                                type="number"
                                variant="outlined"
                                size="small"
                                fullWidth
                                sx={{
                                  mt: "15px",
                                  ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                                    {
                                      padding: "8.5px 7px",
                                    },
                                  ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                    {
                                      fontSize: "14px",
                                    },
                                  label: {
                                    fontSize: "14px",
                                  },
                                  ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                    {
                                      color: "input.font",
                                    },
                                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "input.border",
                                    },
                                  ".css-wgai2y-MuiFormLabel-asterisk": {
                                    color: "danger.main",
                                  },
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                onKeyPress={(event) => {
                                  if (
                                    event?.key === "-" ||
                                    event?.key === "+"
                                  ) {
                                    event.preventDefault();
                                  }
                                }}
                                InputProps={{
                                  inputProps: {
                                    min: 0,
                                  },
                                }}
                              />
                            </TableCell>

                            <TableCell sx={{ minWidth: "100px" }}>
                              <TextField
                                select
                                name="units"
                                value={itemEditedRow.units}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  console.log(value);

                                  setItemEditedRow((prev) => ({
                                    ...prev,
                                    units: value,
                                  }));
                                }}
                                disabled={
                                  itemEditedRow.name.label == "" ? true : false
                                }
                                id="units"
                                label=""
                                variant="outlined"
                                size="small"
                                fullWidth
                                sx={{
                                  minWidth: "100px",
                                  maxWidth: "100px",
                                  mt: "15px",
                                  ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                    {
                                      fontSize: "14px",
                                    },
                                  label: {
                                    fontSize: "14px",
                                  },
                                  ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root":
                                    {
                                      fontSize: "14px",
                                    },
                                  ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                    {
                                      color: "input.font",
                                    },
                                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "input.border",
                                    },
                                  ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root":
                                    {
                                      color: "input.font",
                                    },
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              >
                                {units?.map((item) => {
                                  return (
                                    <MenuItem
                                      key={item.value}
                                      value={item.value}
                                    >
                                      <ListItemText
                                        sx={{ margin: "0px" }}
                                        primary={item.option}
                                      />
                                    </MenuItem>
                                  );
                                })}
                              </TextField>
                            </TableCell>

                            <TableCell sx={{ minWidth: "50px" }}>
                              <TextField
                                value={itemEditedRow?.rate}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  let amount = "";
                                  let taxableAmount = "";
                                  if (value !== "") {
                                    if (itemEditedRow.qty !== "") {
                                      amount =
                                        Number(itemEditedRow.qty) *
                                        Number(value);
                                      if (itemEditedRow.dicount !== "") {
                                        taxableAmount =
                                          Number(amount) -
                                          Number(itemEditedRow.dicount);
                                      } else {
                                        taxableAmount = Number(amount);
                                      }
                                    } else {
                                      amount = "";
                                      taxableAmount = "";
                                    }
                                  } else {
                                    amount = "";
                                    taxableAmount = "";
                                  }
                                  setItemEditedRow((prev) => ({
                                    ...prev,
                                    rate: value,
                                    amount: amount,
                                    taxableAMount: taxableAmount,
                                  }));
                                }}
                                type="number"
                                disabled={
                                  itemEditedRow.name.label == "" ? true : false
                                }
                                id="rate"
                                label="Rate"
                                required={true}
                                variant="outlined"
                                size="small"
                                fullWidth
                                sx={{
                                  mt: "15px",
                                  ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                                    {
                                      padding: "8.5px 7px",
                                    },
                                  ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                    {
                                      fontSize: "14px",
                                    },
                                  label: {
                                    fontSize: "14px",
                                  },
                                  ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                    {
                                      color: "input.font",
                                    },
                                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "input.border",
                                    },
                                  ".css-wgai2y-MuiFormLabel-asterisk": {
                                    color: "danger.main",
                                  },
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                InputProps={{
                                  inputProps: {
                                    min: 0,
                                  },
                                }}
                                onKeyPress={(event) => {
                                  if (
                                    event?.key === "-" ||
                                    event?.key === "+"
                                  ) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                            </TableCell>
                            <TableCell sx={{ minWidth: "50px" }}>
                              {/* <TextField
                                value={itemEditedRow?.amount}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  let taxableAmount = "";
                                  if (value !== "") {
                                    if (itemEditedRow.dicount !== "") {
                                      taxableAmount =
                                        (Number(itemEditedRow.qty).toFixed(2) * Number(itemEditedRow.rate).toFixed(2)).toFixed(2)-
                                        Number(itemEditedRow.dicount).toFixed(
                                          2
                                        );
                                    } else {
                                      taxableAmount = (Number(itemEditedRow.qty).toFixed(2) *Number(itemEditedRow.rate).toFixed(2)).toFixed(2);
                                    }
                                  } else {
                                    taxableAmount = "";
                                  }

                                  setItemEditedRow((prev) => ({
                                    ...prev,
                                    amount: value,
                                    taxableAMount: taxableAmount,
                                  }));
                                }}
                                type="number"
                                disabled={
                                  itemEditedRow.name.label == "" ? true : false
                                }
                                id="amount"
                                label="Amount"
                                required={true}
                                variant="outlined"
                                size="small"
                                fullWidth
                                sx={{
                                  mt: "15px",
                                  ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                                    {
                                      padding: "8.5px 7px",
                                    },
                                  ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                    {
                                      fontSize: "14px",
                                    },
                                  label: {
                                    fontSize: "14px",
                                  },
                                  ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                    {
                                      color: "input.font",
                                    },
                                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "input.border",
                                    },
                                  ".css-wgai2y-MuiFormLabel-asterisk": {
                                    color: "danger.main",
                                  },
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                InputProps={{
                                  inputProps: {
                                    min: 0,
                                  },
                                }}
                                onKeyPress={(event) => {
                                  if (
                                    event?.key === "-" ||
                                    event?.key === "+"
                                  ) {
                                    event.preventDefault();
                                  }
                                }}
                              /> */}
                              <Typography sx={{ fontSize: "14px", mt: "15px" }}>
                                {MoneyFormat(
                                  (
                                    Number(itemEditedRow.qty).toFixed(2) *
                                    Number(itemEditedRow.rate).toFixed(2)
                                  ).toFixed(2),
                                  "en-IN"
                                )}
                              </Typography>
                            </TableCell>

                            <TableCell sx={{ minWidth: "50px" }}>
                              <TextField
                                value={itemEditedRow?.dicount}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  let taxableAmount = "";
                                  if (value !== "") {
                                    if (itemEditedRow.taxableAMount !== "") {
                                      taxableAmount =
                                        (
                                          Number(itemEditedRow.qty).toFixed(2) *
                                          Number(itemEditedRow.rate).toFixed(2)
                                        ).toFixed(2) - Number(value).toFixed(2);
                                    } else {
                                      taxableAmount = "";
                                    }
                                  } else {
                                    taxableAmount = (
                                      Number(itemEditedRow.qty).toFixed(2) *
                                      Number(itemEditedRow.rate).toFixed(2)
                                    ).toFixed(2);
                                  }
                                  setItemEditedRow((prev) => ({
                                    ...prev,
                                    dicount: value,
                                    taxableAMount: taxableAmount,
                                  }));
                                }}
                                disabled={
                                  itemEditedRow.name.label == "" ? true : false
                                }
                                id="dicount"
                                label=""
                                type="number"
                                variant="outlined"
                                size="small"
                                fullWidth
                                sx={{
                                  mt: "15px",
                                  ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                                    {
                                      padding: "8.5px 7px",
                                    },
                                  ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                    {
                                      fontSize: "14px",
                                    },
                                  label: {
                                    fontSize: "14px",
                                  },
                                  ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                    {
                                      color: "input.font",
                                    },
                                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "input.border",
                                    },
                                  ".css-wgai2y-MuiFormLabel-asterisk": {
                                    color: "danger.main",
                                  },
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                InputProps={{
                                  inputProps: {
                                    min: 0,
                                  },
                                }}
                                onKeyPress={(event) => {
                                  if (
                                    event?.key === "-" ||
                                    event?.key === "+"
                                  ) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                            </TableCell>
                            <TableCell>
                              <Typography sx={{ fontSize: "14px", mt: "15px" }}>
                                {MoneyFormat(
                                  (
                                    Number(itemEditedRow.qty).toFixed(2) *
                                      Number(itemEditedRow.rate).toFixed(2) -
                                    Number(itemEditedRow.dicount).toFixed(2)
                                  ).toFixed(2),
                                  "en-IN"
                                )}
                              </Typography>
                            </TableCell>

                            <TableCell sx={{ minWidth: "60px" }}>
                              <TextField
                                select
                                name="GSTRate"
                                value={itemEditedRow.GSTRate}
                                onChange={(e) => {
                                  const value = e.target.value;

                                  setItemEditedRow((prev) => ({
                                    ...prev,
                                    GSTRate: value,
                                  }));
                                }}
                                disabled={
                                  itemEditedRow.name.label == "" ? true : false
                                }
                                id="GSTRate"
                                label="GR"
                                required={true}
                                variant="outlined"
                                size="small"
                                fullWidth
                                sx={{
                                  minWidth: "80px",
                                  maxWidth: "80px",
                                  mt: "15px",
                                  ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                    {
                                      fontSize: "14px",
                                    },
                                  label: {
                                    fontSize: "14px",
                                  },
                                  ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root":
                                    {
                                      fontSize: "14px",
                                    },
                                  ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                    {
                                      color: "input.font",
                                    },
                                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "input.border",
                                    },
                                  ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root":
                                    {
                                      color: "input.font",
                                    },
                                  ".css-wgai2y-MuiFormLabel-asterisk": {
                                    color: "danger.main",
                                  },
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              >
                                {[
                                  { id: 0, rate: "0%" },
                                  { id: 5, rate: "5%" },
                                  { id: 12, rate: "12%" },
                                  { id: 18, rate: "18%" },
                                  { id: 28, rate: "28%" },
                                ].map((item) => {
                                  return (
                                    <MenuItem
                                      key={item.id}
                                      value={`${item.id}`}
                                    >
                                      <ListItemText
                                        sx={{ margin: "0px" }}
                                        primary={item.rate}
                                      />
                                    </MenuItem>
                                  );
                                })}
                              </TextField>
                            </TableCell>

                            <TableCell align="center">
                              {/* <LightTooltip title={
                                                                        <React.Fragment>
                                                                            <Typography align='center' fontWeight='bold'>{itemEditedRow.name.label}</Typography>
                                                                            <Typography align='center'>IGST : {itemEditedRow.IGST}</Typography>
                                                                            <Typography align='center'>CGST : {itemEditedRow.CGST}</Typography>
                                                                            <Typography align='center'>SGST : {itemEditedRow.SGST}</Typography>
                                                                        </React.Fragment>
                                                                    } arrow>
                                                                        <Button>₹ 2500</Button>
                                                                    </LightTooltip> */}
                              <Typography
                                sx={{ marginTop: "15px", fontSize: "14px" }}
                              >
                                {MoneyFormat(
                                  Number(itemEditedRow.taxableAMount) *
                                    Number(itemEditedRow.GSTRate / 100),
                                  "en-IN"
                                )}
                              </Typography>
                            </TableCell>
                            <TableCell sx={{ minWidth: "50px" }}>
                              <TextField
                                value={itemEditedRow?.GSTCess}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  let grandTotal = "";
                                  if (value !== "") {
                                    if (itemEditedRow.taxableAMount !== "") {
                                      grandTotal =
                                        Number(itemEditedRow.taxableAMount) +
                                        Number(value) +
                                        Number(itemEditedRow.taxableAMount) *
                                          Number(itemEditedRow.GSTRate / 100);
                                    } else {
                                      grandTotal = "";
                                    }
                                  } else {
                                    grandTotal = itemEditedRow.taxableAMount;
                                  }
                                  setItemEditedRow((prev) => ({
                                    ...prev,
                                    GSTCess: value,
                                    // taxableAMount:taxableAmount
                                    netAmount: grandTotal,
                                  }));
                                }}
                                disabled={
                                  itemEditedRow.name.label == "" ? true : false
                                }
                                id="dicount"
                                label=""
                                type="number"
                                variant="outlined"
                                size="small"
                                fullWidth
                                sx={{
                                  mt: "15px",
                                  ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                                    {
                                      padding: "8.5px 7px",
                                    },
                                  ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                    {
                                      fontSize: "14px",
                                    },
                                  label: {
                                    fontSize: "14px",
                                  },
                                  ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                    {
                                      color: "input.font",
                                    },
                                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "input.border",
                                    },
                                  ".css-wgai2y-MuiFormLabel-asterisk": {
                                    color: "danger.main",
                                  },
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                InputProps={{
                                  inputProps: {
                                    min: 0,
                                  },
                                }}
                                onKeyPress={(event) => {
                                  if (
                                    event?.key === "-" ||
                                    event?.key === "+"
                                  ) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <Typography
                                sx={{ marginTop: "15px", fontSize: "14px" }}
                              >
                                {MoneyFormat(itemEditedRow.netAmount, "en-IN")}
                              </Typography>
                            </TableCell>
                            {params?.view !== true && (
                              <TableCell align="right">
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    mt: "15px",
                                  }}
                                >
                                  <IconButton
                                    disableRipple
                                    aria-label="delete"
                                    disabled={
                                      data.partyName.value == "" ? true : false
                                    }
                                    sx={{
                                      margin: "0px 2px",
                                      padding: "5px",
                                      backgroundColor: "#83ff7b7a",
                                    }}
                                    onClick={() => {
                                      if (params?.view != true) {
                                        saveChangesInRows(index);
                                      }
                                    }}
                                  >
                                    <DoneIcon
                                      sx={{
                                        fontSize: "18px",
                                        color:
                                          data.partyName.value !== ""
                                            ? "#34994f"
                                            : "#C9C9C9",
                                      }}
                                    />
                                  </IconButton>
                                  {items.length > 1 && (
                                    <IconButton
                                      disableRipple
                                      aria-label="delete"
                                      sx={{
                                        margin: "0px 2px",
                                        padding: "5px",
                                        backgroundColor: "#fbc7c78c",
                                      }}
                                      onClick={() => {
                                        if (params?.view != true) {
                                          closeChangesInRows(index);
                                        }
                                      }}
                                    >
                                      <CloseIcon
                                        sx={{
                                          fontSize: "18px",
                                          color: "#eb6a6a",
                                        }}
                                      />
                                    </IconButton>
                                  )}
                                </Box>
                              </TableCell>
                            )}
                          </TableRow>
                        );
                      } else {
                        let IgstValue =
                          Number(col.taxableAMount) * Number(col.GSTRate / 100);
                        let CgstValue =
                          (Number(col.taxableAMount) *
                            Number(col.GSTRate / 100)) /
                          2;
                        let SgstValue =
                          (Number(col.taxableAMount) *
                            Number(col.GSTRate / 100)) /
                          2;
                        return (
                          <TableRow hover role="checkbox" key={index}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{col.itemCode.label}</TableCell>
                            <TableCell>{col.name.label}</TableCell>
                            {/* <TableCell>
                              {accountsObj[col.purchaseAccount?.value]}
                            </TableCell> */}
                            <TableCell>{col.HSN.value}</TableCell>
                            <TableCell>{col.qty}</TableCell>
                            <TableCell>{unitsObj[col.units]}</TableCell>
                            <TableCell>
                              {MoneyFormat(
                                col.rate == "" ? 0 : col.rate,
                                "en-IN"
                              )}
                            </TableCell>
                            <TableCell>
                              {MoneyFormat(
                                col.amount == ""
                                  ? 0
                                  : (
                                      Number(col.rate).toFixed(2) *
                                      Number(col.qty).toFixed(2)
                                    ).toFixed(2),
                                "en-IN"
                              )}
                            </TableCell>
                            <TableCell>
                              {MoneyFormat(
                                col.dicount == "" ? 0 : col.dicount,
                                "en-IN"
                              )}
                            </TableCell>
                            <TableCell>
                              {MoneyFormat(
                                col.taxableAMount == "" ? 0 : col.taxableAMount,
                                "en-IN"
                              )}
                            </TableCell>
                            <TableCell>{col.GSTRate}</TableCell>

                            <TableCell>
                              <LightTooltip
                                title={
                                  <React.Fragment>
                                    <Typography
                                      align="center"
                                      fontWeight="bold"
                                    >
                                      {col.name.label}
                                    </Typography>
                                    <Typography align="center">
                                      IGST :{" "}
                                      {data.placeOfSupply != "KeralaDistrict"
                                        ? Number(IgstValue).toFixed(2)
                                        : Number(0).toFixed(2)}
                                    </Typography>
                                    <Typography align="center">
                                      CGST :{" "}
                                      {data.placeOfSupply == "KeralaDistrict"
                                        ? Number(CgstValue).toFixed(2)
                                        : Number(0).toFixed(2)}
                                    </Typography>
                                    <Typography align="center">
                                      SGST :{" "}
                                      {data.placeOfSupply == "KeralaDistrict"
                                        ? Number(SgstValue).toFixed(2)
                                        : Number(0).toFixed(2)}
                                    </Typography>
                                  </React.Fragment>
                                }
                                arrow
                              >
                                <Button>
                                  {data.placeOfSupply == "KeralaDistrict"
                                    ? MoneyFormat(
                                        (Number(col.taxableAMount) *
                                          Number(col.GSTRate / 100)) /
                                          2 +
                                          (Number(col.taxableAMount) *
                                            Number(col.GSTRate / 100)) /
                                            2,
                                        "en-IN"
                                      )
                                    : MoneyFormat(
                                        Number(col.taxableAMount) *
                                          Number(col.GSTRate / 100),
                                        "en-IN"
                                      )}
                                  {/* {MoneyFormat(Number(col.taxableAMount) * Number(col.GSTRate/100) + (Number(col.taxableAMount) * Number(col.GSTRate/100)) / 2 + (Number(col.taxableAMount) * Number(col.GSTRate/100)) / 2, 'en-IN')} */}
                                </Button>
                              </LightTooltip>
                            </TableCell>
                            <TableCell>
                              {MoneyFormat(
                                col.GSTCess == "" ? 0 : col.GSTCess,
                                "en-IN"
                              )}
                            </TableCell>
                            <TableCell>
                              {MoneyFormat(
                                col.netAmount == "" ? 0 : col.netAmount,
                                "en-IN"
                              )}
                            </TableCell>
                            {params?.view !== true && (
                              <TableCell align="right">
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <IconButton
                                    disabled={
                                      Object.keys(itemTempRow).length == 0
                                        ? false
                                        : true
                                    }
                                    disableRipple
                                    aria-label="delete"
                                    sx={{
                                      margin: "0px 2px",
                                      padding: "5px",
                                      backgroundColor: "#b1d1f97d",
                                    }}
                                    onClick={() => {
                                      if (params?.view != true) {
                                        if (
                                          Object.keys(itemTempRow).length == 0
                                        ) {
                                          setItemTempRow(col);
                                          setItemEditedRow(col);
                                          let arr = [...items];
                                          arr[index].editable = true;
                                          arr[index].new = false;
                                          setItems(arr);
                                        }
                                      }
                                    }}
                                  >
                                    <EditIcon
                                      sx={{
                                        fontSize: "15px",
                                        color: "#6096d9",
                                      }}
                                    />
                                  </IconButton>
                                  <IconButton
                                    disabled={
                                      Object.keys(itemTempRow).length == 0
                                        ? false
                                        : true
                                    }
                                    disableRipple
                                    aria-label="delete"
                                    sx={{
                                      margin: "0px 2px",
                                      padding: "5px",
                                      backgroundColor: "#fbc7c78c",
                                    }}
                                    onClick={() => {
                                      if (params?.view != true) {
                                        if (
                                          Object.keys(itemTempRow).length == 0
                                        ) {
                                          setDeleteEntriesModal(true);
                                          setEntryIndex(index);
                                        }
                                      }
                                    }}
                                  >
                                    <DeleteIcon
                                      sx={{
                                        fontSize: "15px",
                                        color: "#eb6a6a",
                                      }}
                                    />
                                  </IconButton>
                                </Box>
                              </TableCell>
                            )}
                          </TableRow>
                        );
                      }
                    })
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={15}>
                        No Items Found
                      </TableCell>
                    </TableRow>
                  )}
                  <TableRow>
                    <TableCell colSpan={7} sx={{ fontWeight: 600 }}>
                      Total (₹)
                    </TableCell>
                    <TableCell colSpan={1} sx={{ fontWeight: 600 }}>
                      {totAmount.toFixed(2)}
                    </TableCell>
                    <TableCell colSpan={1} sx={{ fontWeight: 600 }}>
                      {totDiscount.toFixed(2)}
                    </TableCell>
                    <TableCell colSpan={2} sx={{ fontWeight: 600 }}>
                      {totTaxableAmount.toFixed(2)}
                    </TableCell>
                    <TableCell
                      align="center"
                      colSpan={1}
                      sx={{ fontWeight: 600 }}
                    >
                      {totGST.toFixed(2)}
                    </TableCell>
                    <TableCell colSpan={1} sx={{ fontWeight: 600 }}>
                      {totGstCess}
                    </TableCell>
                    <TableCell colSpan={2} sx={{ fontWeight: 600 }}>
                      {tabelTotAmount.toFixed(2)}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Box>
              <Button
                disableRipple
                disableElevation
                size="small"
                variant="text"
                d
                onClick={() => itemWiseNewRow()}
                startIcon={<AddBox />}
                sx={{
                  fontSize: "14px",
                  marginTop: "15px",
                }}
                disabled={
                  Object.keys(itemTempRow).length > 0 || params?.view == true
                    ? true
                    : false
                }
              >
                Add New Line
              </Button>
            </Box>
            {/* <Typography onClick={() => itemWiseNewRow()} sx={{justifyContent:'flex-start',color:'primary.main',display:'flex',alignItems:'center',fontSize:'14px',marginTop:'15px',width:'130px',padding:'10px',cursor:'pointer'}}><AddBox fontSize='small' sx={{marginRight:'5px'}} /> Add New Line</Typography> */}
          </Box>
        </Paper>
      ) : (
        <Paper
          sx={{
            width: "100%",
            borderRadius: "12px",
            overflow: "hidden",
            marginTop: "20px",
            boxShadow:
              "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
            ":hover": {
              boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
            },
            transition: "all 1s ease-in-out",
            ".MuiTableCell-root": {
              padding: "10px 5px",
              fontSize: "13px",
            },
            ".MuiTableCell-head": {
              backgroundColor: "background.tablebg",
              padding: "10px 8px",
              borderBottom: "0px",
              fontSize: "13px",
              fontWeight: "bold",
            },
            ".MuiTableCell-head:first-of-type": {
              borderTopLeftRadius: "6px",
              borderBottomLeftRadius: "6px",
            },
            ".MuiTableCell-head:last-child": {
              borderTopRightRadius: "6px",
              borderBottomRightRadius: "6px",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              borderBottom: "solid 0px gray",
              padding: { xs: "10px 10px", sm: "10px 20px" },
            }}
          >
            <Box
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "10px 0px",
                color: "#ccccb3",
                borderBottom: "solid 2px #fff",
                cursor: "pointer",
              }}
              onClick={() => {
                if (params?.view !== true) {
                  if (nonItems.length > 0) {
                    if (nonItems.length == 1 && nonItemEditedRow.editable) {
                      setItemEntry(true);
                    } else {
                      setSwitchedTo("items");
                      setWarningText(
                        "If you Switch to Item Wise Entry , then the Non-Item Wise Entry Table is cleared."
                      );
                      setItemsWarningModal(true);
                    }
                  } else {
                    setItemEntry(true);
                  }
                }
              }}
            >
              <FormatListBulleted sx={{ marginRight: "10px" }} /> Item Wise
              Entry
            </Box>
            <Box
              sx={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "10px 0px",
                color: "primary.main",
                borderBottom: "solid 2px",
                borderColor: "primary.main",
                cursor: "pointer",
              }}
              onClick={() => {
                if (params?.view !== true) {
                  if (params?.id == undefined || null) {
                    setItemEntry(false);
                  }
                }
              }}
            >
              <FilterListOff sx={{ marginRight: "10px" }} /> Non-Item Wise Entry
            </Box>
          </Box>
          <Box sx={{ padding: { xs: "10px 10px", sm: "10px 20px" } }}>
            <TableContainer
              sx={{
                // maxHeight: 440,
                scrollbarWidth: "thin",
                "&::-webkit-scrollbar": {
                  width: "0.4em",
                  height: "0.4em",
                },
                "&::-webkit-scrollbar-track": {
                  background: `${theme.palette.primary.main}47`,
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "primary.main",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: `${theme.palette.primary.main}47`,
                },
              }}
            >
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {nonItemWiseHeader.map((column) => {
                      if (params?.view != true) {
                        return (
                          <TableCell
                            key={column.id}
                            // sx={{minWidth:column.width}}
                          >
                            {column.label}
                          </TableCell>
                        );
                      } else {
                        return (
                          column.label != "Action" && (
                            <TableCell
                              key={column.id}
                              // sx={{minWidth:column.width}}
                            >
                              {column.label}
                            </TableCell>
                          )
                        );
                      }
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {nonItems.length > 0 ? (
                    nonItems.map((column, index) => {
                      if (column.editable) {
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={index}
                          >
                            <TableCell>{index + 1}</TableCell>
                            <TableCell sx={{ minWidth: "200px" }}>
                              <Autocomplete
                                // disablePortal
                                id="ledgerAccount"
                                disableClearable
                                options={accName}
                                disabled={
                                  data.partyName.value == "" ? true : false
                                }
                                isOptionEqualToValue={(option, value) =>
                                  option.value == value.value
                                }
                                value={nonItemEditedRow.ledgerAccount}
                                onChange={(e, newValue) => {
                                  console.log(newValue);
                                  setNonItemEditedRow((prev) => ({
                                    ...prev,
                                    ledgerAccount: newValue,
                                  }));
                                }}
                                sx={{
                                  ".css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                                    {
                                      paddingBottom: "5px",
                                    },
                                  ".css-lcu7oo-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                                    {
                                      paddingTop: "6px",
                                      paddingBottom: "5px",
                                      paddingLeft: "6px",
                                    },
                                }}
                                size="small"
                                renderInput={(params) => (
                                  <TextField
                                    sx={{
                                      ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                                        {
                                          padding: "8.5px 7px",
                                        },
                                      ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                        {
                                          fontSize: "14px",
                                        },
                                      label: {
                                        fontSize: "14px",
                                      },
                                      ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root":
                                        {
                                          fontSize: "14px",
                                        },
                                      ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                        {
                                          color: "input.font",
                                        },
                                      ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                        {
                                          borderColor: "input.border",
                                        },
                                      ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root":
                                        {
                                          color: "input.font",
                                        },
                                      ".css-14qz1ij-MuiListItemText-root": {
                                        margin: "0px",
                                      },
                                      ".css-wgai2y-MuiFormLabel-asterisk": {
                                        color: "danger.main",
                                      },
                                    }}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    {...params}
                                    label="Ledger Account"
                                    required={true}
                                  />
                                )}
                              />
                            </TableCell>
                            <TableCell sx={{ minWidth: "180px" }}>
                              <Autocomplete
                                // disablePortal
                                id="HSN"
                                disableClearable
                                options={filterHSN}
                                disabled={
                                  data.partyName.value == "" ? true : false
                                }
                                isOptionEqualToValue={(option, value) =>
                                  option.value == value.value
                                }
                                value={nonItemEditedRow.HSN}
                                onInputChange={(e, value) => {
                                  if (value.length >= 3) {
                                    setCompleteSnakbar(false);
                                    setSearchValue(value.length);
                                    searchSAC(value);
                                  } else {
                                    setCompleteSnakbar(true);
                                    setWarningMessage(
                                      "Use atleast 3 characters"
                                    );
                                  }
                                }}
                                onChange={(e, newValue) => {
                                  setNonItemEditedRow((prev) => ({
                                    ...prev,
                                    HSN: newValue,
                                  }));
                                }}
                                sx={{
                                  ".css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                                    {
                                      paddingBottom: "5px",
                                    },
                                  ".css-lcu7oo-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                                    {
                                      paddingTop: "6px",
                                      paddingBottom: "5px",
                                      paddingLeft: "6px",
                                    },
                                }}
                                size="small"
                                renderInput={(params) => (
                                  <TextField
                                    sx={{
                                      ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                                        {
                                          padding: "8.5px 7px",
                                        },
                                      ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                        {
                                          fontSize: "14px",
                                        },
                                      label: {
                                        fontSize: "14px",
                                      },
                                      ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root":
                                        {
                                          fontSize: "14px",
                                        },
                                      ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                        {
                                          color: "input.font",
                                        },
                                      ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                        {
                                          borderColor: "input.border",
                                        },
                                      ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root":
                                        {
                                          color: "input.font",
                                        },
                                      ".css-14qz1ij-MuiListItemText-root": {
                                        margin: "0px",
                                      },
                                      ".css-wgai2y-MuiFormLabel-asterisk": {
                                        color: "danger.main",
                                      },
                                    }}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    {...params}
                                    label=""
                                  />
                                )}
                              />
                            </TableCell>
                            <TableCell sx={{ minWidth: "280px" }}>
                              <TextField
                                value={nonItemEditedRow?.description}
                                disabled={
                                  data.partyName.value == "" ? true : false
                                }
                                onChange={(e) => {
                                  const value = e.target.value;

                                  setNonItemEditedRow((prev) => ({
                                    ...prev,
                                    description: value,
                                  }));
                                }}
                                id="description"
                                label=""
                                type="text"
                                variant="outlined"
                                size="small"
                                fullWidth
                                sx={{
                                  ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                                    {
                                      padding: "8.5px 7px",
                                    },
                                  ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                    {
                                      fontSize: "14px",
                                    },
                                  label: {
                                    fontSize: "14px",
                                  },
                                  ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                    {
                                      color: "input.font",
                                    },
                                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "input.border",
                                    },
                                  ".css-wgai2y-MuiFormLabel-asterisk": {
                                    color: "danger.main",
                                  },
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              />
                            </TableCell>
                            <TableCell sx={{ minWidth: "80px" }}>
                              <TextField
                                value={nonItemEditedRow?.taxAMount}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  let totalAmount = 0;

                                  totalAmount =
                                    Number(value) +
                                    Number(
                                      Number(nonItemEditedRow.taxAMount) *
                                        Number(nonItemEditedRow.GSTRate / 100)
                                    ) +
                                    Number(nonItemEditedRow.GSTCess);

                                  setNonItemEditedRow((prev) => ({
                                    ...prev,
                                    taxAMount: value,
                                    netAmount: totalAmount,
                                  }));
                                }}
                                disabled={
                                  data.partyName.value == "" ? true : false
                                }
                                type="number"
                                id="amount"
                                label="TA"
                                required={true}
                                variant="outlined"
                                size="small"
                                fullWidth
                                sx={{
                                  ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                                    {
                                      padding: "8.5px 7px",
                                    },
                                  ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                    {
                                      fontSize: "14px",
                                    },
                                  label: {
                                    fontSize: "14px",
                                  },
                                  ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                    {
                                      color: "input.font",
                                    },
                                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "input.border",
                                    },
                                  ".css-wgai2y-MuiFormLabel-asterisk": {
                                    color: "danger.main",
                                  },
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                onKeyPress={(event) => {
                                  if (
                                    event?.key === "-" ||
                                    event?.key === "+"
                                  ) {
                                    event.preventDefault();
                                  }
                                }}
                                InputProps={{
                                  inputProps: {
                                    min: 0,
                                  },
                                }}
                              />
                            </TableCell>
                            <TableCell sx={{ minWidth: "80px" }}>
                              <TextField
                                select
                                name="GSTRate"
                                value={nonItemEditedRow.GSTRate}
                                disabled={
                                  data.partyName.value == "" ? true : false
                                }
                                onChange={(e) => {
                                  const value = e.target.value;
                                  let totalAmount = 0;

                                  totalAmount =
                                    Number(nonItemEditedRow.taxAMount) +
                                    Number(
                                      Number(nonItemEditedRow.taxAMount) *
                                        Number(value / 100)
                                    ) +
                                    Number(nonItemEditedRow.GSTCess);

                                  setNonItemEditedRow((prev) => ({
                                    ...prev,
                                    GSTRate: value,
                                    netAmount: totalAmount,
                                  }));
                                }}
                                id="GSTRate"
                                label="GR"
                                required={true}
                                variant="outlined"
                                size="small"
                                fullWidth
                                sx={{
                                  minWidth: "80px",
                                  maxWidth: "80px",
                                  ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                    {
                                      fontSize: "14px",
                                    },
                                  label: {
                                    fontSize: "14px",
                                  },
                                  ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root":
                                    {
                                      fontSize: "14px",
                                    },
                                  ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                    {
                                      color: "input.font",
                                    },
                                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "input.border",
                                    },
                                  ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root":
                                    {
                                      color: "input.font",
                                    },
                                  ".css-wgai2y-MuiFormLabel-asterisk": {
                                    color: "danger.main",
                                  },
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                              >
                                {[
                                  { id: 0, rate: "0%" },
                                  { id: 5, rate: "5%" },
                                  { id: 12, rate: "12%" },
                                  { id: 18, rate: "18%" },
                                  { id: 28, rate: "28%" },
                                ].map((item) => {
                                  return (
                                    <MenuItem
                                      key={item.id}
                                      value={`${item.id}`}
                                    >
                                      <ListItemText
                                        sx={{ margin: "0px" }}
                                        primary={item.rate}
                                      />
                                    </MenuItem>
                                  );
                                })}
                              </TextField>
                            </TableCell>
                            <TableCell align="center">
                              {MoneyFormat(
                                Number(nonItemEditedRow.taxAMount) *
                                  Number(nonItemEditedRow.GSTRate / 100),
                                "en-IN"
                              )}
                            </TableCell>
                            <TableCell sx={{ minWidth: "80px" }}>
                              <TextField
                                value={nonItemEditedRow?.GSTCess}
                                disabled={
                                  data.partyName.value == "" ? true : false
                                }
                                onChange={(e) => {
                                  const value = e.target.value;
                                  let grandTotal = "";
                                  if (value !== "") {
                                    if (nonItemEditedRow.taxAMount !== "") {
                                      grandTotal =
                                        Number(nonItemEditedRow.taxAMount) +
                                        Number(
                                          Number(nonItemEditedRow.taxAMount) *
                                            Number(
                                              nonItemEditedRow.GSTRate / 100
                                            )
                                        ) +
                                        Number(value);
                                    } else {
                                      grandTotal = "";
                                    }
                                  } else {
                                    grandTotal = nonItemEditedRow.taxAMount;
                                  }
                                  setNonItemEditedRow((prev) => ({
                                    ...prev,
                                    GSTCess: value,
                                    netAmount: grandTotal,
                                  }));
                                }}
                                id="dicount"
                                label=""
                                type="number"
                                variant="outlined"
                                size="small"
                                fullWidth
                                sx={{
                                  ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                                    {
                                      padding: "8.5px 7px",
                                    },
                                  ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                    {
                                      fontSize: "14px",
                                    },
                                  label: {
                                    fontSize: "14px",
                                  },
                                  ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                    {
                                      color: "input.font",
                                    },
                                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "input.border",
                                    },
                                  ".css-wgai2y-MuiFormLabel-asterisk": {
                                    color: "danger.main",
                                  },
                                }}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                InputProps={{
                                  inputProps: {
                                    min: 0,
                                  },
                                }}
                                onKeyPress={(event) => {
                                  if (
                                    event?.key === "-" ||
                                    event?.key === "+"
                                  ) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                            </TableCell>
                            <TableCell>
                              {MoneyFormat(nonItemEditedRow.netAmount, "en-IN")}
                            </TableCell>
                            {params?.view !== true && (
                              <TableCell align="right">
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <IconButton
                                    disableRipple
                                    aria-label="delete"
                                    disabled={
                                      data.partyName.value == "" ? true : false
                                    }
                                    sx={{
                                      margin: "0px 2px",
                                      padding: "5px",
                                      backgroundColor: "#83ff7b7a",
                                    }}
                                    onClick={() => {
                                      if (params?.view != true) {
                                        saveChangesInNonRows(index);
                                      }
                                    }}
                                  >
                                    <DoneIcon
                                      sx={{
                                        fontSize: "18px",
                                        color:
                                          data.partyName.value !== ""
                                            ? "#34994f"
                                            : "#C9C9C9",
                                      }}
                                    />
                                  </IconButton>
                                  {nonItems.length > 1 && (
                                    <IconButton
                                      disableRipple
                                      aria-label="delete"
                                      sx={{
                                        margin: "0px 2px",
                                        padding: "5px",
                                        backgroundColor: "#fbc7c78c",
                                      }}
                                      onClick={() => {
                                        if (params?.view != true) {
                                          noncloseChangesInRows(index);
                                        }
                                      }}
                                    >
                                      <CloseIcon
                                        sx={{
                                          fontSize: "18px",
                                          color: "#eb6a6a",
                                        }}
                                      />
                                    </IconButton>
                                  )}
                                </Box>
                              </TableCell>
                            )}
                          </TableRow>
                        );
                      } else {
                        let IgstValue =
                          Number(column.taxAMount) *
                          Number(column.GSTRate / 100);
                        let CgstValue =
                          (Number(column.taxAMount) *
                            Number(column.GSTRate / 100)) /
                          2;
                        let SgstValue =
                          (Number(column.taxAMount) *
                            Number(column.GSTRate / 100)) /
                          2;
                        return (
                          <TableRow hover role="checkbox" key={index}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>
                              {accountsObj[column.ledgerAccount.value]}
                            </TableCell>
                            <TableCell>{column.HSN.value}</TableCell>
                            <TableCell>{column.description}</TableCell>
                            <TableCell>
                              {MoneyFormat(
                                column.taxAMount == "" ? 0 : column.taxAMount,
                                "en-IN"
                              )}
                            </TableCell>
                            <TableCell>{column.GSTRate}</TableCell>

                            <TableCell>
                              <LightTooltip
                                title={
                                  <React.Fragment>
                                    <Typography
                                      align="center"
                                      fontWeight="bold"
                                    >
                                      {accountsObj[column.ledgerAccount.value]}
                                    </Typography>
                                    <Typography align="center">
                                      IGST :{" "}
                                      {data.placeOfSupply != "KeralaDistrict"
                                        ? Number(IgstValue).toFixed(2)
                                        : Number(0).toFixed(2)}
                                    </Typography>
                                    <Typography align="center">
                                      CGST :{" "}
                                      {data.placeOfSupply == "KeralaDistrict"
                                        ? Number(CgstValue).toFixed(2)
                                        : Number(0).toFixed(2)}
                                    </Typography>
                                    <Typography align="center">
                                      SGST :{" "}
                                      {data.placeOfSupply == "KeralaDistrict"
                                        ? Number(SgstValue).toFixed(2)
                                        : Number(0).toFixed(2)}
                                    </Typography>
                                  </React.Fragment>
                                }
                                arrow
                              >
                                <Button>
                                  {data.placeOfSupply == "KeralaDistrict"
                                    ? MoneyFormat(
                                        (Number(column.taxAMount) *
                                          Number(column.GSTRate / 100)) /
                                          2 +
                                          (Number(column.taxAMount) *
                                            Number(column.GSTRate / 100)) /
                                            2,
                                        "en-IN"
                                      )
                                    : MoneyFormat(
                                        Number(column.taxAMount) *
                                          Number(column.GSTRate / 100),
                                        "en-IN"
                                      )}
                                </Button>
                              </LightTooltip>
                            </TableCell>
                            <TableCell>
                              {MoneyFormat(
                                column.GSTCess == "" ? 0 : column.GSTCess,
                                "en-IN"
                              )}
                            </TableCell>
                            <TableCell>
                              {MoneyFormat(
                                column.netAmount == "" ? 0 : column.netAmount,
                                "en-IN"
                              )}
                            </TableCell>
                            {params?.view !== true && (
                              <TableCell align="center">
                                <Box
                                  sx={{
                                    display: "flex",
                                    // justifyContent: "center",
                                  }}
                                >
                                  <IconButton
                                    disabled={
                                      Object.keys(nonItemTempRow).length == 0
                                        ? false
                                        : true
                                    }
                                    disableRipple
                                    aria-label="delete"
                                    sx={{
                                      margin: "0px 2px",
                                      padding: "5px",
                                      backgroundColor: "#b1d1f97d",
                                    }}
                                    onClick={() => {
                                      if (params?.view != true) {
                                        if (
                                          Object.keys(nonItemTempRow).length ==
                                          0
                                        ) {
                                          setNonItemTempRow(column);
                                          setNonItemEditedRow(column);
                                          let arr = [...nonItems];
                                          arr[index].editable = true;
                                          arr[index].new = false;
                                          setNonItems(arr);
                                        }
                                      }
                                    }}
                                  >
                                    <EditIcon
                                      sx={{
                                        fontSize: "15px",
                                        color: "#6096d9",
                                      }}
                                    />
                                  </IconButton>
                                  <IconButton
                                    disabled={
                                      Object.keys(nonItemTempRow).length == 0
                                        ? false
                                        : true
                                    }
                                    disableRipple
                                    aria-label="delete"
                                    sx={{
                                      margin: "0px 2px",
                                      padding: "5px",
                                      backgroundColor: "#fbc7c78c",
                                    }}
                                    onClick={() => {
                                      if (params?.view != true) {
                                        if (
                                          Object.keys(nonItemTempRow).length ==
                                          0
                                        ) {
                                          setDeleteNonEntriesModal(true);
                                          setNonEntryIndex(index);
                                        }
                                      }
                                    }}
                                  >
                                    <DeleteIcon
                                      sx={{
                                        fontSize: "15px",
                                        color: "#eb6a6a",
                                      }}
                                    />
                                  </IconButton>
                                </Box>
                              </TableCell>
                            )}
                          </TableRow>
                        );
                      }
                    })
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={10}>
                        No Items Found
                      </TableCell>
                    </TableRow>
                  )}
                  <TableRow>
                    <TableCell colSpan={4} sx={{ fontWeight: 600 }}>
                      Total (₹)
                    </TableCell>
                    <TableCell colSpan={2} sx={{ fontWeight: 600 }}>
                      {totTaxableAmount.toFixed(2)}
                    </TableCell>
                    <TableCell
                      align="center"
                      colSpan={1}
                      sx={{ fontWeight: 600 }}
                    >
                      {totGST.toFixed(2)}
                    </TableCell>
                    <TableCell colSpan={1} sx={{ fontWeight: 600 }}>
                      {totGstCess}
                    </TableCell>
                    <TableCell colSpan={2} sx={{ fontWeight: 600 }}>
                      {totNetAmount.toFixed(2)}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
            <Box>
              <Button
                disableElevation
                disableRipple
                size="small"
                variant="text"
                onClick={() => nonItemWiseNewRow()}
                startIcon={<AddBox />}
                sx={{
                  fontSize: "14px",
                  marginTop: "15px",
                }}
                disabled={
                  Object.keys(nonItemEditedRow).length > 0 ||
                  params?.view == true
                    ? true
                    : false
                }
              >
                Add New Line
              </Button>
            </Box>
            {/* <Typography onClick={() => nonItemWiseNewRow()}  sx={{justifyContent:'flex-start',color:'primary.main',display:'flex',alignItems:'center',fontSize:'14px',marginTop:'15px',width:'130px',padding:'10px',cursor:'pointer'}}><AddBox fontSize='small' sx={{marginRight:'5px'}} /> Add New Line</Typography> */}
          </Box>
        </Paper>
      )}

      {/* <Box
        sx={{
          marginTop: "20px",
          padding: { xs: "10px 0px", sm: "10px 10px" },
          borderRadius: "12px",
          backgroundColor: "#fff",
          boxShadow:
            "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
          ":hover": {
            boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
          },
          transition: "all 1s ease-in-out",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: { sm: "start", md: "flex-start" },
            flexWrap: { xs: "wrap", md: "nowrap" },
            flexDirection: { xs: "column", sm: "row" },
            marginBottom: "0px",
          }}
        >
          <Box sx={{ flex: 1, m: 1 }}>
            <Box
              id="paymentType"
              sx={{
                position: "relative",
                border: "solid 1px",
                borderColor:
                  data?.errorStatus.paymentType === true
                    ? "danger.main"
                    : "input.border",
                borderRadius: "4px",
                padding: "9px 14px",
                boxSizing: "border-box",
                ".css-ahj2mt-MuiTypography-root": {
                  fontSize: "12px",
                  color:
                    data?.errorStatus.paymentType === true
                      ? "danger.main"
                      : "input.font",
                },
                ".css-1n70hd2-MuiButtonBase-root-MuiRadio-root": {
                  padding: "0px",
                  margin: "0px 5px",
                },
                ".css-1rfdfc4-MuiButtonBase-root-MuiRadio-root": {
                  padding: "0px",
                  margin: "0px 5px",
                  color: "input.border",
                },
                ".css-1rfdfc4-MuiButtonBase-root-MuiRadio-root.Mui-checked": {
                  color: "primary.main",
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: "0.75em",
                  letterSpacing: "0.00938em",
                  position: "absolute",
                  top: "-10px",
                  left: "9px",
                  background: "#fff",
                  padding: "0px 3px",
                  color:
                    data?.errorStatus.paymentType === true
                      ? "danger.main"
                      : "input.label",
                }}
              >
                Payment Type <span style={{ color: "#e55353" }}>*</span>
              </Typography>
              <RadioGroup
                disabled={params?.view == true ? true : false}
                sx={{
                  display: "flex",
                  flexDirection: { xs: "row", sm: "row" },
                }}
                name="paymentType"
                onChange={(e) => {
                  const value = e.target.value;
                  setPaidAccountName("");
                  if (value !== "") {
                    if (value == "Credit") {
                      setData((prev) => ({
                        ...prev,
                        paymentType: value,
                        recordAmount: "",
                        creditPeriod: creditPeriod,
                        creditToAccount: "",
                        errorStatus: {
                          ...prev.errorStatus,
                          paymentType: false,
                          recordAmount: false,
                          creditToAccount: false,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          paymentType: "",
                          recordAmount: "",
                          creditToAccount: "",
                        },
                      }));
                    } else {
                      setData((prev) => ({
                        ...prev,
                        paymentType: value,
                        creditToAccount: "",
                        creditPeriod: "",
                        errorStatus: {
                          ...prev.errorStatus,
                          paymentType: false,
                          creditPeriod: false,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          paymentType: "",
                          creditPeriod: "",
                        },
                      }));
                    }
                  }
                }}
                value={data.paymentType}
              >
                <FormControlLabel
                  disabled={
                    data.partyName.value == "" || params?.view == true
                      ? true
                      : false
                  }
                  name="paymentType"
                  value="Cash"
                  control={<Radio size="small" disableRipple />}
                  label="Cash/Part Payment"
                />
                <FormControlLabel
                  disabled={
                    data.partyName.value == "" || params?.view == true
                      ? true
                      : false
                  }
                  name="paymentType"
                  value="Bank"
                  control={<Radio size="small" />}
                  label="Bank/UPI/Card"
                />
                <FormControlLabel
                  disabled={
                    data.partyName.value == "" || params?.view == true
                      ? true
                      : false
                  }
                  name="paymentType"
                  value="Credit"
                  control={<Radio size="small" />}
                  label="Credit"
                />
              </RadioGroup>
            </Box>
            <Typography
              sx={{
                marginTop: "2px",
                marginLeft: "10px",
                marginBottom: "0px",
                fontSize: "11px",
                color: "danger.main",
              }}
            >
              {data?.errorFields.paymentType}
            </Typography>
          </Box>
          <Box sx={{ flex: 1, m: 1 }}>
            <TextField
              error={data.errorStatus.recordAmount == true ? true : false}
              value={data.recordAmount}
              disabled={
                data.paymentType === "Credit" ||
                data.paymentType === "" ||
                params?.view == true ||
                data.partyName.value == ""
                  ? true
                  : false
              }
              required={true}
              onChange={(e) => {
                const value = e.target.value;
                let total =
                  data.gstApplicable == "1" ? totNetAmount : totNonGstNetAmount;
                if (data.paymentType == "Cash" || data.paymentType == "Bank") {
                  if (value == "") {
                    setData((prev) => ({
                      ...prev,
                      recordAmount: value,
                      errorStatus: {
                        ...prev.errorStatus,
                        recordAmount: true,
                      },
                      errorFields: {
                        ...prev.errorFields,
                        recordAmount: "Record Amount is required",
                      },
                    }));
                  } else {
                    if (
                      !new RegExp(/^(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/).test(
                        value
                      )
                    ) {
                      setData((prev) => ({
                        ...prev,
                        recordAmount: value,
                        errorStatus: {
                          ...prev.errorStatus,
                          recordAmount: true,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          recordAmount: "Invalid Amount",
                        },
                      }));
                    } else if (
                      value >
                      Number(total) + Number(data.adjustments)
                    ) {
                      setData((prev) => ({
                        ...prev,
                        recordAmount: value,
                        errorStatus: {
                          ...prev.errorStatus,
                          recordAmount: true,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          recordAmount:
                            "Amount should be less than Grand Total.",
                        },
                      }));
                    } else {
                      setData((prev) => ({
                        ...prev,
                        recordAmount: value,
                        errorStatus: {
                          ...prev.errorStatus,
                          recordAmount: false,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          recordAmount: "",
                        },
                      }));
                    }
                  }
                } else {
                  setData((prev) => ({
                    ...prev,
                    recordAmount: value,
                    errorStatus: {
                      ...prev.errorStatus,
                      recordAmount: false,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      recordAmount: "",
                    },
                  }));
                }
              }}
              id="recordAmount"
              label="Record Amount"
              variant="outlined"
              size="small"
              fullWidth
              sx={{
                ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                  fontSize: "14px",
                },
                label: {
                  fontSize: "14px",
                },
                ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                  color: "input.font",
                },
                ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                  borderColor: "input.border",
                },
                ".css-wgai2y-MuiFormLabel-asterisk": {
                  color: "danger.main",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              {totNetAmount !== 0
                ? (data.paymentType == "Cash" || data.paymentType == "Bank") &&
                  data.recordAmount !== "" &&
                  Number(totNetAmount) +
                    Number(data.adjustments) -
                    Number(data.recordAmount) >
                    0 &&
                  data.errorStatus.recordAmount != true && (
                    <Typography
                      sx={{ flex: { xs: 1, sm: 1 }, fontSize: "14px" }}
                    >
                      <span style={{ fontWeight: 600 }}> Balance Due: </span>
                      {(
                        Number(totNetAmount) +
                        Number(data.adjustments) -
                        Number(data.recordAmount)
                      ).toFixed(2)}
                    </Typography>
                  )
                : (data.paymentType == "Cash" || data.paymentType == "Bank") &&
                  data.recordAmount !== "" &&
                  Number(totNonGstNetAmount) +
                    Number(data.adjustments) -
                    Number(data.recordAmount) >
                    0 &&
                  data.errorStatus.recordAmount != true && (
                    <Typography
                      sx={{ flex: { xs: 1, sm: 1 }, fontSize: "14px" }}
                    >
                      <span style={{ fontWeight: 600 }}> Balance Due: </span>
                      {(
                        Number(totNonGstNetAmount) +
                        Number(data.adjustments) -
                        Number(data.recordAmount)
                      ).toFixed(2)}
                    </Typography>
                  )}
              <Typography
                sx={{
                  marginTop: "2px",
                  marginLeft: "10px",
                  marginBottom: "0px",
                  fontSize: "11px",
                  color: "danger.main",
                }}
              >
                {data?.errorFields.recordAmount}
              </Typography>
              <Typography
                sx={{
                  justifyContent: "flex-end",
                  color: params?.view == true ? "input.border" : "primary.main",
                  display: "flex",
                  alignItems: "center",
                  fontSize: "13px",
                  marginTop: { xs: "5px" },
                }}
              >
                Enter Denomination :
                <Typography
                  disabled={params?.view == true ? true : false}
                  color={params?.view == true ? "input.border" : "primary.main"}
                  href="#"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: params?.view == true ? "default" : "",
                  }}
                  // onClick={(event) => event.preventDefault()}
                ></Typography>
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            alignItems: { sm: "start" },
            flexWrap: { xs: "wrap", md: "nowrap" },
            flexDirection: { xs: "column", sm: "row" },
            marginBottom: "0px",
          }}
        >
          <Box sx={{ flex: { xs: 1, md: 0.5 } }}>
            <Box sx={{ flex: 1, m: 1, position: "relative" }}>
              <Typography
                sx={{
                  justifyContent: "flex-end",
                  color: "primary.main",
                  display: "flex",
                  alignItems: "center",
                  fontSize: "13px",
                  position: "absolute",
                  right: 0,
                  top: "-20px",
                }}
              >
                <Link
                  disabled={
                    (data.paymentType == "Cash" ||
                      data.paymentType == "Bank") &&
                    params?.view != true
                      ? false
                      : true
                  }
                  color={
                    params?.view != true &&
                    (data.paymentType == "Cash" || data.paymentType == "Bank")
                      ? "primary.main"
                      : "input.border"
                  }
                  href="#"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor:
                      params?.view != true &&
                      (data.paymentType == "Cash" || data.paymentType == "Bank")
                        ? ""
                        : "default",
                  }}
                  onClick={(event) => {
                    event.preventDefault();
                    setToAccountModal(true);
                  }}
                >
                  <AddIcon
                    disabled={
                      (data.paymentType == "Cash" ||
                        data.paymentType == "Bank") &&
                      params?.view != true
                        ? false
                        : true
                    }
                    fontSize="small"
                    sx={{ marginRight: "5px" }}
                  />
                  Add Account
                </Link>
              </Typography>
              <Autocomplete
                id="creditToAccount"
                disableClearable
                options={
                  paidAccountFlag == true
                    ? accName
                    : data.paymentType == "Cash"
                    ? cashAccount
                    : bankAccount
                }
                disabled={
                  (data.paymentType == "Cash" || data.paymentType == "Bank") &&
                  params?.view != true
                    ? false
                    : true
                }
                isOptionEqualToValue={(option, value) =>
                  option.value == value.value
                }
                value={data.creditToAccount}
                onChange={(e, newValue) => {
                 
                  if (
                    data.paymentType == "Cash" ||
                    data.paymentType == "Bank"
                  ) {
                    if (newValue.value === "") {
                      setPaidAccountName({ label: "", value: "" });
                      setData((prev) => ({
                        ...prev,
                        creditToAccount: newValue,
                        errorStatus: {
                          ...prev.errorStatus,
                          creditToAccount: true,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          creditToAccount:
                            "Received To Account is required",
                        },
                      }));
                    } else {
                      if (data.paymentType === "Cash")

                      cashAccount.map((item) => {
                        if (item.value === newValue.value)
                          setPaidAccountName({
                            label: item.label,
                            value: item.value,
                          });
                      });
                      if (data.paymentType === "Bank")
                        bankAccount.map((item) => {
                          if (item.value === newValue.value)
                            setPaidAccountName({
                              label: item.label,
                              value: item.value,
                            });
                        });

                      setData((prev) => ({
                        ...prev,
                        creditToAccount: newValue,
                        errorStatus: {
                          ...prev.errorStatus,
                          creditToAccount: false,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          creditToAccount: "",
                        },
                      }));
                    }
                  } else {
                    setPaidAccountName({ label: "", value: "" });
                    setData((prev) => ({
                      ...prev,
                      creditToAccount: newValue,
                      errorStatus: {
                        ...prev.errorStatus,
                        creditToAccount: false,
                      },
                      errorFields: {
                        ...prev.errorFields,
                        creditToAccount: "",
                      },
                    }));
                  }
                }}
                sx={{
                  ".css-1kxbtff-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                    {
                      paddingBottom: "5px",
                    },
                  ".css-lcu7oo-MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall":
                    {
                      paddingTop: "6px",
                      paddingBottom: "5px",
                      paddingLeft: "6px",
                    },
                }}
                size="small"
                renderInput={(params) => (
                  <TextField
                    required={
                      data.paymentType == "Cash" || data.paymentType == "Bank"
                        ? true
                        : false
                    }
                    error={
                      data.errorStatus.creditToAccount === true ? true : false
                    }
                    sx={{
                      ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input":
                        {
                          padding: "8.5px 7px",
                        },
                      ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                        fontSize: "14px",
                      },
                      label: {
                        fontSize: "14px",
                      },
                      ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root": {
                        fontSize: "14px",
                      },
                      ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                        color: "input.font",
                      },
                      ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                        borderColor: "input.border",
                      },
                      ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root": {
                        color: "input.font",
                      },
                      ".css-14qz1ij-MuiListItemText-root": {
                        margin: "0px",
                      },
                      ".css-wgai2y-MuiFormLabel-asterisk": {
                        color: "danger.main",
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    {...params}
                    label="Received To Account (Cr)"
                  />
                )}
              />
              <Typography
                sx={{
                  marginTop: "2px",
                  marginLeft: "10px",
                  marginBottom: "0px",
                  fontSize: "11px",
                  color: "danger.main",
                }}
              >
                {data?.errorFields.creditToAccount}
              </Typography>
              <Typography
                sx={{
                  justifyContent: "flex-start",
                  color: "primary.main",
                  display: "flex",
                  alignItems: "center",
                  fontSize: "5px",
                  marginTop: { xs: "1px" },
                }}
              >
                <FormControlLabel
                  disabled={
                    (data.paymentType == "Cash" ||
                      data.paymentType == "Bank") &&
                    params?.view != true
                      ? false
                      : true
                  }
                  checked={paidAccountFlag}
                  control={<Checkbox />}
                  label="Show All Accounts"
                  onChange={(e) => {
                    e.target.checked
                      ? setPaidAccountFlag(true)
                      : setPaidAccountFlag(false);
                  }}
                />
              </Typography>
            </Box>
          </Box>
          <Box sx={{ flex: { xs: 1, md: 0.5 } }}>
            <Box
              sx={{
                flex: { xs: 1, sm: 1 },
                m: 1,
                display: "flex",
                alignItems: { xs: "flex-start", sm: "center" },
                flexDirection: {
                  xs: "column",
                  sm: "row",
                },
              }}
            >
              <Typography
                sx={{
                  fontSize: "13px",
                  marginLeft: "15px",
                  marginRight: { xs: 1, sm: 0, md: 2 },
                  marginBottom: { xs: "10px", md: "0px" },
                  color: "input.label",
                }}
              >
                Adjustments, if any (+/-)
              </Typography>
              <Box sx={{ flex: { xs: 1, sm: 1 } }}>
                <TextField
                  error={data.errorStatus.adjustments == true ? true : false}
                  label="Amount"
                  id="adjustments"
                  type="number"
                  disabled={
                    params?.view == true ||
                    supplierNameEnabled ||
                    params?.view == true
                      ? true
                      : false
                  }
                  value={data.adjustments}
                  onChange={(e) => {
                    let total =
                      data.gstApplicable == "1"
                        ? Number(totNetAmount) + Number(data.adjustments)
                        : Number(totNonGstNetAmount) + Number(data.adjustments);
                    const value = e.target.value;
                    if (value == "") {
                      setData((prev) => ({
                        ...prev,
                        adjustments: value,
                        errorStatus: {
                          ...prev.errorStatus,
                          adjustments: false,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          adjustments: "",
                        },
                      }));
                    } else if (total < 0) {
                      setData((prev) => ({
                        ...prev,
                        adjustments: value,
                        errorStatus: {
                          ...prev.errorStatus,
                          adjustments: true,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          adjustments:
                            "Grand Total should not be -ve please adjust the amount correctly",
                        },
                      }));
                    } else {
                      if (
                        !new RegExp(
                          /^[+-]?(?=.+)(?:[1-9]\d*|0)?(?:\.\d+)?$/
                        ).test(value)
                      ) {
                        setData((prev) => ({
                          ...prev,
                          adjustments: value,
                          errorStatus: {
                            ...prev.errorStatus,
                            adjustments: true,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            adjustments: "Inavid Amount",
                          },
                        }));
                      } else {
                        setData((prev) => ({
                          ...prev,
                          adjustments: value,
                          errorStatus: {
                            ...prev.errorStatus,
                            adjustments: false,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            adjustments: "",
                          },
                        }));
                      }
                    }
                  }}
                  fullWidth
                  size="small"
                  sx={{
                    ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                      fontSize: "14px",
                    },
                    label: {
                      fontSize: "14px",
                    },
                    ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                      color: "input.font",
                    },
                    ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      borderColor: "input.border",
                    },
                    ".css-wgai2y-MuiFormLabel-asterisk": {
                      color: "danger.main",
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">₹</InputAdornment>
                    ),
                  }}
                />
                <Typography
                  sx={{
                    marginTop: "2px",
                    marginLeft: "10px",
                    marginBottom: "0px",
                    fontSize: "11px",
                    color: "danger.main",
                  }}
                >
                  {data?.errorFields.adjustments}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: { sm: "start", md: "flex-start" },
            flexWrap: { xs: "wrap", md: "nowrap" },
            flexDirection: { xs: "column", sm: "row" },
            marginBottom: "0px",
          }}
        >
          <Box sx={{ flex: { xs: 1, md: 0.5 } }}>
            {data.paymentType == "Bank" ? (
              <Box sx={{ flex: 1, m: 1 }}>
                <TextField
                  error={data.errorStatus.bankRefNo == true ? true : false}
                  value={data.bankRefNo}
                  disabled={
                    data.paymentType == "Bank" || params?.view == true
                      ? false
                      : true
                  }
                  required={true}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (data.paymentType == "Bank") {
                      if (value == "") {
                        setData((prev) => ({
                          ...prev,
                          bankRefNo: value,
                          errorStatus: {
                            ...prev.errorStatus,
                            bankRefNo: true,
                          },
                          errorFields: {
                            ...prev.errorFields,
                            bankRefNo: "Bank Reference Number is required",
                          },
                        }));
                      } else {
                        if (!new RegExp(/^\d{9,18}$/).test(value)) {
                          setData((prev) => ({
                            ...prev,
                            bankRefNo: value,
                            errorStatus: {
                              ...prev.errorStatus,
                              bankRefNo: true,
                            },
                            errorFields: {
                              ...prev.errorFields,
                              bankRefNo: "Invalid Bank Reference Number",
                            },
                          }));
                        } else {
                          setData((prev) => ({
                            ...prev,
                            bankRefNo: value,
                            errorStatus: {
                              ...prev.errorStatus,
                              bankRefNo: false,
                            },
                            errorFields: {
                              ...prev.errorFields,
                              bankRefNo: "",
                            },
                          }));
                        }
                      }
                    } else {
                      setData((prev) => ({
                        ...prev,
                        recordAmount: value,
                        errorStatus: {
                          ...prev.errorStatus,
                          recordAmount: false,
                        },
                        errorFields: {
                          ...prev.errorFields,
                          recordAmount: "",
                        },
                      }));
                    }
                  }}
                  id="bankRefNo"
                  label="Bank Reference Number"
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={{
                    ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                      fontSize: "14px",
                    },
                    label: {
                      fontSize: "14px",
                    },
                    ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                      color: "input.font",
                    },
                    ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      borderColor: "input.border",
                    },
                    ".css-wgai2y-MuiFormLabel-asterisk": {
                      color: "danger.main",
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <Typography
                  sx={{
                    marginTop: "2px",
                    marginLeft: "10px",
                    marginBottom: "0px",
                    fontSize: "11px",
                    color: "danger.main",
                  }}
                >
                  {data?.errorFields.bankRefNo}
                </Typography>
              </Box>
            ) : (
              <Box sx={{ flex: 1, m: 1 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ xs: 0.3, sm: 1 }}>
                    <Typography
                      sx={{
                        borderRadius: "4px",
                        paddingLeft: "8px",
                        paddingRight: "8px",
                        backgroundColor: "white",
                        top: "-8px",
                        right: "8px",
                        color: "#808080",
                        textTransform: "capitalize",
                        fontSize: "15px",
                        fontWeight: "normal",
                      }}
                      id="creditPeriodSlider"
                    >
                      Credit Period (In Days)
                      {data.paymentType == "Credit" ? (
                        <sup
                          style={{
                            color: "red",
                            position: "relative",
                            top: "3px",
                            left: "3px",
                            fontSize: "10px",
                          }}
                        >
                          *
                        </sup>
                      ) : (
                        ""
                      )}
                      {""} -
                    </Typography>
                  </Box>
                  <Box sx={{ xs: 0.3, sm: 1 }}>
                    <TextField
                      size="small"
                      type="number"
                      name="creditPeriod"
                      value={data.creditPeriod}
                      disabled={
                        data.paymentType == "Credit" && params?.view != true
                          ? false
                          : true
                      }
                      onChange={(e) => {
                        if (e.target.value > 1000 || e.target.value < 0) {
                          let dudt = "";

                          dudt = moment(data.creditNoteDate).add(
                            creditPeriod,
                            "days"
                          );

                          let duedate = moment(dudt._d).format("DD MMM YYYY");

                          setData((prev) => ({
                            ...prev,
                            creditPeriod: e.target.value,
                            dueDate: duedate,
                            ["errorStatus"]: {
                              ...prev.errorStatus,
                              creditPeriod: true,
                            },
                            ["errorFields"]: {
                              ...prev.errorFields,
                              creditPeriod:
                                "Credit period should between 0 and 1000",
                            },
                          }));
                        } else {
                          let dudt = "";

                          dudt = moment(data.creditNoteDate).add(
                            e.target.value,
                            "days"
                          );

                          let duedate = moment(dudt._d).format("DD MMM YYYY");
                          setData((prev) => ({
                            ...prev,
                            creditPeriod: e.target.value,
                            dueDate: duedate,
                            ["errorStatus"]: {
                              ...prev.errorStatus,
                              creditPeriod: false,
                            },
                            ["errorFields"]: {
                              ...prev.errorFields,
                              creditPeriod: "",
                            },
                          }));
                        }
                      }}
                      label=""
                      required={data.partyType == "Credit" ? true : false}
                      InputProps={{
                        inputProps: {
                          min: 0,
                        },
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      sx={{
                        width: "125px",
                      }}
                    ></TextField>
                  </Box>
                  <Box sx={{ flex: { xs: 0.3, sm: 1 } }}></Box>
                </Box>
                <Box sx={{ flex: { xs: 0.3, sm: 1 }, m: 1 }}>
                  <Slider
                    state={data}
                    style={{ width: 300 }}
                    valueLabelDisplay="auto"
                    disabled={
                      data.paymentType == "Credit" && params?.view != true
                        ? false
                        : true
                    }
                    value={data.creditPeriod}
                    aria-labelledby="creditPeriodSlider"
                    step={1}
                    marks
                    min={0}
                    max={1000}
                    name="CreditPeriod"
                    // onChange={handleChange}
                    onChange={(e) => {
                      if (e.target.value > 1000 || e.target.value < 0) {
                        let dudt = "";

                        dudt = moment(data.creditNoteDate).add(
                          creditPeriod,
                          "days"
                        );

                        let duedate = moment(dudt._d).format("DD MMM YYYY");

                        setData((prev) => ({
                          ...prev,
                          creditPeriod: e.target.value,
                          dueDate: duedate,
                          ["errorStatus"]: {
                            ...prev.errorStatus,
                            creditPeriod: true,
                          },
                          ["errorFields"]: {
                            ...prev.errorFields,
                            creditPeriod:
                              "Credit period should between 0 and 1000",
                          },
                        }));
                      } else {
                        let dudt = "";

                        dudt = moment(data.creditNoteDate).add(
                          e.target.value,
                          "days"
                        );

                        let duedate = moment(dudt._d).format("DD MMM YYYY");
                        setData((prev) => ({
                          ...prev,
                          creditPeriod: e.target.value,
                          dueDate: duedate,
                          ["errorStatus"]: {
                            ...prev.errorStatus,
                            creditPeriod: false,
                          },
                          ["errorFields"]: {
                            ...prev.errorFields,
                            creditPeriod: "",
                          },
                        }));
                      }
                    }}
                  />
                </Box>
                <Typography
                  sx={{
                    marginTop: "2px",
                    marginLeft: "10px",
                    marginBottom: "0px",
                    fontSize: "11px",
                    color: "danger.main",
                  }}
                >
                  {data?.errorFields.creditPeriod}
                </Typography>
              </Box>
            )}
          </Box>
          <Box sx={{ flex: { xs: 1, md: 0.5 } }}>
            <Box sx={{ flex: 1, m: 1 }}>
              {data?.paymentType === "Credit" && (
                <Typography
                  sx={{
                    flex: { xs: 1, sm: 1 },
                    fontSize: "14px",
                    color: "input.font",
                    ml: "10px",
                    marginTop:
                      data.paymentType == "Credit" ||
                      data.paymentType == "Cash" ||
                      data.paymentType == ""
                        ? { xs: "0px", sm: "40px" }
                        : { xs: "0px", sm: "10px" },
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Due Date: </span>{" "}
                  {data.dueDate}
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
      </Box> */}
      {/* <Box
        sx={{
          marginTop: "20px",
          padding: { xs: "10px 0px", sm: "10px 10px" },
          borderRadius: "12px",
          backgroundColor: "#fff",
          boxShadow:
            "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
          ":hover": {
            boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
          },
          transition: "all 1s ease-in-out",
        }}
      >
        <Box sx={{ ml: "6px" }}>
          <Typography sx={{ fontSize: "15px", fontWeight: "bold" }}>
            Dispatch Details :
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexWrap: { xs: "wrap", md: "nowrap" },
            flexDirection: { xs: "column", sm: "row" },
            marginTop: "20px",
          }}
        >
          <Box sx={{ flex: { xs: 1, md: 0.5 } }}>
            <Box
              sx={{
                m: 1,
                flex: 1,
              }}
            >
              <TextField
                select
                error={
                  data.errorStatus.transpotationMode == true ? true : false
                }
                value={data.transpotationMode}
                disabled={
                  data.partyName.value == "" || params?.view == true
                    ? true
                    : false
                }
                onChange={(e) => {
                  const value = e.target.value;
                  setData((prev) => ({
                    ...prev,
                    transpotationMode: value,
                    errorStatus: {
                      ...prev.errorStatus,
                      transpotationMode: false,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      transpotationMode: "",
                    },
                  }));
                }}
                id="transpotationMode"
                label="Transportation Mode (Cr)"
                variant="outlined"
                size="small"
                fullWidth
                sx={{
                  ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                    fontSize: "14px",
                  },
                  label: {
                    fontSize: "14px",
                  },
                  ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                    color: "input.font",
                  },
                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    borderColor: "input.border",
                  },
                  ".css-wgai2y-MuiFormLabel-asterisk": {
                    color: "danger.main",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              >
                {[
                  { option: "Railways", value: "Railways" },
                  { option: "Air", value: "Air" },
                  { option: "Road", value: "Road" },
                  { option: "Ship", value: "Ship" },
                ].map((item, ind) => {
                  return (
                    <MenuItem key={item.value} value={`${item.value}`}>
                      <ListItemText
                        sx={{ margin: "0px" }}
                        primary={item.option}
                      />
                    </MenuItem>
                  );
                })}
              </TextField>
            </Box>
          </Box>

          <Box sx={{ flex: { xs: 1, md: 0.5 } }}>
            <Box
              sx={{
                m: 1,
                flex: 1,
              }}
            >
              <TextField
                error={data.errorStatus.vehicleNumber == true ? true : false}
                value={data.vehicleNumber}
                disabled={
                  data.partyName.value == "" || params?.view == true
                    ? true
                    : false
                }
                onChange={(e) => {
                  const value = e.target.value;
                  setData((prev) => ({
                    ...prev,
                    vehicleNumber: value,
                    errorStatus: {
                      ...prev.errorStatus,
                      vehicleNumber: false,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      vehicleNumber: "",
                    },
                  }));
                }}
                id="vehicleNUmber"
                label="Vehicle Number"
                variant="outlined"
                size="small"
                fullWidth
                sx={{
                  ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                    fontSize: "14px",
                  },
                  label: {
                    fontSize: "14px",
                  },
                  ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                    color: "input.font",
                  },
                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    borderColor: "input.border",
                  },
                  ".css-wgai2y-MuiFormLabel-asterisk": {
                    color: "danger.main",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexWrap: { xs: "wrap", md: "nowrap" },
            flexDirection: { xs: "column", sm: "row" },
            marginBottom: "0px",
          }}
        >
          <Box sx={{ flex: { xs: 1, md: 0.5 } }}>
            <Box
              sx={{
                m: 1,
                flex: 1,
              }}
            >
              <TextField
                error={data.errorStatus.dateOfDispatch == true ? true : false}
                value={data.dateOfDispatch}
                disabled={
                  data.partyName.value == "" || params?.view == true
                    ? true
                    : false
                }
                onChange={(e) => {
                  const value = e.target.value;

                  setData((prev) => ({
                    ...prev,
                    dateOfDispatch: value,
                    errorStatus: {
                      ...prev.errorStatus,
                      dateOfDispatch: false,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      dateOfDispatch: "",
                    },
                  }));
                }}
                type="date"
                id="dateofDispatch"
                label="Date of Dispatch"
                variant="outlined"
                size="small"
                fullWidth
                sx={{
                  ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                    fontSize: "14px",
                  },
                  label: {
                    fontSize: "14px",
                  },
                  ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                    color: "input.font",
                  },
                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    borderColor: "input.border",
                  },
                  ".css-wgai2y-MuiFormLabel-asterisk": {
                    color: "danger.main",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
          </Box>
          <Box sx={{ flex: { xs: 1, md: 0.5 } }}>
            <Box
              sx={{
                m: 1,
                flex: 1,
              }}
            >
              <TextField
                error={data.errorStatus.eWayBill == true ? true : false}
                value={data.eWayBill}
                disabled={
                  data.partyName.value == "" || params?.view == true
                    ? true
                    : false
                }
                onChange={(e) => {
                  const value = e.target.value;
                  setData((prev) => ({
                    ...prev,
                    eWayBill: value,
                    errorStatus: {
                      ...prev.errorStatus,
                      eWayBill: false,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      eWayBill: "",
                    },
                  }));
                }}
                id="eWayBill"
                label="eWay Bill No"
                variant="outlined"
                size="small"
                fullWidth
                sx={{
                  ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                    fontSize: "14px",
                  },
                  label: {
                    fontSize: "14px",
                  },
                  ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                    color: "input.font",
                  },
                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    borderColor: "input.border",
                  },
                  ".css-wgai2y-MuiFormLabel-asterisk": {
                    color: "danger.main",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box> */}

      <Box
        sx={{
          marginTop: "20px",
          padding: { xs: "10px 0px", sm: "10px 10px" },
          borderRadius: "12px",
          backgroundColor: "#fff",
          boxShadow:
            "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
          ":hover": {
            boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
          },
          transition: "all 1s ease-in-out",
        }}
      >
        <Box sx={{ ml: "6px" }}>
          <Typography sx={{ fontSize: "15px", fontWeight: "bold" }}>
            Recurring Invoice Details :
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexWrap: { xs: "wrap", md: "nowrap" },
            flexDirection: { xs: "column", sm: "row" },
            marginTop: "20px",
          }}
        >
          <Box sx={{ flex: { xs: 1, md: 0.5 } }}>
            <Box
              sx={{
                m: 1,
                flex: 1,
              }}
            >
              <TextField
                error={data.errorStatus.invoiceStartDate == true ? true : false}
                value={data.invoiceStartDate}
                disabled={
                  data.partyName.value == "" || params?.view == true
                    ? true
                    : false
                }
                onChange={(e) => {
                  const value = e.target.value;

                  setData((prev) => ({
                    ...prev,
                    invoiceStartDate: value,
                    errorStatus: {
                      ...prev.errorStatus,
                      invoiceStartDate: false,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      invoiceStartDate: "",
                    },
                  }));
                }}
                type="date"
                id="invoiceStartDate"
                label="Start Date"
                variant="outlined"
                size="small"
                fullWidth
                sx={{
                  ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                    fontSize: "14px",
                  },
                  label: {
                    fontSize: "14px",
                  },
                  ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                    color: "input.font",
                  },
                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    borderColor: "input.border",
                  },
                  ".css-wgai2y-MuiFormLabel-asterisk": {
                    color: "danger.main",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
          </Box>

          <Box sx={{ flex: { xs: 1, md: 0.5 } }}>
            <Box
              sx={{
                m: 1,
                flex: 1,
              }}
            >
              <TextField
                error={data.errorStatus.invoiceEndDate == true ? true : false}
                value={data.invoiceEndDate}
                disabled={
                  data.partyName.value == "" || params?.view == true
                    ? true
                    : false
                }
                onChange={(e) => {
                  const value = e.target.value;

                  setData((prev) => ({
                    ...prev,
                    invoiceEndDate: value,
                    errorStatus: {
                      ...prev.errorStatus,
                      invoiceEndDate: false,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      invoiceEndDate: "",
                    },
                  }));
                }}
                type="date"
                id="invoiceEndDate"
                label="End Date"
                variant="outlined"
                size="small"
                fullWidth
                sx={{
                  ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                    fontSize: "14px",
                  },
                  label: {
                    fontSize: "14px",
                  },
                  ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                    color: "input.font",
                  },
                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    borderColor: "input.border",
                  },
                  ".css-wgai2y-MuiFormLabel-asterisk": {
                    color: "danger.main",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexWrap: { xs: "wrap", md: "nowrap" },
            flexDirection: { xs: "column", sm: "row" },
            marginBottom: "0px",
          }}
        >
          <Box sx={{ flex: { xs: 1, md: 0.5 } }}>
            <Box
              sx={{
                m: 1,
                flex: 1,
              }}
            >
              <TextField
                error={data.errorStatus.periodicity == true ? true : false}
                value={data.periodicity}
                disabled={
                  data.partyName.value == "" || params?.view == true
                    ? true
                    : false
                }
                onChange={(e) => {
                  const value = e.target.value;

                  setData((prev) => ({
                    ...prev,
                    periodicity: value,
                    errorStatus: {
                      ...prev.errorStatus,
                      periodicity: false,
                    },
                    errorFields: {
                      ...prev.errorFields,
                      periodicity: "",
                    },
                  }));
                }}
                type="date"
                id="periodicity"
                label="Periodicity"
                variant="outlined"
                size="small"
                fullWidth
                sx={{
                  ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                    fontSize: "14px",
                  },
                  label: {
                    fontSize: "14px",
                  },
                  ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                    color: "input.font",
                  },
                  ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    borderColor: "input.border",
                  },
                  ".css-wgai2y-MuiFormLabel-asterisk": {
                    color: "danger.main",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
          </Box>
          <Box sx={{ flex: { xs: 1, md: 0.5 } }}>
            <Box
              sx={{
                m: 1,
                flex: 1,
              }}
            ></Box>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          marginTop: "20px",
          padding: { xs: "20px 0px", sm: "20px 10px" },
          borderRadius: "12px",
          backgroundColor: "#fff",
          boxShadow:
            "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
          ":hover": {
            boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
          },
          transition: "all 1s ease-in-out",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexWrap: { xs: "wrap", md: "nowrap" },
            flexDirection: { xs: "column", sm: "row" },
            marginBottom: "0px",
          }}
        >
          {/* <Box sx={{ flex: { xs: 1, md: 0.5 } }}> */}
          <Box
            sx={{
              flex: 1,
              m: 1,
            }}
          >
            <TeaxtareaField
              error={data.errorStatus.remarks === true ? true : false}
              name="remarks"
              placeholder="Comments / Remarks"
              size="small"
              disable={
                data.partyName.value == "" || params?.view == true
                  ? true
                  : false
              }
              fullWidth
              state={data}
              value={data.remarks}
              onChange={(e) => {
                const name = e.target.name;
                const value = e.target.value;
                if (value.length > 150) {
                  setData((prev) => ({
                    ...prev,
                    ["remarks"]: value,
                    ["errorStatus"]: {
                      ...prev.errorStatus,
                      ["remarks"]: true,
                    },
                    ["errorFields"]: {
                      ...prev.errorFields,
                      ["remarks"]:
                        "Comments/Remarks should be less than 150 characters",
                    },
                  }));
                } else {
                  setData((prev) => ({
                    ...prev,
                    ["remarks"]: value,
                    ["errorStatus"]: {
                      ...prev.errorStatus,
                      ["remarks"]: false,
                    },
                    ["errorFields"]: {
                      ...prev.errorFields,
                      ["remarks"]: "",
                    },
                  }));
                }
              }}
              rows={3}
            />
            {/* </Box> */}
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexWrap: { xs: "wrap", md: "nowrap" },
            flexDirection: { xs: "column", sm: "row" },
            marginBottom: "0px",
          }}
        >
          <Box sx={{ flex: { xs: 1, sm: 0.5 } }}>
            <Box
              sx={{
                flex: 1,
                m: 1,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: { sm: "flex-start" },
                  // alignItems:'center',
                  padding: "8px",
                  minHeight: "155px",
                  borderRadius: "4px",
                  backgroundColor: "#a0a1a11a",
                  position: "relative",
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
              >
                <Typography
                  sx={{
                    borderRadius: "4px",
                    paddingLeft: "8px",
                    paddingRight: "8px",
                    backgroundColor: "white",
                    position: "absolute",
                    top: "-8px",
                    right: "8px",
                    color: "#808080",
                    textTransform: "capitalize",
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >
                  Journal entries
                </Typography>
                {data.partyName.value != "" && (
                  <div dangerouslySetInnerHTML={{ __html: journalHTML }} />
                )}
              </Box>
            </Box>
          </Box>
          <Box sx={{ flex: { xs: 1, sm: 0.5 } }}>
            <TableContainer
              sx={{
                scrollbarWidth: "thin",
                ".MuiTableCell-body": {
                  padding: "12px 10px",
                },
                ".MuiTableCell-head": {
                  backgroundColor: "background.tablebg",
                  padding: "10px 8px",
                  borderBottom: "0px",
                  fontSize: "13px",
                  fontWeight: "bold",
                },
                ".MuiTableCell-head:first-of-type": {
                  borderTopLeftRadius: "6px",
                  borderBottomLeftRadius: "6px",
                },
                ".MuiTableCell-head:last-child": {
                  borderTopRightRadius: "6px",
                  borderBottomRightRadius: "6px",
                },
                "&::-webkit-scrollbar": {
                  width: "0.4em",
                  height: "0.4em",
                },
                "&::-webkit-scrollbar-track": {
                  background: `${theme.palette.primary.main}47`,
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "primary.main",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: `${theme.palette.primary.main}47`,
                },
              }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    {headCell2.map((column) => {
                      if (params?.view != true) {
                        return (
                          <TableCell key={column.id}>{column.label}</TableCell>
                        );
                      } else {
                        return (
                          column.label != "Action" && (
                            <TableCell key={column.id}>
                              {column.label}
                            </TableCell>
                          )
                        );
                      }
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {itemsRows.map((column, index) => {
                    return (
                      <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                        <TableCell>
                          <TextField
                            name="credit"
                            label="File Name"
                            variant="outlined"
                            size="small"
                            disabled={
                              data.partyName.value == "" || params?.view == true
                                ? true
                                : false
                            }
                            value={column?.name}
                            fullWidth
                            onChange={(e) => {
                              const value = e.target.value;
                              let arr = [...itemsRows];
                              arr[index].name = value;
                              setItemsRows(arr);
                            }}
                            sx={{
                              maxWidth: "150px",
                              ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root":
                                {
                                  fontSize: "14px",
                                },
                              label: {
                                fontSize: "14px",
                              },
                              ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root":
                                {
                                  color: "input.font",
                                },
                              ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                                borderColor: "input.border",
                              },
                              ".css-wgai2y-MuiFormLabel-asterisk": {
                                color: "danger.main",
                              },
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          {column.url !== "" ? (
                            <Box
                              sx={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Box
                                sx={{
                                  textTransform: "none",
                                  width: {
                                    xs: "100px",
                                    sm: "200px",
                                    lg: "200px",
                                  },
                                  //height:{xs:'70px',md:'170px'},
                                  border: "1px dashed",
                                  borderColor: "input.border",
                                  position: "relative",
                                  color: "input.font",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  padding: "5px 0px",
                                }}
                              >
                                <img
                                  style={{ width: "50px", height: "50px" }}
                                  src={column.url}
                                />
                              </Box>
                            </Box>
                          ) : (
                            <Button
                              disabled={params?.view == true ? true : false}
                              size="small"
                              variant="outlined"
                              component="label"
                              sx={{
                                flex: { xs: 1 },
                                textTransform: "none",
                                width: {
                                  xs: "100px",
                                  sm: "200px",
                                  lg: "200px",
                                },
                                border: "1px dashed #e2e4ee",
                                position: "relative",
                                color: "#a0a1a1c7",
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <AddPhotoAlternate
                                fontSize="large"
                                sx={{
                                  marginRight: "5px",
                                  color: "#a0a1a1c7",
                                  fontSize: "20px",
                                }}
                              />
                              <Typography fontSize="10px" color={"#a0a1a1c7"}>
                                Add File
                              </Typography>
                              <input
                                disabled={
                                  data.partyName.value == "" ||
                                  params?.view == true
                                    ? true
                                    : false
                                }
                                hidden
                                // accept="image/*"
                                multiple
                                type="file"
                                onChange={(e) => {
                                  importFile(e, index);
                                }}
                              />
                            </Button>
                          )}
                        </TableCell>
                        {params?.view !== true && (
                          <TableCell>
                            <IconButton
                              aria-label="delete"
                              disabled={
                                data.partyName.value == "" ||
                                params?.view == true
                                  ? true
                                  : false
                              }
                              sx={{
                                margin: "0px 2px",
                                padding: "5px",
                                backgroundColor: "#fbc7c78c",
                              }}
                              onClick={() => {
                                let arr = [...itemsRows];
                                let newArray = arr.filter((ele, ind) => {
                                  if (ind !== index) {
                                    return ele;
                                  }
                                });

                                setItemsRows(newArray);
                              }}
                            >
                              <DeleteIcon
                                sx={{ fontSize: "15px", color: "#eb6a6a" }}
                              />
                            </IconButton>
                          </TableCell>
                        )}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>

            <Box>
              <Button
                disableElevation
                disableRipple
                size="small"
                variant="text"
                disabled={
                  data.partyName.value == "" || params?.view == true
                    ? true
                    : false
                }
                onClick={() => NewRowFile()}
                startIcon={<AddBox />}
                sx={{
                  fontSize: "14px",
                  marginTop: "15px",
                }}
              >
                Add New Line
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          marginTop: "20px",
          padding: { xs: "20px 0px", sm: "20px 10px" },
          borderRadius: "12px",
          backgroundColor: "#fff",
          boxShadow:
            "rgba(27, 31, 35, 0.04) 0px 1px 0px, rgba(255, 255, 255, 0.25) 0px 1px 0px inset",
          ":hover": {
            boxShadow: "rgba(33, 35, 38, 0.1) 0px 10px 10px -10px",
          },
          transition: "all 1s ease-in-out",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexWrap: { xs: "wrap", md: "nowrap" },
            flexDirection: { xs: "column", sm: "row" },
            marginBottom: "30px",
            position: "relative",
          }}
        >
          <Box
            sx={{
              flex: 1,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", m: 1 }}>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 600,
                  marginBottom: "15px",
                  color: "rgba(0,0,0,0.6)",
                }}
              >
                Billing Address
              </Typography>
              <Button
                disableRipple
                disableElevation
                size="small"
                variant="text"
                disabled={
                  params?.view == true || data.billingAddress == ""
                    ? true
                    : false
                }
                onClick={() => {
                  if (data.partyName.value !== "") {
                    setBillingAddressModal(true);
                  }
                }}
                startIcon={<Edit />}
                sx={{
                  fontSize: "14px",
                  marginBottom: "10px",
                }}
              ></Button>
            </Box>
            {data.partyName.value != "" && (
              <Box sx={{ flex: 1, m: 1 }}>
                <Typography
                  sx={{ fontSize: "14px", color: "rgba(0, 0, 0, 0.6)" }}
                >
                  {billingAddressDetails.billingAddress !== ""
                    ? billingAddressDetails.billingAddress.replace("**", ",")
                    : data.billingAddress.replace("**", ",")}
                </Typography>
                {billingAddressDetails.stateCD != "" || stateName !== "" ? (
                  <Typography
                    sx={{ fontSize: "14px", color: "rgba(0, 0, 0, 0.6)" }}
                  >
                    {billingAddressDetails.stateCD != ""
                      ? billingAddressDetails.stateCD
                      : stateName}
                    ,{countryName}
                  </Typography>
                ) : (
                  <Typography
                    sx={{ fontSize: "14px", color: "rgba(0, 0, 0, 0.6)" }}
                  >
                    {countryName}
                  </Typography>
                )}
              </Box>
            )}
          </Box>
          <Box
            sx={{
              flex: 1,
              m: 1,
              display: "flex",
            }}
          >
            <Box sx={{ flex: { xs: 1, sm: 0.5 } }}>
              <SelectField
                state={data}
                name="placeOfSupply"
                placeholder="Place of Supply"
                disable={
                  data.partyName.value == "" || params?.view == true
                    ? true
                    : false
                }
                size="small"
                required={true}
                value={data.placeOfSupply}
                options={states}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value == "") {
                    setData((prev) => ({
                      ...prev,
                      placeOfSupply: value,
                      errorStatus: {
                        ...prev.errorStatus,
                        placeOfSupply: true,
                      },
                      errorFields: {
                        ...prev.errorFields,
                        placeOfSupply: "Place Of Supply is required",
                      },
                    }));
                  } else {
                    setData((prev) => ({
                      ...prev,
                      placeOfSupply: value,
                      errorStatus: {
                        ...prev.errorStatus,
                        placeOfSupply: false,
                      },
                      errorFields: {
                        ...prev.errorFields,
                        placeOfSupply: "",
                      },
                    }));
                  }
                }}
              ></SelectField>
            </Box>
          </Box>
        </Box>

        <Box>
          <Box sx={{ display: "flex", alignItems: "center", m: 1 }}>
            <Typography
              sx={{
                fontSize: "14px",
                color: "rgba(0,0,0,0.6)",
                fontWeight: 600,
              }}
            >
              Delivery Address
            </Typography>
            <Button
              disableRipple
              disableElevation
              size="small"
              variant="text"
              disabled={
                params?.view == true || data.deliveryAddress == ""
                  ? true
                  : false
              }
              onClick={() => {
                if (data.partyName.value !== "") {
                  setChangeAddressModal(true);
                }
              }}
              startIcon={<Edit />}
              sx={{
                fontSize: "14px",
                marginBottom: "0px",
              }}
            ></Button>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: { sm: "center" },
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            {data.partyName.value != "" && (
              <Box sx={{ flex: 1, m: 1 }}>
                <Typography
                  sx={{ fontSize: "14px", color: "rgba(0, 0, 0, 0.6)" }}
                >
                  {deliveryAddressDetails.deliveryAddress !== ""
                    ? deliveryAddressDetails.deliveryAddress.replace("**", ",")
                    : data.deliveryAddress.replace("**", ",")}
                </Typography>
                {deliveryAddressDetails.stateCD != "" || stateDelName !== "" ? (
                  <Typography
                    sx={{ fontSize: "14px", color: "rgba(0, 0, 0, 0.6)" }}
                  >
                    {deliveryAddressDetails.stateCD != ""
                      ? deliveryAddressDetails.stateCD
                      : stateDelName}
                    ,{countryDelName}
                  </Typography>
                ) : (
                  <Typography
                    sx={{ fontSize: "14px", color: "rgba(0, 0, 0, 0.6)" }}
                  >
                    {countryDelName}
                  </Typography>
                )}
              </Box>
            )}
          </Box>
        </Box>
      </Box>
      {params?.id && params?.view !== true ? (
        <Box
          sx={{
            marginTop: "10px",
            position: "sticky",
            paddingTop: "30px",
            width: "100%",
            display: "flex",
            justifyContent: { xs: "space-around", sm: "end" },
            flexWrap: "wrap",
            flexDirection: { xs: "column", sm: "row" },
          }}
        >
          <Button
            variant="outlined"
            disableElevation
            disableRipple
            sx={{
              fontSize: "12px",
              marginBottom: "15px",
              marginLeft: { xs: "0px", sm: "20px", backgroundColor: "#" },
            }}
            onClick={() => {
              setCancelModal(true);
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => handlePrint(CrDrId)}
            variant="outlined"
            startIcon={<LocalPrintshop />}
            disableElevation
            disableRipple
            sx={{
              fontSize: "12px",
              marginBottom: "15px",
              marginLeft: { xs: "0px", sm: "20px" },
            }}
          >
            Print
          </Button>
          <Button
            variant="contained"
            disableElevation
            disableRipple
            sx={{
              fontSize: "12px",
              marginBottom: "15px",
              marginLeft: { xs: "0px", sm: "20px" },
            }}
            onClick={saveEditChanges}
          >
            Save
          </Button>
        </Box>
      ) : params?.id && params?.view == true ? (
        ""
      ) : (
        <Box
          sx={{
            marginTop: "30px",
            position: ModalEvent == true ? "sticky" : "",
            bottom: 0,
            paddingTop: "10px",
            paddingBottom: "10px",
            backgroundColor: ModalEvent == true ? "#FFF" : "",
            marginRight: "10px",
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: { xs: "space-around", md: "end" },
            zIndex: 1,
          }}
        >
          <Button
            disableRipple
            disableElevation
            variant="outlined"
            sx={{
              fontSize: "12px",
              marginBottom: { xs: "20px", md: "0px" },
              marginLeft: { xs: "0px", sm: "20px" },
            }}
            onClick={() => setCancelModal(true)}
          >
            Cancel
          </Button>
          <Button
            onClick={saveChanges}
            disableRipple
            disableElevation
            disabled={params?.view == true ? true : false}
            variant="outlined"
            startIcon={<LocalPrintshop />}
            sx={{
              fontSize: "12px",
              marginBottom: { xs: "20px", md: "0px" },
              marginLeft: { xs: "0px", sm: "20px" },
            }}
          >
            Save And Print
          </Button>
          <Button
            onClick={() => {
              data.gstApplicable == "1"
                ? setPreviewGstCreditNoteModal(true)
                : setPreviewNonGstCreditNoteModal(true);
            }}
            disabled={params?.view == true ? true : false}
            disableRipple
            disableElevation
            variant="contained"
            startIcon={<Preview />}
            color="info"
            sx={{
              fontSize: "12px",
              marginBottom: { xs: "20px", md: "0px" },
              marginLeft: { xs: "0px", sm: "20px" },
            }}
          >
            Preview Invoice
          </Button>
          {ModalEvent != true && (
            <Button
              disabled={params?.view == true ? true : false}
              disableRipple
              disableElevation
              variant="outlined"
              sx={{
                fontSize: "12px",
                marginBottom: { xs: "20px", md: "0px" },
                marginLeft: { xs: "0px", sm: "20px" },
                color: "#fff",
                backgroundColor: "#2e858b",
              }}
              onClick={() => saveChanges({ print: true })}
            >
              Save
            </Button>
          )}
        </Box>
      )}

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropOpen}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        open={completeSnackbar}
        autoHideDuration={5000}
        onClose={() => {
          setCompleteSnakbar(false);
        }}
      >
        <Alert
          onClose={() => {
            setCompleteSnakbar(false);
          }}
          variant="filled"
          severity="warning"
          sx={{ width: "100%" }}
        >
          {warningMessage}
        </Alert>
      </Snackbar>

      <Snackbar
        autoHideDuration={5000}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        open={entrySnakbar}
        onClose={() => {
          setEntrySnakbar(false);
        }}
      >
        <Alert
          onClose={() => {
            setEntrySnakbar(false);
          }}
          variant="filled"
          severity="error"
          sx={{ width: "100%" }}
        >
          Purchase Entry is Required
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        open={successSnackbar}
        autoHideDuration={5000}
        onClose={() => {
          setsuccessSnakbar(false);
        }}
      >
        <Alert
          onClose={() => {
            setsuccessSnakbar(false);
          }}
          variant="filled"
          severity="success"
          sx={{ width: "100%" }}
        >
          {snakbarText}
        </Alert>
      </Snackbar>
      <PreviewGstCreditNote
        open={previewGstCreditNoteModal}
        setOpen={setPreviewGstCreditNoteModal}
        companyDetails={companyDetails}
        itemEntry={itemEntry}
        items={items}
        nonItems={nonItems}
        totAmount={totAmount}
        data={data}
        billingAddressDetails={billingAddressDetails}
        deliveryAddressDetails={deliveryAddressDetails}
        stateName={stateName}
        countryName={countryName}
        stateDelName={stateDelName}
        countryDelName={countryDelName}
        totNetAmount={totNetAmount}
        totTaxableAmount={totTaxableAmount}
        totGST={totGST}
        totGstCess={totGstCess}
        creditNoteNumber={creditNoteNumber}
        companyLogo={companyLogo}
      />
      <PreviewNonGstCreditNote
        open={previewNonGstCreditNoteModal}
        setOpen={setPreviewNonGstCreditNoteModal}
        companyDetails={companyDetails}
        itemEntry={itemEntry}
        items={items}
        nonGstItems={nonGstItems}
        totAmount={totAmount}
        data={data}
        billingAddressDetails={billingAddressDetails}
        deliveryAddressDetails={deliveryAddressDetails}
        stateName={stateName}
        countryName={countryName}
        stateDelName={stateDelName}
        countryDelName={countryDelName}
        totNetAmount={totNonGstNetAmount}
        totTaxableAmount={totTaxableAmount}
        totGST={totGST}
        totGstCess={totGstCess}
        creditNoteNumber={creditNoteNumber}
        companyLogo={companyLogo}
      />
      {/* <EditDeliveryAddress
        open={deliveryAddressModal}
        setOpen={setDeliveryAddressModal}
      />
      <EditBillingAddress
        open={billingAddressModal}
        setOpen={setBillingAddressModal}
      /> */}
      <LinktoRecipt open={linktoReciptModal} setOpen={setLinktoReciptModal} />
      <Attachments open={attachmentModal} setOpen={setAttachmentModal} />
      <EnterDenomination
        open={denominationModal}
        setOpen={setDenominationModal}
      />
      <AddUnitsModal open={unitModal} setOpen={setUnitModal} />
      <DeleteEntries
        open={deleteEntriesModal}
        setEntryRows={setItems}
        setOpen={setDeleteEntriesModal}
        setsuccessSnakbar={setsuccessSnakbar}
        setSnakbarTex={setSnakbarTex}
        entryRows={items}
        entryInd={entryIndex}
      />

      <DeleteNonItems
        open={deleteNonEntriesModal}
        setEntryRows={setNonItems}
        setOpen={setDeleteNonEntriesModal}
        setsuccessSnakbar={setsuccessSnakbar}
        setSnakbarTex={setSnakbarTex}
        entryRows={nonItems}
        entryInd={nonEntryIndex}
      />
      <DeleteNonGstEntryModal
        open={deleteNonGSTEntriesModal}
        setOpen={setDeleteNonGSTEntriesModal}
        setEntryRows={setNonGstItems}
        setsuccessSnakbar={setsuccessSnakbar}
        setSnakbarTex={setSnakbarTex}
        entryRows={nonGstItems}
        entryInd={nonGSTentryIndex}
      />
      <ConfirmCancel
        open={cancelModal}
        setOpen={setCancelModal}
        ModalCloseEvent={ModalCloseEvent}
        path="allcreditnote"
      />
      <ItemsSwitchWarning
        open={itemsWrningModal}
        setOpen={setItemsWarningModal}
        warningText={warningText}
        switchedTo={switchedTo}
        items={setItems}
        itemsEdited={setItemEditedRow}
        itemsTemp={setItemTempRow}
        setItemEntry={setItemEntry}
        nonItems={setNonItems}
        nonItemsEdited={setNonItemEditedRow}
        nonItemsTemp={setNonItemTempRow}
      />
      <GstApplicableSwitchModal
        open={gstWarningModal}
        setOpen={setGstWarningModal}
        warningText={warningText}
        setData={setData}
        gstFlag={gstFlag}
        todayDate={todayDate}
        items={setItems}
        ItemId={ItemId}
        itemsEdited={setItemEditedRow}
        itemsTemp={setItemTempRow}
        setItemEntry={setItemEntry}
        nonItems={setNonItems}
        nonItemsEdited={setNonItemEditedRow}
        nonItemsTemp={setNonItemTempRow}
        GstType={data.gstApplicable}
        nonGstItems={setNonGstItems}
        nonGstItemEditedRow={setNonGstItemEditedRow}
        nonGstItemTempRow={setNonGstItemTempRow}
      />
      <EditCreditDeliveryAddress
        open={changeAddressModal}
        setOpen={setChangeAddressModal}
        partyID={partyID}
        CrDrId={CrDrId}
        setDeliveryAddressDetails={setDeliveryAddressDetails}
        setStateArr={setStateArr}
        setDistrictArr={setDistrictArr}
        setCountryArr={setCountryArr}
        data={data}
      />
      <EditCreditBillingAddress
        open={billingAddressModal}
        setOpen={setBillingAddressModal}
        partyID={partyID}
        CrDrId={CrDrId}
        setBillingAddressDetails={setBillingAddressDetails}
        setStateArr={setStateArr}
        setDistrictArr={setDistrictArr}
        setCountryArr={setCountryArr}
        data={data}
      />
      <AddToAccount
        open={toAccountModal}
        setOpen={setToAccountModal}
        accountName={accName}
        setsuccessSnakbar={setsuccessSnakbar}
        setSnakbarText={setSnakbarTex}
        setWarningSnakbar={setWarningSnakbar}
        setWarningText={setWarningText}
      />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={backdropOpen}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
}

export default AddRecurringInvoice;
